import { jsx as u, jsxs as z, Fragment as Ot } from "react/jsx-runtime";
import * as C from "react";
import { forwardRef as ze, useState as Oe, useEffect as ct, useMemo as Mn, useRef as Do, Fragment as fa, useImperativeHandle as ma, useCallback as nn } from "react";
import { styled as K, Box as fe, Button as On, CircularProgress as pt, TextField as Fn, InputAdornment as Co, IconButton as We, Tooltip as Je, Select as ba, MenuItem as In, FormControl as ha, InputLabel as ga, FormHelperText as Vn, ToggleButtonGroup as ya, Menu as Da, MenuList as Ca, Checkbox as vo, Link as va, ListItemText as An, Autocomplete as wo, Divider as kt, ListItemIcon as wa, createFilterOptions as Ta, Accordion as xa, AccordionSummary as Pa, AccordionDetails as Sa, Avatar as ka, Snackbar as Ra, Portal as Ma, Fade as Oa, Slide as En, alpha as Fa, useTheme as Bt, Toolbar as Ia, AppBar as Va, Paper as Aa, Dialog as Ea, DialogTitle as La, Chip as $a, DialogContent as ja, DialogActions as Ba } from "@mui/material";
import { _ as b, m as Lt, d as Nt, h as Ze, r as qt, s as ve, e as Wt, v as Na, p as we, f as Te, i as qa, j as Wa, k as _a, l as rn, n as Ha, o as za, q as an, P as e, T as Re, c as Tt, u as $e, N as sn, A as Ua } from "../TablePaginationActions-BmvmVQd9.js";
import { a as vm } from "../TablePaginationActions-BmvmVQd9.js";
import { useIntl as je } from "react-intl";
import { VisibilityOffOutlined as Ya, VisibilityOutlined as Ka, Cancel as Ln, AddCircleOutlineOutlined as Ga, CloseOutlined as $n, MenuOutlined as Qa, HelpOutline as To, TodayOutlined as Za, Check as Xa } from "@mui/icons-material";
import { A as jn } from "../Alert-DbN79ENW.js";
import "cartocolor";
import { _ as ne, g as he, a as ge, D as Rt, b as _t, u as ue, c as Le, d as Ye, e as Ce, f as me, h as Se, s as xe, i as Ja, j as Ht, k as Z, l as Bn, m as Nn, n as qn, o as es, p as Wn, q as ke, t as _e, v as _n, w as ts, x as os, y as ln, z as ns, A as zt, B as bo, C as rs, E as cn, F as un, G as dn, H as as, I as ss, J as is, K as Ft, L as Ve, N as ls, O as cs, P as us, Q as ds, R as ps, S as fs, T as pe, U as ms, V as bs, W as et, X as xo, Y as Po, Z as Ut, $ as xt, a0 as hs, a1 as So, a2 as ko, a3 as gs, a4 as ys, a5 as Ds, a6 as Cs, a7 as vs, a8 as ws, a9 as Ts, aa as Ro, ab as Hn, ac as xs, ad as Mt, ae as Mo, af as zn, ag as nt, ah as ut, ai as Un, aj as Xe, ak as ft, al as Ps, am as Oo, an as Yn, ao as Pt, ap as $t, aq as vt, ar as jt, as as Ss, r as Kn, at, au as ks, av as Rs, aw as Vt, ax as pn, ay as Ms, az as Os, M as Gn } from "../MenuItem-CkxKygcd.js";
import { A as Fo } from "../ArrowDown-B1AG0MlL.js";
import Yt from "@mui/material/useMediaQuery";
import { styled as _, alpha as dt, useThemeProps as le, useTheme as Qn } from "@mui/material/styles";
import mt from "@mui/material/Typography";
import { TransitionGroup as Zn, CSSTransition as Fs } from "react-transition-group";
import Kt from "@mui/material/Fade";
import Is from "@mui/material/ButtonBase";
import Io from "@mui/material/IconButton";
import Vo from "@mui/material/TextField";
import Vs from "@mui/material/InputLabel";
import As from "@mui/material/FormHelperText";
import Es, { useFormControl as Gt } from "@mui/material/FormControl";
import Xn from "@mui/material/InputAdornment";
import Ls from "@mui/material/Grow";
import $s from "@mui/material/Paper";
import js from "@mui/material/Popper";
import Bs from "@mui/material/Unstable_TrapFocus";
import wt from "@mui/material/Button";
import Ns from "@mui/material/DialogActions";
import qs from "@mui/material/List";
import Ws from "@mui/material/ListItem";
import _s from "@mui/material/Chip";
import Hs from "@mui/material/DialogContent";
import zs, { dialogClasses as fn } from "@mui/material/Dialog";
import Jn from "@mui/material/Divider";
import mn from "@mui/material/Tab";
import Us, { tabsClasses as Ys } from "@mui/material/Tabs";
import Ks from "@mui/material/ClickAwayListener";
const Gs = ["values", "unit", "step"], Qs = (t) => {
  const o = Object.keys(t).map((n) => ({
    key: n,
    val: t[n]
  })) || [];
  return o.sort((n, r) => n.val - r.val), o.reduce((n, r) => b({}, n, {
    [r.key]: r.val
  }), {});
};
function Zs(t) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: o = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5
  } = t, a = ne(t, Gs), s = Qs(o), i = Object.keys(s);
  function l(d) {
    return `@media (min-width:${typeof o[d] == "number" ? o[d] : d}${n})`;
  }
  function c(d) {
    return `@media (max-width:${(typeof o[d] == "number" ? o[d] : d) - r / 100}${n})`;
  }
  function p(d, g) {
    const h = i.indexOf(g);
    return `@media (min-width:${typeof o[d] == "number" ? o[d] : d}${n}) and (max-width:${(h !== -1 && typeof o[i[h]] == "number" ? o[i[h]] : g) - r / 100}${n})`;
  }
  function m(d) {
    return i.indexOf(d) + 1 < i.length ? p(d, i[i.indexOf(d) + 1]) : l(d);
  }
  function f(d) {
    const g = i.indexOf(d);
    return g === 0 ? l(i[1]) : g === i.length - 1 ? c(i[g]) : p(d, i[i.indexOf(d) + 1]).replace("@media", "@media not all and");
  }
  return b({
    keys: i,
    values: s,
    up: l,
    down: c,
    between: p,
    only: m,
    not: f,
    unit: n
  }, a);
}
const Xs = {
  borderRadius: 4
};
function Qt(...t) {
  const o = t.reduce((r, a) => (a.filterProps.forEach((s) => {
    r[s] = a;
  }), r), {}), n = (r) => Object.keys(r).reduce((a, s) => o[s] ? Lt(a, o[s](r)) : a, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? t.reduce((r, a) => Object.assign(r, a.propTypes), {}) : {}, n.filterProps = t.reduce((r, a) => r.concat(a.filterProps), []), n;
}
function Ae(t) {
  return typeof t != "number" ? t : `${t}px solid`;
}
function Be(t, o) {
  return ve({
    prop: t,
    themeKey: "borders",
    transform: o
  });
}
const Js = Be("border", Ae), ei = Be("borderTop", Ae), ti = Be("borderRight", Ae), oi = Be("borderBottom", Ae), ni = Be("borderLeft", Ae), ri = Be("borderColor"), ai = Be("borderTopColor"), si = Be("borderRightColor"), ii = Be("borderBottomColor"), li = Be("borderLeftColor"), ci = Be("outline", Ae), ui = Be("outlineColor"), Zt = (t) => {
  if (t.borderRadius !== void 0 && t.borderRadius !== null) {
    const o = Nt(t.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: Wt(o, r)
    });
    return Ze(t, t.borderRadius, n);
  }
  return null;
};
Zt.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: qt
} : {};
Zt.filterProps = ["borderRadius"];
Qt(Js, ei, ti, oi, ni, ri, ai, si, ii, li, Zt, ci, ui);
const Xt = (t) => {
  if (t.gap !== void 0 && t.gap !== null) {
    const o = Nt(t.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: Wt(o, r)
    });
    return Ze(t, t.gap, n);
  }
  return null;
};
Xt.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: qt
} : {};
Xt.filterProps = ["gap"];
const Jt = (t) => {
  if (t.columnGap !== void 0 && t.columnGap !== null) {
    const o = Nt(t.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: Wt(o, r)
    });
    return Ze(t, t.columnGap, n);
  }
  return null;
};
Jt.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: qt
} : {};
Jt.filterProps = ["columnGap"];
const eo = (t) => {
  if (t.rowGap !== void 0 && t.rowGap !== null) {
    const o = Nt(t.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: Wt(o, r)
    });
    return Ze(t, t.rowGap, n);
  }
  return null;
};
eo.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: qt
} : {};
eo.filterProps = ["rowGap"];
const di = ve({
  prop: "gridColumn"
}), pi = ve({
  prop: "gridRow"
}), fi = ve({
  prop: "gridAutoFlow"
}), mi = ve({
  prop: "gridAutoColumns"
}), bi = ve({
  prop: "gridAutoRows"
}), hi = ve({
  prop: "gridTemplateColumns"
}), gi = ve({
  prop: "gridTemplateRows"
}), yi = ve({
  prop: "gridTemplateAreas"
}), Di = ve({
  prop: "gridArea"
});
Qt(Xt, Jt, eo, di, pi, fi, mi, bi, hi, gi, yi, Di);
function st(t, o) {
  return o === "grey" ? o : t;
}
const Ci = ve({
  prop: "color",
  themeKey: "palette",
  transform: st
}), vi = ve({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: st
}), wi = ve({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: st
});
Qt(Ci, vi, wi);
function Fe(t) {
  return t <= 1 && t !== 0 ? `${t * 100}%` : t;
}
const Ti = ve({
  prop: "width",
  transform: Fe
}), Ao = (t) => {
  if (t.maxWidth !== void 0 && t.maxWidth !== null) {
    const o = (n) => {
      var r, a;
      const s = ((r = t.theme) == null || (r = r.breakpoints) == null || (r = r.values) == null ? void 0 : r[n]) || Na[n];
      return s ? ((a = t.theme) == null || (a = a.breakpoints) == null ? void 0 : a.unit) !== "px" ? {
        maxWidth: `${s}${t.theme.breakpoints.unit}`
      } : {
        maxWidth: s
      } : {
        maxWidth: Fe(n)
      };
    };
    return Ze(t, t.maxWidth, o);
  }
  return null;
};
Ao.filterProps = ["maxWidth"];
const xi = ve({
  prop: "minWidth",
  transform: Fe
}), Pi = ve({
  prop: "height",
  transform: Fe
}), Si = ve({
  prop: "maxHeight",
  transform: Fe
}), ki = ve({
  prop: "minHeight",
  transform: Fe
});
ve({
  prop: "size",
  cssProperty: "width",
  transform: Fe
});
ve({
  prop: "size",
  cssProperty: "height",
  transform: Fe
});
const Ri = ve({
  prop: "boxSizing"
});
Qt(Ti, Ao, xi, Pi, Si, ki, Ri);
const er = {
  // borders
  border: {
    themeKey: "borders",
    transform: Ae
  },
  borderTop: {
    themeKey: "borders",
    transform: Ae
  },
  borderRight: {
    themeKey: "borders",
    transform: Ae
  },
  borderBottom: {
    themeKey: "borders",
    transform: Ae
  },
  borderLeft: {
    themeKey: "borders",
    transform: Ae
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Ae
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Zt
  },
  // palette
  color: {
    themeKey: "palette",
    transform: st
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: st
  },
  backgroundColor: {
    themeKey: "palette",
    transform: st
  },
  // spacing
  p: {
    style: we
  },
  pt: {
    style: we
  },
  pr: {
    style: we
  },
  pb: {
    style: we
  },
  pl: {
    style: we
  },
  px: {
    style: we
  },
  py: {
    style: we
  },
  padding: {
    style: we
  },
  paddingTop: {
    style: we
  },
  paddingRight: {
    style: we
  },
  paddingBottom: {
    style: we
  },
  paddingLeft: {
    style: we
  },
  paddingX: {
    style: we
  },
  paddingY: {
    style: we
  },
  paddingInline: {
    style: we
  },
  paddingInlineStart: {
    style: we
  },
  paddingInlineEnd: {
    style: we
  },
  paddingBlock: {
    style: we
  },
  paddingBlockStart: {
    style: we
  },
  paddingBlockEnd: {
    style: we
  },
  m: {
    style: Te
  },
  mt: {
    style: Te
  },
  mr: {
    style: Te
  },
  mb: {
    style: Te
  },
  ml: {
    style: Te
  },
  mx: {
    style: Te
  },
  my: {
    style: Te
  },
  margin: {
    style: Te
  },
  marginTop: {
    style: Te
  },
  marginRight: {
    style: Te
  },
  marginBottom: {
    style: Te
  },
  marginLeft: {
    style: Te
  },
  marginX: {
    style: Te
  },
  marginY: {
    style: Te
  },
  marginInline: {
    style: Te
  },
  marginInlineStart: {
    style: Te
  },
  marginInlineEnd: {
    style: Te
  },
  marginBlock: {
    style: Te
  },
  marginBlockStart: {
    style: Te
  },
  marginBlockEnd: {
    style: Te
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (t) => ({
      "@media print": {
        display: t
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Xt
  },
  rowGap: {
    style: eo
  },
  columnGap: {
    style: Jt
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Fe
  },
  maxWidth: {
    style: Ao
  },
  minWidth: {
    transform: Fe
  },
  height: {
    transform: Fe
  },
  maxHeight: {
    transform: Fe
  },
  minHeight: {
    transform: Fe
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function Mi(...t) {
  const o = t.reduce((r, a) => r.concat(Object.keys(a)), []), n = new Set(o);
  return t.every((r) => n.size === Object.keys(r).length);
}
function Oi(t, o) {
  return typeof t == "function" ? t(o) : t;
}
function Fi() {
  function t(n, r, a, s) {
    const i = {
      [n]: r,
      theme: a
    }, l = s[n];
    if (!l)
      return {
        [n]: r
      };
    const {
      cssProperty: c = n,
      themeKey: p,
      transform: m,
      style: f
    } = l;
    if (r == null)
      return null;
    if (p === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const d = _a(a, p) || {};
    return f ? f(i) : Ze(i, r, (h) => {
      let D = rn(d, m, h);
      return h === D && typeof h == "string" && (D = rn(d, m, `${n}${h === "default" ? "" : Ha(h)}`, h)), c === !1 ? D : {
        [c]: D
      };
    });
  }
  function o(n) {
    var r;
    const {
      sx: a,
      theme: s = {}
    } = n || {};
    if (!a)
      return null;
    const i = (r = s.unstable_sxConfig) != null ? r : er;
    function l(c) {
      let p = c;
      if (typeof c == "function")
        p = c(s);
      else if (typeof c != "object")
        return c;
      if (!p)
        return null;
      const m = qa(s.breakpoints), f = Object.keys(m);
      let d = m;
      return Object.keys(p).forEach((g) => {
        const h = Oi(p[g], s);
        if (h != null)
          if (typeof h == "object")
            if (i[g])
              d = Lt(d, t(g, h, s, i));
            else {
              const D = Ze({
                theme: s
              }, h, (y) => ({
                [g]: y
              }));
              Mi(D, h) ? d[g] = o({
                sx: h,
                theme: s
              }) : d = Lt(d, D);
            }
          else
            d = Lt(d, t(g, h, s, i));
      }), Wa(f, d);
    }
    return Array.isArray(a) ? a.map(l) : l(a);
  }
  return o;
}
const tr = Fi();
tr.filterProps = ["sx"];
function Ii(t, o) {
  const n = this;
  return n.vars && typeof n.getColorSchemeSelector == "function" ? {
    [n.getColorSchemeSelector(t).replace(/(\[[^\]]+\])/, "*:where($1)")]: o
  } : n.palette.mode === t ? o : {};
}
const Vi = ["breakpoints", "palette", "spacing", "shape"];
function Ai(t = {}, ...o) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: a,
    shape: s = {}
  } = t, i = ne(t, Vi), l = Zs(n), c = za(a);
  let p = an({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: b({
      mode: "light"
    }, r),
    spacing: c,
    shape: b({}, Xs, s)
  }, i);
  return p.applyStyles = Ii, p = o.reduce((m, f) => an(m, f), p), p.unstable_sxConfig = b({}, er, i == null ? void 0 : i.unstable_sxConfig), p.unstable_sx = function(f) {
    return tr({
      sx: f,
      theme: this
    });
  }, p;
}
function Ei(t) {
  return t !== "ownerState" && t !== "theme" && t !== "sx" && t !== "as";
}
Ai();
function Li(t, ...o) {
  const n = new URL(`https://mui.com/production-error/?code=${t}`);
  return o.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${t}; visit ${n} for the full message.`;
}
const Pe = e.oneOfType([e.func, e.object]);
function $i(t) {
  if (typeof t != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Li(7));
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function po(t) {
  return t && t.ownerDocument || document;
}
const ji = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function Bi(t) {
  return ge("MuiPickersDay", t);
}
const Ge = he("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]), Ni = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"], qi = (t) => {
  const {
    selected: o,
    disableMargin: n,
    disableHighlightToday: r,
    today: a,
    disabled: s,
    outsideCurrentMonth: i,
    showDaysOutsideCurrentMonth: l,
    classes: c
  } = t, p = i && !l;
  return me({
    root: ["root", o && !p && "selected", s && "disabled", !n && "dayWithMargin", !r && a && "today", i && l && "dayOutsideMonth", p && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, Bi, c);
}, or = ({
  theme: t
}) => b({}, t.typography.caption, {
  width: Rt,
  height: Rt,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: t.transitions.create("background-color", {
    duration: t.transitions.duration.short
  }),
  color: (t.vars || t).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: t.vars ? `rgba(${t.vars.palette.primary.mainChannel} / ${t.vars.palette.action.hoverOpacity})` : dt(t.palette.primary.main, t.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: t.vars ? `rgba(${t.vars.palette.primary.mainChannel} / ${t.vars.palette.action.focusOpacity})` : dt(t.palette.primary.main, t.palette.action.focusOpacity),
    [`&.${Ge.selected}`]: {
      willChange: "background-color",
      backgroundColor: (t.vars || t).palette.primary.dark
    }
  },
  [`&.${Ge.selected}`]: {
    color: (t.vars || t).palette.primary.contrastText,
    backgroundColor: (t.vars || t).palette.primary.main,
    fontWeight: t.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (t.vars || t).palette.primary.dark
    }
  },
  [`&.${Ge.disabled}:not(.${Ge.selected})`]: {
    color: (t.vars || t).palette.text.disabled
  },
  [`&.${Ge.disabled}&.${Ge.selected}`]: {
    opacity: 0.6
  },
  variants: [{
    props: {
      disableMargin: !1
    },
    style: {
      margin: `0 ${_t}px`
    }
  }, {
    props: {
      outsideCurrentMonth: !0,
      showDaysOutsideCurrentMonth: !0
    },
    style: {
      color: (t.vars || t).palette.text.secondary
    }
  }, {
    props: {
      disableHighlightToday: !1,
      today: !0
    },
    style: {
      [`&:not(.${Ge.selected})`]: {
        border: `1px solid ${(t.vars || t).palette.text.secondary}`
      }
    }
  }]
}), nr = (t, o) => {
  const {
    ownerState: n
  } = t;
  return [o.root, !n.disableMargin && o.dayWithMargin, !n.disableHighlightToday && n.today && o.today, !n.outsideCurrentMonth && n.showDaysOutsideCurrentMonth && o.dayOutsideMonth, n.outsideCurrentMonth && !n.showDaysOutsideCurrentMonth && o.hiddenDaySpacingFiller];
}, Wi = _(Is, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: nr
})(or), _i = _("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: nr
})(({
  theme: t
}) => b({}, or({
  theme: t
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
})), yt = () => {
}, rr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiPickersDay"
  }), {
    autoFocus: a = !1,
    className: s,
    day: i,
    disabled: l = !1,
    disableHighlightToday: c = !1,
    disableMargin: p = !1,
    isAnimating: m,
    onClick: f,
    onDaySelect: d,
    onFocus: g = yt,
    onBlur: h = yt,
    onKeyDown: D = yt,
    onMouseDown: y = yt,
    onMouseEnter: x = yt,
    outsideCurrentMonth: v,
    selected: P = !1,
    showDaysOutsideCurrentMonth: T = !1,
    children: S,
    today: k = !1
  } = r, M = ne(r, Ni), w = b({}, r, {
    autoFocus: a,
    disabled: l,
    disableHighlightToday: c,
    disableMargin: p,
    selected: P,
    showDaysOutsideCurrentMonth: T,
    today: k
  }), q = qi(w), B = ue(), O = C.useRef(null), V = Le(O, n);
  Ye(() => {
    a && !l && !m && !v && O.current.focus();
  }, [a, l, m, v]);
  const N = (F) => {
    y(F), v && F.preventDefault();
  }, A = (F) => {
    l || d(i), v && F.currentTarget.focus(), f && f(F);
  };
  return v && !T ? /* @__PURE__ */ u(_i, {
    className: Ce(q.root, q.hiddenDaySpacingFiller, s),
    ownerState: w,
    role: M.role
  }) : /* @__PURE__ */ u(Wi, b({
    className: Ce(q.root, s),
    ref: V,
    centerRipple: !0,
    disabled: l,
    tabIndex: P ? 0 : -1,
    onKeyDown: (F) => D(F, i),
    onFocus: (F) => g(F, i),
    onBlur: (F) => h(F, i),
    onMouseEnter: (F) => x(F, i),
    onClick: A,
    onMouseDown: N
  }, M, {
    ownerState: w,
    children: S || B.format(i, "dayOfMonth")
  }));
});
process.env.NODE_ENV !== "production" && (rr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: e.oneOfType([e.func, e.shape({
    current: e.shape({
      focusVisible: e.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: e.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  className: e.string,
  component: e.elementType,
  /**
   * The date to show.
   */
  day: e.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: e.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: e.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: e.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: e.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: e.string,
  isAnimating: e.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: e.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: e.bool.isRequired,
  onBlur: e.func,
  onDaySelect: e.func.isRequired,
  onFocus: e.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: e.func,
  onKeyDown: e.func,
  onMouseEnter: e.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: e.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: e.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: e.bool,
  style: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * @default 0
   */
  tabIndex: e.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: e.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: e.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: e.oneOfType([e.func, e.shape({
    current: e.shape({
      pulsate: e.func.isRequired,
      start: e.func.isRequired,
      stop: e.func.isRequired
    })
  })])
});
const ar = /* @__PURE__ */ C.memo(rr), bt = ({
  props: t,
  value: o,
  timezone: n,
  adapter: r
}) => {
  if (o === null)
    return null;
  const {
    shouldDisableDate: a,
    shouldDisableMonth: s,
    shouldDisableYear: i,
    disablePast: l,
    disableFuture: c
  } = t, p = r.utils.date(void 0, n), m = Se(r.utils, t.minDate, r.defaultDates.minDate), f = Se(r.utils, t.maxDate, r.defaultDates.maxDate);
  switch (!0) {
    case !r.utils.isValid(o):
      return "invalidDate";
    case !!(a && a(o)):
      return "shouldDisableDate";
    case !!(s && s(o)):
      return "shouldDisableMonth";
    case !!(i && i(o)):
      return "shouldDisableYear";
    case !!(c && r.utils.isAfterDay(o, p)):
      return "disableFuture";
    case !!(l && r.utils.isBeforeDay(o, p)):
      return "disablePast";
    case !!(m && r.utils.isBeforeDay(o, m)):
      return "minDate";
    case !!(f && r.utils.isAfterDay(o, f)):
      return "maxDate";
    default:
      return null;
  }
};
bt.valueManager = xe;
const It = ({
  adapter: t,
  value: o,
  timezone: n,
  props: r
}) => {
  if (o === null)
    return null;
  const {
    minTime: a,
    maxTime: s,
    minutesStep: i,
    shouldDisableTime: l,
    disableIgnoringDatePartForTimeValidation: c = !1,
    disablePast: p,
    disableFuture: m
  } = r, f = t.utils.date(void 0, n), d = Ja(c, t.utils);
  switch (!0) {
    case !t.utils.isValid(o):
      return "invalidDate";
    case !!(a && d(a, o)):
      return "minTime";
    case !!(s && d(o, s)):
      return "maxTime";
    case !!(m && t.utils.isAfter(o, f)):
      return "disableFuture";
    case !!(p && t.utils.isBefore(o, f)):
      return "disablePast";
    case !!(l && l(o, "hours")):
      return "shouldDisableTime-hours";
    case !!(l && l(o, "minutes")):
      return "shouldDisableTime-minutes";
    case !!(l && l(o, "seconds")):
      return "shouldDisableTime-seconds";
    case !!(i && t.utils.getMinutes(o) % i !== 0):
      return "minutesStep";
    default:
      return null;
  }
};
It.valueManager = xe;
const to = ({
  adapter: t,
  value: o,
  timezone: n,
  props: r
}) => {
  const a = bt({
    adapter: t,
    value: o,
    timezone: n,
    props: r
  });
  return a !== null ? a : It({
    adapter: t,
    value: o,
    timezone: n,
    props: r
  });
};
to.valueManager = xe;
const ho = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], go = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], sr = ["minDateTime", "maxDateTime"], Hi = [...ho, ...go, ...sr], ht = (t) => Hi.reduce((o, n) => (t.hasOwnProperty(n) && (o[n] = t[n]), o), {});
function ir(t) {
  const {
    props: o,
    validator: n,
    value: r,
    timezone: a,
    onError: s
  } = t, i = Ht(), l = C.useRef(n.valueManager.defaultErrorState), c = n({
    adapter: i,
    value: r,
    timezone: a,
    props: o
  }), p = n.valueManager.hasError(c);
  C.useEffect(() => {
    s && !n.valueManager.isSameError(c, l.current) && s(c, r), l.current = c;
  }, [n, s, c, r]);
  const m = Z((f) => n({
    adapter: i,
    value: f,
    timezone: a,
    props: o
  }));
  return {
    validationError: c,
    hasValidationError: p,
    getValidationErrorForNewValue: m
  };
}
const zi = ({
  utils: t,
  format: o
}) => {
  let n = 10, r = o, a = t.expandFormat(o);
  for (; a !== r; )
    if (r = a, a = t.expandFormat(r), n -= 1, n < 0)
      throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.");
  return a;
}, Ui = ({
  utils: t,
  expandedFormat: o
}) => {
  const n = [], {
    start: r,
    end: a
  } = t.escapedCharacters, s = new RegExp(`(\\${r}[^\\${a}]*\\${a})+`, "g");
  let i = null;
  for (; i = s.exec(o); )
    n.push({
      start: i.index,
      end: s.lastIndex - 1
    });
  return n;
}, Yi = (t, o, n, r) => {
  switch (n.type) {
    case "year":
      return o.fieldYearPlaceholder({
        digitAmount: t.formatByString(t.date(void 0, "default"), r).length,
        format: r
      });
    case "month":
      return o.fieldMonthPlaceholder({
        contentType: n.contentType,
        format: r
      });
    case "day":
      return o.fieldDayPlaceholder({
        format: r
      });
    case "weekDay":
      return o.fieldWeekDayPlaceholder({
        contentType: n.contentType,
        format: r
      });
    case "hours":
      return o.fieldHoursPlaceholder({
        format: r
      });
    case "minutes":
      return o.fieldMinutesPlaceholder({
        format: r
      });
    case "seconds":
      return o.fieldSecondsPlaceholder({
        format: r
      });
    case "meridiem":
      return o.fieldMeridiemPlaceholder({
        format: r
      });
    default:
      return r;
  }
}, Ki = ({
  utils: t,
  date: o,
  shouldRespectLeadingZeros: n,
  localeText: r,
  localizedDigits: a,
  now: s,
  token: i,
  startSeparator: l
}) => {
  if (i === "")
    throw new Error("MUI X: Should not call `commitToken` with an empty token");
  const c = Bn(t, i), p = Nn(t, c.contentType, c.type, i), m = n ? p : c.contentType === "digit", f = o != null && t.isValid(o);
  let d = f ? t.formatByString(o, i) : "", g = null;
  if (m)
    if (p)
      g = d === "" ? t.formatByString(s, i).length : d.length;
    else {
      if (c.maxLength == null)
        throw new Error(`MUI X: The token ${i} should have a 'maxDigitNumber' property on it's adapter`);
      g = c.maxLength, f && (d = qn(es(Wn(d, a), g), a));
    }
  return b({}, c, {
    format: i,
    maxLength: g,
    value: d,
    placeholder: Yi(t, r, c, i),
    hasLeadingZerosInFormat: p,
    hasLeadingZerosInInput: m,
    startSeparator: l,
    endSeparator: "",
    modified: !1
  });
}, Gi = (t) => {
  var g;
  const {
    utils: o,
    expandedFormat: n,
    escapedParts: r
  } = t, a = o.date(void 0), s = [];
  let i = "";
  const l = Object.keys(o.formatTokenMap).sort((h, D) => D.length - h.length), c = /^([a-zA-Z]+)/, p = new RegExp(`^(${l.join("|")})*$`), m = new RegExp(`^(${l.join("|")})`), f = (h) => r.find((D) => D.start <= h && D.end >= h);
  let d = 0;
  for (; d < n.length; ) {
    const h = f(d), D = h != null, y = (g = c.exec(n.slice(d))) == null ? void 0 : g[1];
    if (!D && y != null && p.test(y)) {
      let x = y;
      for (; x.length > 0; ) {
        const v = m.exec(x)[1];
        x = x.slice(v.length), s.push(Ki(b({}, t, {
          now: a,
          token: v,
          startSeparator: i
        }))), i = "";
      }
      d += y.length;
    } else {
      const x = n[d];
      D && (h == null ? void 0 : h.start) === d || (h == null ? void 0 : h.end) === d || (s.length === 0 ? i += x : s[s.length - 1].endSeparator += x), d += 1;
    }
  }
  return s.length === 0 && i.length > 0 && s.push({
    type: "empty",
    contentType: "letter",
    maxLength: null,
    format: "",
    value: "",
    placeholder: "",
    hasLeadingZerosInFormat: !1,
    hasLeadingZerosInInput: !1,
    startSeparator: i,
    endSeparator: "",
    modified: !1
  }), s;
}, Qi = ({
  isRtl: t,
  formatDensity: o,
  sections: n
}) => n.map((r) => {
  const a = (s) => {
    let i = s;
    return t && i !== null && i.includes(" ") && (i = `⁩${i}⁦`), o === "spacious" && ["/", ".", "-"].includes(i) && (i = ` ${i} `), i;
  };
  return r.startSeparator = a(r.startSeparator), r.endSeparator = a(r.endSeparator), r;
}), bn = (t) => {
  let o = zi(t);
  t.isRtl && t.enableAccessibleFieldDOMStructure && (o = o.split(" ").reverse().join(" "));
  const n = Ui(b({}, t, {
    expandedFormat: o
  })), r = Gi(b({}, t, {
    expandedFormat: o,
    escapedParts: n
  }));
  return Qi(b({}, t, {
    sections: r
  }));
}, Zi = (t) => {
  const o = ue(), n = ke(), r = Ht(), a = _e(), {
    valueManager: s,
    fieldValueManager: i,
    valueType: l,
    validator: c,
    internalProps: p,
    internalProps: {
      value: m,
      defaultValue: f,
      referenceDate: d,
      onChange: g,
      format: h,
      formatDensity: D = "dense",
      selectedSections: y,
      onSelectedSectionsChange: x,
      shouldRespectLeadingZeros: v = !1,
      timezone: P,
      enableAccessibleFieldDOMStructure: T = !1
    }
  } = t, {
    timezone: S,
    value: k,
    handleValueChange: M
  } = _n({
    timezone: P,
    value: m,
    defaultValue: f,
    referenceDate: d,
    onChange: g,
    valueManager: s
  }), w = C.useMemo(() => ts(o), [o]), q = C.useMemo(() => os(o, w, S), [o, w, S]), B = C.useCallback(($, X = null) => i.getSectionsFromValue(o, $, X, (H) => bn({
    utils: o,
    localeText: n,
    localizedDigits: w,
    format: h,
    date: H,
    formatDensity: D,
    shouldRespectLeadingZeros: v,
    enableAccessibleFieldDOMStructure: T,
    isRtl: a
  })), [i, h, n, w, a, v, o, D, T]), [O, V] = C.useState(() => {
    const $ = B(k);
    ln($, l);
    const X = {
      sections: $,
      value: k,
      referenceValue: s.emptyValue,
      tempValueStrAndroid: null
    }, H = ns($), E = s.getInitialReferenceValue({
      referenceDate: d,
      value: k,
      utils: o,
      props: p,
      granularity: H,
      timezone: S
    });
    return b({}, X, {
      referenceValue: E
    });
  }), [N, A] = zt({
    controlled: y,
    default: null,
    name: "useField",
    state: "selectedSections"
  }), F = ($) => {
    A($), x == null || x($);
  }, L = C.useMemo(() => bo(N, O.sections), [N, O.sections]), ee = L === "all" ? 0 : L, Q = ({
    value: $,
    referenceValue: X,
    sections: H
  }) => {
    if (V((I) => b({}, I, {
      sections: H,
      value: $,
      referenceValue: X,
      tempValueStrAndroid: null
    })), s.areValuesEqual(o, O.value, $))
      return;
    const E = {
      validationError: c({
        adapter: r,
        value: $,
        timezone: S,
        props: p
      })
    };
    M($, E);
  }, ae = ($, X) => {
    const H = [...O.sections];
    return H[$] = b({}, H[$], {
      value: X,
      modified: !0
    }), H;
  }, se = () => {
    Q({
      value: s.emptyValue,
      referenceValue: O.referenceValue,
      sections: B(s.emptyValue)
    });
  }, re = () => {
    if (ee == null)
      return;
    const $ = O.sections[ee], X = i.getActiveDateManager(o, O, $), E = X.getSections(O.sections).filter((U) => U.value !== "").length === ($.value === "" ? 0 : 1), I = ae(ee, ""), J = E ? null : o.getInvalidDate(), te = X.getNewValuesFromNewActiveDate(J);
    Q(b({}, te, {
      sections: I
    }));
  }, ce = ($) => {
    const X = (I, J) => {
      const te = o.parse(I, h);
      if (te == null || !o.isValid(te))
        return null;
      const U = bn({
        utils: o,
        localeText: n,
        localizedDigits: w,
        format: h,
        date: te,
        formatDensity: D,
        shouldRespectLeadingZeros: v,
        enableAccessibleFieldDOMStructure: T,
        isRtl: a
      });
      return cn(o, te, U, J, !1);
    }, H = i.parseValueStr($, O.referenceValue, X), E = i.updateReferenceValue(o, H, O.referenceValue);
    Q({
      value: H,
      referenceValue: E,
      sections: B(H, O.sections)
    });
  }, ye = ({
    activeSection: $,
    newSectionValue: X,
    shouldGoToNextSection: H
  }) => {
    H && ee < O.sections.length - 1 && F(ee + 1);
    const E = i.getActiveDateManager(o, O, $), I = ae(ee, X), J = E.getSections(I), te = rs(o, J, w);
    let U, R;
    if (te != null && o.isValid(te)) {
      const W = cn(o, te, J, E.referenceDate, !0);
      U = E.getNewValuesFromNewActiveDate(W), R = !0;
    } else
      U = E.getNewValuesFromNewActiveDate(te), R = (te != null && !o.isValid(te)) != (E.date != null && !o.isValid(E.date));
    return R ? Q(b({}, U, {
      sections: I
    })) : V((W) => b({}, W, U, {
      sections: I,
      tempValueStrAndroid: null
    }));
  }, de = ($) => V((X) => b({}, X, {
    tempValueStrAndroid: $
  }));
  return C.useEffect(() => {
    const $ = B(O.value);
    ln($, l), V((X) => b({}, X, {
      sections: $
    }));
  }, [h, o.locale, a]), C.useEffect(() => {
    let $;
    s.areValuesEqual(o, O.value, k) ? $ = s.getTimezone(o, O.value) !== s.getTimezone(o, k) : $ = !0, $ && V((X) => b({}, X, {
      value: k,
      referenceValue: i.updateReferenceValue(o, k, X.referenceValue),
      sections: B(k)
    }));
  }, [k]), {
    state: O,
    activeSectionIndex: ee,
    parsedSelectedSections: L,
    setSelectedSections: F,
    clearValue: se,
    clearActiveSection: re,
    updateSectionValue: ye,
    updateValueFromValueStr: ce,
    setTempAndroidValueStr: de,
    getSectionsFromValue: B,
    sectionsValueBoundaries: q,
    localizedDigits: w,
    timezone: S
  };
}, Xi = 5e3, ot = (t) => t.saveQuery != null, Ji = ({
  sections: t,
  updateSectionValue: o,
  sectionsValueBoundaries: n,
  localizedDigits: r,
  setTempAndroidValueStr: a,
  timezone: s
}) => {
  const i = ue(), [l, c] = C.useState(null), p = Z(() => c(null));
  C.useEffect(() => {
    var h;
    l != null && ((h = t[l.sectionIndex]) == null ? void 0 : h.type) !== l.sectionType && p();
  }, [t, l, p]), C.useEffect(() => {
    if (l != null) {
      const h = setTimeout(() => p(), Xi);
      return () => {
        clearTimeout(h);
      };
    }
    return () => {
    };
  }, [l, p]);
  const m = ({
    keyPressed: h,
    sectionIndex: D
  }, y, x) => {
    const v = h.toLowerCase(), P = t[D];
    if (l != null && (!x || x(l.value)) && l.sectionIndex === D) {
      const S = `${l.value}${v}`, k = y(S, P);
      if (!ot(k))
        return c({
          sectionIndex: D,
          value: S,
          sectionType: P.type
        }), k;
    }
    const T = y(v, P);
    return ot(T) && !T.saveQuery ? (p(), null) : (c({
      sectionIndex: D,
      value: v,
      sectionType: P.type
    }), ot(T) ? null : T);
  }, f = (h) => {
    const D = (v, P, T) => {
      const S = P.filter((k) => k.toLowerCase().startsWith(T));
      return S.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: S[0],
        shouldGoToNextSection: S.length === 1
      };
    }, y = (v, P, T, S) => {
      const k = (M) => is(i, s, P.type, M);
      if (P.contentType === "letter")
        return D(P.format, k(P.format), v);
      if (T && S != null && Bn(i, T).contentType === "letter") {
        const M = k(T), w = D(T, M, v);
        return ot(w) ? {
          saveQuery: !1
        } : b({}, w, {
          sectionValue: S(w.sectionValue, M)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return m(h, (v, P) => {
      switch (P.type) {
        case "month": {
          const T = (S) => dn(i, S, i.formats.month, P.format);
          return y(v, P, i.formats.month, T);
        }
        case "weekDay": {
          const T = (S, k) => k.indexOf(S).toString();
          return y(v, P, i.formats.weekday, T);
        }
        case "meridiem":
          return y(v, P);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, d = (h) => {
    const D = (x, v) => {
      const P = Wn(x, r), T = Number(P), S = n[v.type]({
        currentDate: null,
        format: v.format,
        contentType: v.contentType
      });
      if (T > S.maximum)
        return {
          saveQuery: !1
        };
      if (T < S.minimum)
        return {
          saveQuery: !0
        };
      const k = T * 10 > S.maximum || P.length === S.maximum.toString().length;
      return {
        sectionValue: ss(i, T, S, r, v),
        shouldGoToNextSection: k
      };
    };
    return m(h, (x, v) => {
      if (v.contentType === "digit" || v.contentType === "digit-with-letter")
        return D(x, v);
      if (v.type === "month") {
        const P = Nn(i, "digit", "month", "MM"), T = D(x, {
          type: v.type,
          format: "MM",
          hasLeadingZerosInFormat: P,
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (ot(T))
          return T;
        const S = dn(i, T.sectionValue, "MM", v.format);
        return b({}, T, {
          sectionValue: S
        });
      }
      if (v.type === "weekDay") {
        const P = D(x, v);
        if (ot(P))
          return P;
        const T = as(i, v.format)[Number(P.sectionValue) - 1];
        return b({}, P, {
          sectionValue: T
        });
      }
      return {
        saveQuery: !1
      };
    }, (x) => un(x, r));
  };
  return {
    applyCharacterEditing: Z((h) => {
      const D = t[h.sectionIndex], x = un(h.keyPressed, r) ? d(b({}, h, {
        keyPressed: qn(h.keyPressed, r)
      })) : f(h);
      if (x == null) {
        a(null);
        return;
      }
      o({
        activeSection: D,
        newSectionValue: x.sectionValue,
        shouldGoToNextSection: x.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: p
  };
}, el = (t) => {
  const {
    internalProps: {
      disabled: o,
      readOnly: n = !1
    },
    forwardedProps: {
      sectionListRef: r,
      onBlur: a,
      onClick: s,
      onFocus: i,
      onInput: l,
      onPaste: c,
      focused: p,
      autoFocus: m = !1
    },
    fieldValueManager: f,
    applyCharacterEditing: d,
    resetCharacterQuery: g,
    setSelectedSections: h,
    parsedSelectedSections: D,
    state: y,
    clearActiveSection: x,
    clearValue: v,
    updateSectionValue: P,
    updateValueFromValueStr: T,
    sectionOrder: S,
    areAllSectionsEmpty: k,
    sectionsValueBoundaries: M
  } = t, w = C.useRef(null), q = Le(r, w), B = ke(), O = ue(), V = Ft(), [N, A] = C.useState(!1), F = C.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!w.current)
        return;
      const R = document.getSelection();
      if (!R)
        return;
      if (D == null) {
        R.rangeCount > 0 && w.current.getRoot().contains(R.getRangeAt(0).startContainer) && R.removeAllRanges(), N && w.current.getRoot().blur();
        return;
      }
      if (!w.current.getRoot().contains(Ve(document)))
        return;
      const W = new window.Range();
      let G;
      D === "all" ? G = w.current.getRoot() : y.sections[D].type === "empty" ? G = w.current.getSectionContainer(D) : G = w.current.getSectionContent(D), W.selectNodeContents(G), G.focus(), R.removeAllRanges(), R.addRange(W);
    },
    getActiveSectionIndexFromDOM: () => {
      const R = Ve(document);
      return !R || !w.current || !w.current.getRoot().contains(R) ? null : w.current.getSectionIndexFromDOMElement(R);
    },
    focusField: (R = 0) => {
      if (!w.current)
        return;
      const W = bo(R, y.sections);
      A(!0), w.current.getSectionContent(W).focus();
    },
    setSelectedSections: (R) => {
      if (!w.current)
        return;
      const W = bo(R, y.sections);
      A((W === "all" ? 0 : W) !== null), h(R);
    },
    isFieldFocused: () => {
      const R = Ve(document);
      return !!w.current && w.current.getRoot().contains(R);
    }
  }), [D, h, y.sections, N]), L = Z((R) => {
    if (!w.current)
      return;
    const W = y.sections[R];
    w.current.getSectionContent(R).innerHTML = W.value || W.placeholder, F.syncSelectionToDOM();
  }), ee = Z((R, ...W) => {
    R.isDefaultPrevented() || !w.current || (A(!0), s == null || s(R, ...W), D === "all" ? setTimeout(() => {
      const G = document.getSelection().getRangeAt(0).startOffset;
      if (G === 0) {
        h(S.startIndex);
        return;
      }
      let j = 0, oe = 0;
      for (; oe < G && j < y.sections.length; ) {
        const Y = y.sections[j];
        j += 1, oe += `${Y.startSeparator}${Y.value || Y.placeholder}${Y.endSeparator}`.length;
      }
      h(j - 1);
    }) : N ? w.current.getRoot().contains(R.target) || h(S.startIndex) : (A(!0), h(S.startIndex)));
  }), Q = Z((R) => {
    if (l == null || l(R), !w.current || D !== "all")
      return;
    const G = R.target.textContent ?? "";
    w.current.getRoot().innerHTML = y.sections.map((j) => `${j.startSeparator}${j.value || j.placeholder}${j.endSeparator}`).join(""), F.syncSelectionToDOM(), G.length === 0 || G.charCodeAt(0) === 10 ? (g(), v(), h("all")) : G.length > 1 ? T(G) : d({
      keyPressed: G,
      sectionIndex: 0
    });
  }), ae = Z((R) => {
    if (c == null || c(R), n || D !== "all") {
      R.preventDefault();
      return;
    }
    const W = R.clipboardData.getData("text");
    R.preventDefault(), g(), T(W);
  }), se = Z((...R) => {
    if (i == null || i(...R), N || !w.current)
      return;
    A(!0), w.current.getSectionIndexFromDOMElement(Ve(document)) != null || h(S.startIndex);
  }), re = Z((...R) => {
    a == null || a(...R), setTimeout(() => {
      if (!w.current)
        return;
      const W = Ve(document);
      !w.current.getRoot().contains(W) && (A(!1), h(null));
    });
  }), ce = Z((R) => (W) => {
    W.isDefaultPrevented() || h(R);
  }), ye = Z((R) => {
    R.preventDefault();
  }), de = Z((R) => () => {
    h(R);
  }), $ = Z((R) => {
    if (R.preventDefault(), n || o || typeof D != "number")
      return;
    const W = y.sections[D], G = R.clipboardData.getData("text"), j = /^[a-zA-Z]+$/.test(G), oe = /^[0-9]+$/.test(G), Y = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(G);
    W.contentType === "letter" && j || W.contentType === "digit" && oe || W.contentType === "digit-with-letter" && Y ? (g(), P({
      activeSection: W,
      newSectionValue: G,
      shouldGoToNextSection: !0
    })) : !j && !oe && (g(), T(G));
  }), X = Z((R) => {
    R.preventDefault(), R.dataTransfer.dropEffect = "none";
  }), H = Z((R) => {
    if (!w.current)
      return;
    const W = R.target, G = W.textContent ?? "", j = w.current.getSectionIndexFromDOMElement(W), oe = y.sections[j];
    if (n || !w.current) {
      L(j);
      return;
    }
    if (G.length === 0) {
      if (oe.value === "") {
        L(j);
        return;
      }
      const Y = R.nativeEvent.inputType;
      if (Y === "insertParagraph" || Y === "insertLineBreak") {
        L(j);
        return;
      }
      g(), x();
      return;
    }
    d({
      keyPressed: G,
      sectionIndex: j
    }), L(j);
  });
  Ye(() => {
    if (!(!N || !w.current)) {
      if (D === "all")
        w.current.getRoot().focus();
      else if (typeof D == "number") {
        const R = w.current.getSectionContent(D);
        R && R.focus();
      }
    }
  }, [D, N]);
  const E = C.useMemo(() => y.sections.reduce((R, W) => (R[W.type] = M[W.type]({
    currentDate: null,
    contentType: W.contentType,
    format: W.format
  }), R), {}), [M, y.sections]), I = D === "all", J = C.useMemo(() => y.sections.map((R, W) => {
    const G = !I && !o && !n;
    return {
      container: {
        "data-sectionindex": W,
        onClick: ce(W)
      },
      content: {
        tabIndex: I || W > 0 ? -1 : 0,
        contentEditable: !I && !o && !n,
        role: "spinbutton",
        id: `${V}-${R.type}`,
        "aria-labelledby": `${V}-${R.type}`,
        "aria-readonly": n,
        "aria-valuenow": ls(R, O),
        "aria-valuemin": E[R.type].minimum,
        "aria-valuemax": E[R.type].maximum,
        "aria-valuetext": R.value ? cs(R, O) : B.empty,
        "aria-label": B[R.type],
        "aria-disabled": o,
        spellCheck: G ? !1 : void 0,
        autoCapitalize: G ? "off" : void 0,
        autoCorrect: G ? "off" : void 0,
        [parseInt(C.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: G ? "next" : void 0,
        children: R.value || R.placeholder,
        onInput: H,
        onPaste: $,
        onFocus: de(W),
        onDragOver: X,
        onMouseUp: ye,
        inputMode: R.contentType === "letter" ? "text" : "numeric"
      },
      before: {
        children: R.startSeparator
      },
      after: {
        children: R.endSeparator
      }
    };
  }), [y.sections, de, $, X, H, ce, ye, o, n, I, B, O, E, V]), te = Z((R) => {
    T(R.target.value);
  }), U = C.useMemo(() => k ? "" : f.getV7HiddenInputValueFromSections(y.sections), [k, y.sections, f]);
  return C.useEffect(() => {
    if (w.current == null)
      throw new Error(["MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`", "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.", "", "If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:", "", "<DatePicker slots={{ textField: MyCustomTextField }} />", "", "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"].join(`
`));
    m && w.current && w.current.getSectionContent(S.startIndex).focus();
  }, []), {
    interactions: F,
    returnedValue: {
      // Forwarded
      autoFocus: m,
      readOnly: n,
      focused: p ?? N,
      sectionListRef: q,
      onBlur: re,
      onClick: ee,
      onFocus: se,
      onInput: Q,
      onPaste: ae,
      // Additional
      enableAccessibleFieldDOMStructure: !0,
      elements: J,
      // TODO v7: Try to set to undefined when there is a section selected.
      tabIndex: D === 0 ? -1 : 0,
      contentEditable: I,
      value: U,
      onChange: te,
      areAllSectionsEmpty: k
    }
  };
}, rt = (t) => t.replace(/[\u2066\u2067\u2068\u2069]/g, ""), tl = (t, o, n) => {
  let r = 0, a = n ? 1 : 0;
  const s = [];
  for (let i = 0; i < t.length; i += 1) {
    const l = t[i], c = ds(l, n ? "input-rtl" : "input-ltr", o), p = `${l.startSeparator}${c}${l.endSeparator}`, m = rt(p).length, f = p.length, d = rt(c), g = a + (d === "" ? 0 : c.indexOf(d[0])) + l.startSeparator.length, h = g + d.length;
    s.push(b({}, l, {
      start: r,
      end: r + m,
      startInInput: g,
      endInInput: h
    })), r += m, a += f;
  }
  return s;
}, ol = (t) => {
  const o = _e(), n = C.useRef(), r = C.useRef(), {
    forwardedProps: {
      onFocus: a,
      onClick: s,
      onPaste: i,
      onBlur: l,
      inputRef: c,
      placeholder: p
    },
    internalProps: {
      readOnly: m = !1,
      disabled: f = !1
    },
    parsedSelectedSections: d,
    activeSectionIndex: g,
    state: h,
    fieldValueManager: D,
    valueManager: y,
    applyCharacterEditing: x,
    resetCharacterQuery: v,
    updateSectionValue: P,
    updateValueFromValueStr: T,
    clearActiveSection: S,
    clearValue: k,
    setTempAndroidValueStr: M,
    setSelectedSections: w,
    getSectionsFromValue: q,
    areAllSectionsEmpty: B,
    localizedDigits: O
  } = t, V = C.useRef(null), N = Le(c, V), A = C.useMemo(() => tl(h.sections, O, o), [h.sections, O, o]), F = C.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!V.current)
        return;
      if (d == null) {
        V.current.scrollLeft && (V.current.scrollLeft = 0);
        return;
      }
      if (V.current !== Ve(document))
        return;
      const H = V.current.scrollTop;
      if (d === "all")
        V.current.select();
      else {
        const E = A[d], I = E.type === "empty" ? E.startInInput - E.startSeparator.length : E.startInInput, J = E.type === "empty" ? E.endInInput + E.endSeparator.length : E.endInInput;
        (I !== V.current.selectionStart || J !== V.current.selectionEnd) && V.current === Ve(document) && V.current.setSelectionRange(I, J), clearTimeout(r.current), r.current = setTimeout(() => {
          V.current && V.current === Ve(document) && // The section might loose all selection, where `selectionStart === selectionEnd`
          // https://github.com/mui/mui-x/pull/13652
          V.current.selectionStart === V.current.selectionEnd && (V.current.selectionStart !== I || V.current.selectionEnd !== J) && F.syncSelectionToDOM();
        });
      }
      V.current.scrollTop = H;
    },
    getActiveSectionIndexFromDOM: () => {
      const H = V.current.selectionStart ?? 0, E = V.current.selectionEnd ?? 0;
      if (H === 0 && E === 0)
        return null;
      const I = H <= A[0].startInInput ? 1 : A.findIndex((J) => J.startInInput - J.startSeparator.length > H);
      return I === -1 ? A.length - 1 : I - 1;
    },
    focusField: (H = 0) => {
      var E;
      (E = V.current) == null || E.focus(), w(H);
    },
    setSelectedSections: (H) => w(H),
    isFieldFocused: () => V.current === Ve(document)
  }), [V, d, A, w]), L = () => {
    const H = V.current.selectionStart ?? 0;
    let E;
    H <= A[0].startInInput || H >= A[A.length - 1].endInInput ? E = 1 : E = A.findIndex((J) => J.startInInput - J.startSeparator.length > H);
    const I = E === -1 ? A.length - 1 : E - 1;
    w(I);
  }, ee = Z((...H) => {
    a == null || a(...H);
    const E = V.current;
    clearTimeout(n.current), n.current = setTimeout(() => {
      !E || E !== V.current || g == null && (// avoid selecting all sections when focusing empty field without value
      E.value.length && Number(E.selectionEnd) - Number(E.selectionStart) === E.value.length ? w("all") : L());
    });
  }), Q = Z((H, ...E) => {
    H.isDefaultPrevented() || (s == null || s(H, ...E), L());
  }), ae = Z((H) => {
    if (i == null || i(H), H.preventDefault(), m || f)
      return;
    const E = H.clipboardData.getData("text");
    if (typeof d == "number") {
      const I = h.sections[d], J = /^[a-zA-Z]+$/.test(E), te = /^[0-9]+$/.test(E), U = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(E);
      if (I.contentType === "letter" && J || I.contentType === "digit" && te || I.contentType === "digit-with-letter" && U) {
        v(), P({
          activeSection: I,
          newSectionValue: E,
          shouldGoToNextSection: !0
        });
        return;
      }
      if (J || te)
        return;
    }
    v(), T(E);
  }), se = Z((...H) => {
    l == null || l(...H), w(null);
  }), re = Z((H) => {
    if (m)
      return;
    const E = H.target.value;
    if (E === "") {
      v(), k();
      return;
    }
    const I = H.nativeEvent.data, J = I && I.length > 1, te = J ? I : E, U = rt(te);
    if (g == null || J) {
      T(J ? I : U);
      return;
    }
    let R;
    if (d === "all" && U.length === 1)
      R = U;
    else {
      const W = rt(D.getV6InputValueFromSections(A, O, o));
      let G = -1, j = -1;
      for (let be = 0; be < W.length; be += 1)
        G === -1 && W[be] !== U[be] && (G = be), j === -1 && W[W.length - be - 1] !== U[U.length - be - 1] && (j = be);
      const oe = A[g];
      if (G < oe.start || W.length - j - 1 > oe.end)
        return;
      const ie = U.length - W.length + oe.end - rt(oe.endSeparator || "").length;
      R = U.slice(oe.start + rt(oe.startSeparator || "").length, ie);
    }
    if (R.length === 0) {
      us() && M(te), v(), S();
      return;
    }
    x({
      keyPressed: R,
      sectionIndex: g
    });
  }), ce = C.useMemo(() => p !== void 0 ? p : D.getV6InputValueFromSections(q(y.emptyValue), O, o), [p, D, q, y.emptyValue, O, o]), ye = C.useMemo(() => h.tempValueStrAndroid ?? D.getV6InputValueFromSections(h.sections, O, o), [h.sections, D, h.tempValueStrAndroid, O, o]);
  C.useEffect(() => (V.current && V.current === Ve(document) && w("all"), () => {
    clearTimeout(n.current), clearTimeout(r.current);
  }), []);
  const de = C.useMemo(() => g == null || h.sections[g].contentType === "letter" ? "text" : "numeric", [g, h.sections]), X = !(V.current && V.current === Ve(document)) && B;
  return {
    interactions: F,
    returnedValue: {
      // Forwarded
      readOnly: m,
      onBlur: se,
      onClick: Q,
      onFocus: ee,
      onPaste: ae,
      inputRef: N,
      // Additional
      enableAccessibleFieldDOMStructure: !1,
      placeholder: ce,
      inputMode: de,
      autoComplete: "off",
      value: X ? "" : ye,
      onChange: re
    }
  };
}, Eo = (t) => {
  const o = ue(), {
    internalProps: n,
    internalProps: {
      unstableFieldRef: r,
      minutesStep: a,
      enableAccessibleFieldDOMStructure: s = !1,
      disabled: i = !1,
      readOnly: l = !1
    },
    forwardedProps: {
      onKeyDown: c,
      error: p,
      clearable: m,
      onClear: f
    },
    fieldValueManager: d,
    valueManager: g,
    validator: h
  } = t, D = _e(), y = Zi(t), {
    state: x,
    activeSectionIndex: v,
    parsedSelectedSections: P,
    setSelectedSections: T,
    clearValue: S,
    clearActiveSection: k,
    updateSectionValue: M,
    setTempAndroidValueStr: w,
    sectionsValueBoundaries: q,
    localizedDigits: B,
    timezone: O
  } = y, V = Ji({
    sections: x.sections,
    updateSectionValue: M,
    sectionsValueBoundaries: q,
    localizedDigits: B,
    setTempAndroidValueStr: w,
    timezone: O
  }), {
    resetCharacterQuery: N
  } = V, A = g.areValuesEqual(o, x.value, g.emptyValue), F = s ? el : ol, L = C.useMemo(() => ps(x.sections, D && !s), [x.sections, D, s]), {
    returnedValue: ee,
    interactions: Q
  } = F(b({}, t, y, V, {
    areAllSectionsEmpty: A,
    sectionOrder: L
  })), ae = Z(($) => {
    if (c == null || c($), !i)
      switch (!0) {
        case (($.ctrlKey || $.metaKey) && String.fromCharCode($.keyCode) === "A" && !$.shiftKey && !$.altKey): {
          $.preventDefault(), T("all");
          break;
        }
        case $.key === "ArrowRight": {
          if ($.preventDefault(), P == null)
            T(L.startIndex);
          else if (P === "all")
            T(L.endIndex);
          else {
            const X = L.neighbors[P].rightIndex;
            X !== null && T(X);
          }
          break;
        }
        case $.key === "ArrowLeft": {
          if ($.preventDefault(), P == null)
            T(L.endIndex);
          else if (P === "all")
            T(L.startIndex);
          else {
            const X = L.neighbors[P].leftIndex;
            X !== null && T(X);
          }
          break;
        }
        case $.key === "Delete": {
          if ($.preventDefault(), l)
            break;
          P == null || P === "all" ? S() : k(), N();
          break;
        }
        case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes($.key): {
          if ($.preventDefault(), l || v == null)
            break;
          const X = x.sections[v], H = d.getActiveDateManager(o, x, X), E = fs(o, O, X, $.key, q, B, H.date, {
            minutesStep: a
          });
          M({
            activeSection: X,
            newSectionValue: E,
            shouldGoToNextSection: !1
          });
          break;
        }
      }
  });
  Ye(() => {
    Q.syncSelectionToDOM();
  });
  const {
    hasValidationError: se
  } = ir({
    props: n,
    validator: h,
    timezone: O,
    value: x.value,
    onError: n.onError
  }), re = C.useMemo(() => p !== void 0 ? p : se, [se, p]);
  C.useEffect(() => {
    !re && v == null && N();
  }, [x.referenceValue, v, re]), C.useEffect(() => {
    x.tempValueStrAndroid != null && v != null && (N(), k());
  }, [x.sections]), C.useImperativeHandle(r, () => ({
    getSections: () => x.sections,
    getActiveSectionIndex: Q.getActiveSectionIndexFromDOM,
    setSelectedSections: Q.setSelectedSections,
    focusField: Q.focusField,
    isFieldFocused: Q.isFieldFocused
  }));
  const ce = Z(($, ...X) => {
    $.preventDefault(), f == null || f($, ...X), S(), Q.isFieldFocused() ? T(L.startIndex) : Q.focusField(0);
  }), ye = {
    onKeyDown: ae,
    onClear: ce,
    error: re,
    clearable: !!(m && !A && !l && !i)
  }, de = {
    disabled: i,
    readOnly: l
  };
  return b({}, t.forwardedProps, ye, de, ee);
}, nl = ["clearable", "onClear", "InputProps", "sx", "slots", "slotProps"], rl = ["ownerState"], Lo = (t) => {
  const o = ke(), {
    clearable: n,
    onClear: r,
    InputProps: a,
    sx: s,
    slots: i,
    slotProps: l
  } = t, c = ne(t, nl), p = (i == null ? void 0 : i.clearButton) ?? Io, m = pe({
    elementType: p,
    externalSlotProps: l == null ? void 0 : l.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: o.fieldClearLabel
    }
  }), f = ne(m, rl), d = (i == null ? void 0 : i.clearIcon) ?? ms, g = pe({
    elementType: d,
    externalSlotProps: l == null ? void 0 : l.clearIcon,
    ownerState: {}
  });
  return b({}, c, {
    InputProps: b({}, a, {
      endAdornment: /* @__PURE__ */ z(C.Fragment, {
        children: [n && /* @__PURE__ */ u(Xn, {
          position: "end",
          sx: {
            marginRight: a != null && a.endAdornment ? -1 : -1.5
          },
          children: /* @__PURE__ */ u(p, b({}, f, {
            onClick: r,
            children: /* @__PURE__ */ u(d, b({
              fontSize: "small"
            }, g))
          }))
        }), a == null ? void 0 : a.endAdornment]
      })
    }),
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(s) ? s : [s]]
  });
}, al = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef", "enableAccessibleFieldDOMStructure", "disabled", "readOnly", "dateSeparator"], $o = (t, o) => C.useMemo(() => {
  const n = b({}, t), r = {}, a = (s) => {
    n.hasOwnProperty(s) && (r[s] = n[s], delete n[s]);
  };
  return al.forEach(a), o === "date" ? ho.forEach(a) : o === "time" ? go.forEach(a) : o === "date-time" && (ho.forEach(a), go.forEach(a), sr.forEach(a)), {
    forwardedProps: n,
    internalProps: r
  };
}, [t, o]), sl = /* @__PURE__ */ C.createContext(null);
function lr(t) {
  const {
    contextValue: o,
    localeText: n,
    children: r
  } = t;
  return /* @__PURE__ */ u(sl.Provider, {
    value: o,
    children: /* @__PURE__ */ u(bs, {
      localeText: n,
      children: r
    })
  });
}
const il = (t) => {
  const o = ue(), n = et();
  return b({}, t, {
    disablePast: t.disablePast ?? !1,
    disableFuture: t.disableFuture ?? !1,
    format: t.format ?? o.formats.keyboardDate,
    minDate: Se(o, t.minDate, n.minDate),
    maxDate: Se(o, t.maxDate, n.maxDate)
  });
}, ll = (t) => {
  const o = ue(), r = t.ampm ?? o.is12HourCycleInCurrentLocale() ? o.formats.fullTime12h : o.formats.fullTime24h;
  return b({}, t, {
    disablePast: t.disablePast ?? !1,
    disableFuture: t.disableFuture ?? !1,
    format: t.format ?? r
  });
}, cl = (t) => {
  const o = ue(), n = et(), a = t.ampm ?? o.is12HourCycleInCurrentLocale() ? o.formats.keyboardDateTime12h : o.formats.keyboardDateTime24h;
  return b({}, t, {
    disablePast: t.disablePast ?? !1,
    disableFuture: t.disableFuture ?? !1,
    format: t.format ?? a,
    disableIgnoringDatePartForTimeValidation: !!(t.minDateTime || t.maxDateTime),
    minDate: Se(o, t.minDateTime ?? t.minDate, n.minDate),
    maxDate: Se(o, t.maxDateTime ?? t.maxDate, n.maxDate),
    minTime: t.minDateTime ?? t.minTime,
    maxTime: t.maxDateTime ?? t.maxTime
  });
}, ul = (t) => {
  const o = il(t), {
    forwardedProps: n,
    internalProps: r
  } = $o(o, "date");
  return Eo({
    forwardedProps: n,
    internalProps: r,
    valueManager: xe,
    fieldValueManager: xo,
    validator: bt,
    valueType: "date"
  });
};
function dl(t) {
  return ge("MuiPickersTextField", t);
}
he("MuiPickersTextField", ["root", "focused", "disabled", "error", "required"]);
function pl(t) {
  return ge("MuiPickersInputBase", t);
}
const it = he("MuiPickersInputBase", ["root", "focused", "disabled", "error", "notchedOutline", "sectionContent", "sectionBefore", "sectionAfter", "adornedStart", "adornedEnd", "input"]);
function fl(t) {
  return ge("MuiPickersSectionList", t);
}
const Dt = he("MuiPickersSectionList", ["root", "section", "sectionContent"]), ml = ["slots", "slotProps", "elements", "sectionListRef"], cr = _("div", {
  name: "MuiPickersSectionList",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({
  direction: "ltr /*! @noflip */",
  outline: "none"
}), ur = _("span", {
  name: "MuiPickersSectionList",
  slot: "Section",
  overridesResolver: (t, o) => o.section
})({}), dr = _("span", {
  name: "MuiPickersSectionList",
  slot: "SectionSeparator",
  overridesResolver: (t, o) => o.sectionSeparator
})({
  whiteSpace: "pre"
}), pr = _("span", {
  name: "MuiPickersSectionList",
  slot: "SectionContent",
  overridesResolver: (t, o) => o.sectionContent
})({
  outline: "none"
}), bl = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"],
    section: ["section"],
    sectionContent: ["sectionContent"]
  }, fl, o);
};
function fr(t) {
  const {
    slots: o,
    slotProps: n,
    element: r,
    classes: a
  } = t, s = (o == null ? void 0 : o.section) ?? ur, i = pe({
    elementType: s,
    externalSlotProps: n == null ? void 0 : n.section,
    externalForwardedProps: r.container,
    className: a.section,
    ownerState: {}
  }), l = (o == null ? void 0 : o.sectionContent) ?? pr, c = pe({
    elementType: l,
    externalSlotProps: n == null ? void 0 : n.sectionContent,
    externalForwardedProps: r.content,
    additionalProps: {
      suppressContentEditableWarning: !0
    },
    className: a.sectionContent,
    ownerState: {}
  }), p = (o == null ? void 0 : o.sectionSeparator) ?? dr, m = pe({
    elementType: p,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: r.before,
    ownerState: {
      position: "before"
    }
  }), f = pe({
    elementType: p,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: r.after,
    ownerState: {
      position: "after"
    }
  });
  return /* @__PURE__ */ z(s, b({}, i, {
    children: [/* @__PURE__ */ u(p, b({}, m)), /* @__PURE__ */ u(l, b({}, c)), /* @__PURE__ */ u(p, b({}, f))]
  }));
}
process.env.NODE_ENV !== "production" && (fr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: e.object.isRequired,
  element: e.shape({
    after: e.object.isRequired,
    before: e.object.isRequired,
    container: e.object.isRequired,
    content: e.object.isRequired
  }).isRequired,
  /**
   * The props used for each component slot.
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   */
  slots: e.object
});
const mr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiPickersSectionList"
  }), {
    slots: a,
    slotProps: s,
    elements: i,
    sectionListRef: l
  } = r, c = ne(r, ml), p = bl(r), m = C.useRef(null), f = Le(n, m), d = (D) => {
    if (!m.current)
      throw new Error(`MUI X: Cannot call sectionListRef.${D} before the mount of the component.`);
    return m.current;
  };
  C.useImperativeHandle(l, () => ({
    getRoot() {
      return d("getRoot");
    },
    getSectionContainer(D) {
      return d("getSectionContainer").querySelector(`.${Dt.section}[data-sectionindex="${D}"]`);
    },
    getSectionContent(D) {
      return d("getSectionContent").querySelector(`.${Dt.section}[data-sectionindex="${D}"] .${Dt.sectionContent}`);
    },
    getSectionIndexFromDOMElement(D) {
      const y = d("getSectionIndexFromDOMElement");
      if (D == null || !y.contains(D))
        return null;
      let x = null;
      return D.classList.contains(Dt.section) ? x = D : D.classList.contains(Dt.sectionContent) && (x = D.parentElement), x == null ? null : Number(x.dataset.sectionindex);
    }
  }));
  const g = (a == null ? void 0 : a.root) ?? cr, h = pe({
    elementType: g,
    externalSlotProps: s == null ? void 0 : s.root,
    externalForwardedProps: c,
    additionalProps: {
      ref: f,
      suppressContentEditableWarning: !0
    },
    className: p.root,
    ownerState: {}
  });
  return /* @__PURE__ */ u(g, b({}, h, {
    children: h.contentEditable ? i.map(({
      content: D,
      before: y,
      after: x
    }) => `${y.children}${D.children}${x.children}`).join("") : /* @__PURE__ */ u(C.Fragment, {
      children: i.map((D, y) => /* @__PURE__ */ u(fr, {
        slots: a,
        slotProps: s,
        element: D,
        classes: p
      }, y))
    })
  }));
});
process.env.NODE_ENV !== "production" && (mr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: e.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: e.arrayOf(e.shape({
    after: e.object.isRequired,
    before: e.object.isRequired,
    container: e.object.isRequired,
    content: e.object.isRequired
  })).isRequired,
  sectionListRef: e.oneOfType([e.func, e.shape({
    current: e.shape({
      getRoot: e.func.isRequired,
      getSectionContainer: e.func.isRequired,
      getSectionContent: e.func.isRequired,
      getSectionIndexFromDOMElement: e.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   */
  slots: e.object
});
const hl = ["elements", "areAllSectionsEmpty", "defaultValue", "label", "value", "onChange", "id", "autoFocus", "endAdornment", "startAdornment", "renderSuffix", "slots", "slotProps", "contentEditable", "tabIndex", "onInput", "onPaste", "onKeyDown", "fullWidth", "name", "readOnly", "inputProps", "inputRef", "sectionListRef"], gl = (t) => Math.round(t * 1e5) / 1e5, oo = _("div", {
  name: "MuiPickersInputBase",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})(({
  theme: t
}) => b({}, t.typography.body1, {
  color: (t.vars || t).palette.text.primary,
  cursor: "text",
  padding: 0,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  letterSpacing: `${gl(0.15 / 16)}em`,
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
})), jo = _(cr, {
  name: "MuiPickersInputBase",
  slot: "SectionsContainer",
  overridesResolver: (t, o) => o.sectionsContainer
})(({
  theme: t
}) => ({
  padding: "4px 0 5px",
  fontFamily: t.typography.fontFamily,
  fontSize: "inherit",
  lineHeight: "1.4375em",
  // 23px
  flexGrow: 1,
  outline: "none",
  display: "flex",
  flexWrap: "nowrap",
  overflow: "hidden",
  letterSpacing: "inherit",
  // Baseline behavior
  width: "182px",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      textAlign: "right /*! @noflip */"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingTop: 1
    }
  }, {
    props: {
      adornedStart: !1,
      focused: !1,
      filled: !1
    },
    style: {
      color: "currentColor",
      opacity: 0
    }
  }, {
    // Can't use the object notation because label can be null or undefined
    props: ({
      adornedStart: o,
      focused: n,
      filled: r,
      label: a
    }) => !o && !n && !r && a == null,
    style: t.vars ? {
      opacity: t.vars.opacity.inputPlaceholder
    } : {
      opacity: t.palette.mode === "light" ? 0.42 : 0.5
    }
  }]
})), yl = _(ur, {
  name: "MuiPickersInputBase",
  slot: "Section",
  overridesResolver: (t, o) => o.section
})(({
  theme: t
}) => ({
  fontFamily: t.typography.fontFamily,
  fontSize: "inherit",
  letterSpacing: "inherit",
  lineHeight: "1.4375em",
  // 23px
  display: "flex"
})), Dl = _(pr, {
  name: "MuiPickersInputBase",
  slot: "SectionContent",
  overridesResolver: (t, o) => o.content
})(({
  theme: t
}) => ({
  fontFamily: t.typography.fontFamily,
  lineHeight: "1.4375em",
  // 23px
  letterSpacing: "inherit",
  width: "fit-content",
  outline: "none"
})), Cl = _(dr, {
  name: "MuiPickersInputBase",
  slot: "Separator",
  overridesResolver: (t, o) => o.separator
})(() => ({
  whiteSpace: "pre",
  letterSpacing: "inherit"
})), vl = _("input", {
  name: "MuiPickersInputBase",
  slot: "Input",
  overridesResolver: (t, o) => o.hiddenInput
})(b({}, ji)), wl = (t) => {
  const {
    focused: o,
    disabled: n,
    error: r,
    classes: a,
    fullWidth: s,
    readOnly: i,
    color: l,
    size: c,
    endAdornment: p,
    startAdornment: m
  } = t, f = {
    root: ["root", o && !n && "focused", n && "disabled", i && "readOnly", r && "error", s && "fullWidth", `color${$i(l)}`, c === "small" && "inputSizeSmall", !!m && "adornedStart", !!p && "adornedEnd"],
    notchedOutline: ["notchedOutline"],
    input: ["input"],
    sectionsContainer: ["sectionsContainer"],
    sectionContent: ["sectionContent"],
    sectionBefore: ["sectionBefore"],
    sectionAfter: ["sectionAfter"]
  };
  return me(f, pl, a);
}, no = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiPickersInputBase"
  }), {
    elements: a,
    areAllSectionsEmpty: s,
    value: i,
    onChange: l,
    id: c,
    endAdornment: p,
    startAdornment: m,
    renderSuffix: f,
    slots: d,
    slotProps: g,
    contentEditable: h,
    tabIndex: D,
    onInput: y,
    onPaste: x,
    onKeyDown: v,
    name: P,
    readOnly: T,
    inputProps: S,
    inputRef: k,
    sectionListRef: M
  } = r, w = ne(r, hl), q = C.useRef(null), B = Le(n, q), O = Le(S == null ? void 0 : S.ref, k), V = _e(), N = Gt();
  if (!N)
    throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
  const A = (se) => {
    var re;
    if (N.disabled) {
      se.stopPropagation();
      return;
    }
    (re = N.onFocus) == null || re.call(N, se);
  };
  C.useEffect(() => {
    N && N.setAdornedStart(!!m);
  }, [N, m]), C.useEffect(() => {
    N && (s ? N.onEmpty() : N.onFilled());
  }, [N, s]);
  const F = b({}, r, N, {
    isRtl: V
  }), L = wl(F), ee = (d == null ? void 0 : d.root) || oo, Q = pe({
    elementType: ee,
    externalSlotProps: g == null ? void 0 : g.root,
    externalForwardedProps: w,
    additionalProps: {
      "aria-invalid": N.error,
      ref: B
    },
    className: L.root,
    ownerState: F
  }), ae = (d == null ? void 0 : d.input) || jo;
  return /* @__PURE__ */ z(ee, b({}, Q, {
    children: [m, /* @__PURE__ */ u(mr, {
      sectionListRef: M,
      elements: a,
      contentEditable: h,
      tabIndex: D,
      className: L.sectionsContainer,
      onFocus: A,
      onBlur: N.onBlur,
      onInput: y,
      onPaste: x,
      onKeyDown: v,
      slots: {
        root: ae,
        section: yl,
        sectionContent: Dl,
        sectionSeparator: Cl
      },
      slotProps: {
        root: {
          ownerState: F
        },
        sectionContent: {
          className: it.sectionContent
        },
        sectionSeparator: ({
          position: se
        }) => ({
          className: se === "before" ? it.sectionBefore : it.sectionAfter
        })
      }
    }), p, f ? f(b({}, N)) : null, /* @__PURE__ */ u(vl, b({
      name: P,
      className: L.input,
      value: i,
      onChange: l,
      id: c,
      "aria-hidden": "true",
      tabIndex: -1,
      readOnly: T,
      required: N.required,
      disabled: N.disabled
    }, S, {
      ref: O
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (no.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: e.bool.isRequired,
  className: e.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: e.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: e.arrayOf(e.shape({
    after: e.object.isRequired,
    before: e.object.isRequired,
    container: e.object.isRequired,
    content: e.object.isRequired
  })).isRequired,
  endAdornment: e.node,
  fullWidth: e.bool,
  id: e.string,
  inputProps: e.object,
  inputRef: Pe,
  label: e.node,
  margin: e.oneOf(["dense", "none", "normal"]),
  name: e.string,
  onChange: e.func.isRequired,
  onClick: e.func.isRequired,
  onInput: e.func.isRequired,
  onKeyDown: e.func.isRequired,
  onPaste: e.func.isRequired,
  ownerState: e.any,
  readOnly: e.bool,
  renderSuffix: e.func,
  sectionListRef: e.oneOfType([e.func, e.shape({
    current: e.shape({
      getRoot: e.func.isRequired,
      getSectionContainer: e.func.isRequired,
      getSectionContent: e.func.isRequired,
      getSectionIndexFromDOMElement: e.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: e.object,
  startAdornment: e.node,
  style: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  value: e.string.isRequired
});
function Tl(t) {
  return ge("MuiPickersOutlinedInput", t);
}
const Ne = b({}, it, he("MuiPickersOutlinedInput", ["root", "notchedOutline", "input"])), xl = ["children", "className", "label", "notched", "shrink"], Pl = _("fieldset", {
  name: "MuiPickersOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (t, o) => o.notchedOutline
})(({
  theme: t
}) => {
  const o = t.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%",
    borderColor: t.vars ? `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.23)` : o
  };
}), hn = _("span")(({
  theme: t
}) => ({
  fontFamily: t.typography.fontFamily,
  fontSize: "inherit"
})), Sl = _("legend")(({
  theme: t
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: {
      withLabel: !1
    },
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: t.transitions.create("width", {
        duration: 150,
        easing: t.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      withLabel: !0
    },
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: t.transitions.create("max-width", {
        duration: 50,
        easing: t.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: {
      withLabel: !0,
      notched: !0
    },
    style: {
      maxWidth: "100%",
      transition: t.transitions.create("max-width", {
        duration: 100,
        easing: t.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
}));
function kl(t) {
  const {
    className: o,
    label: n
  } = t, r = ne(t, xl), a = n != null && n !== "", s = b({}, t, {
    withLabel: a
  });
  return /* @__PURE__ */ u(Pl, b({
    "aria-hidden": !0,
    className: o
  }, r, {
    ownerState: s,
    children: /* @__PURE__ */ u(Sl, {
      ownerState: s,
      children: a ? /* @__PURE__ */ u(hn, {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        /* @__PURE__ */ u(hn, {
          className: "notranslate",
          children: "​"
        })
      )
    })
  }));
}
const Rl = ["label", "autoFocus", "ownerState", "notched"], Ml = _(oo, {
  name: "MuiPickersOutlinedInput",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})(({
  theme: t
}) => {
  const o = t.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    padding: "0 14px",
    borderRadius: (t.vars || t).shape.borderRadius,
    [`&:hover .${Ne.notchedOutline}`]: {
      borderColor: (t.vars || t).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Ne.notchedOutline}`]: {
        borderColor: t.vars ? `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.23)` : o
      }
    },
    [`&.${Ne.focused} .${Ne.notchedOutline}`]: {
      borderStyle: "solid",
      borderWidth: 2
    },
    [`&.${Ne.disabled}`]: {
      [`& .${Ne.notchedOutline}`]: {
        borderColor: (t.vars || t).palette.action.disabled
      },
      "*": {
        color: (t.vars || t).palette.action.disabled
      }
    },
    [`&.${Ne.error} .${Ne.notchedOutline}`]: {
      borderColor: (t.vars || t).palette.error.main
    },
    variants: Object.keys((t.vars ?? t).palette).filter((n) => {
      var r;
      return ((r = (t.vars ?? t).palette[n]) == null ? void 0 : r.main) ?? !1;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        [`&.${Ne.focused}:not(.${Ne.error}) .${Ne.notchedOutline}`]: {
          // @ts-ignore
          borderColor: (t.vars || t).palette[n].main
        }
      }
    }))
  };
}), Ol = _(jo, {
  name: "MuiPickersOutlinedInput",
  slot: "SectionsContainer",
  overridesResolver: (t, o) => o.sectionsContainer
})({
  padding: "16.5px 0",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 0"
    }
  }]
}), Fl = (t) => {
  const {
    classes: o
  } = t, r = me({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, Tl, o);
  return b({}, o, r);
}, Bo = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiPickersOutlinedInput"
  }), {
    label: a,
    ownerState: s,
    notched: i
  } = r, l = ne(r, Rl), c = Gt(), p = b({}, r, s, c, {
    color: (c == null ? void 0 : c.color) || "primary"
  }), m = Fl(p);
  return /* @__PURE__ */ u(no, b({
    slots: {
      root: Ml,
      input: Ol
    },
    renderSuffix: (f) => /* @__PURE__ */ u(kl, {
      shrink: !!(i || f.adornedStart || f.focused || f.filled),
      notched: !!(i || f.adornedStart || f.focused || f.filled),
      className: m.notchedOutline,
      label: a != null && a !== "" && (c != null && c.required) ? /* @__PURE__ */ z(C.Fragment, {
        children: [a, " ", "*"]
      }) : a,
      ownerState: p
    })
  }, l, {
    label: a,
    classes: m,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (Bo.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: e.bool.isRequired,
  className: e.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: e.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: e.arrayOf(e.shape({
    after: e.object.isRequired,
    before: e.object.isRequired,
    container: e.object.isRequired,
    content: e.object.isRequired
  })).isRequired,
  endAdornment: e.node,
  fullWidth: e.bool,
  id: e.string,
  inputProps: e.object,
  inputRef: Pe,
  label: e.node,
  margin: e.oneOf(["dense", "none", "normal"]),
  name: e.string,
  notched: e.bool,
  onChange: e.func.isRequired,
  onClick: e.func.isRequired,
  onInput: e.func.isRequired,
  onKeyDown: e.func.isRequired,
  onPaste: e.func.isRequired,
  ownerState: e.any,
  readOnly: e.bool,
  renderSuffix: e.func,
  sectionListRef: e.oneOfType([e.func, e.shape({
    current: e.shape({
      getRoot: e.func.isRequired,
      getSectionContainer: e.func.isRequired,
      getSectionContent: e.func.isRequired,
      getSectionIndexFromDOMElement: e.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: e.object,
  startAdornment: e.node,
  style: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  value: e.string.isRequired
});
Bo.muiName = "Input";
function Il(t) {
  return ge("MuiPickersFilledInput", t);
}
const Qe = b({}, it, he("MuiPickersFilledInput", ["root", "underline", "input"])), Vl = ["label", "autoFocus", "disableUnderline", "ownerState"], Al = _(oo, {
  name: "MuiPickersFilledInput",
  slot: "Root",
  overridesResolver: (t, o) => o.root,
  shouldForwardProp: (t) => Ei(t) && t !== "disableUnderline"
})(({
  theme: t
}) => {
  const o = t.palette.mode === "light", n = o ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = o ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", a = o ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", s = o ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    backgroundColor: t.vars ? t.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (t.vars || t).shape.borderRadius,
    borderTopRightRadius: (t.vars || t).shape.borderRadius,
    transition: t.transitions.create("background-color", {
      duration: t.transitions.duration.shorter,
      easing: t.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: t.vars ? t.vars.palette.FilledInput.hoverBg : a,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: t.vars ? t.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${Qe.focused}`]: {
      backgroundColor: t.vars ? t.vars.palette.FilledInput.bg : r
    },
    [`&.${Qe.disabled}`]: {
      backgroundColor: t.vars ? t.vars.palette.FilledInput.disabledBg : s
    },
    variants: [...Object.keys((t.vars ?? t).palette).filter((i) => (t.vars ?? t).palette[i].main).map((i) => {
      var l;
      return {
        props: {
          color: i,
          disableUnderline: !1
        },
        style: {
          "&::after": {
            // @ts-ignore
            borderBottom: `2px solid ${(l = (t.vars || t).palette[i]) == null ? void 0 : l.main}`
          }
        }
      };
    }), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: t.transitions.create("transform", {
            duration: t.transitions.duration.shorter,
            easing: t.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Qe.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Qe.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (t.vars || t).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${t.vars ? `rgba(${t.vars.palette.common.onBackgroundChannel} / ${t.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: t.transitions.create("border-bottom-color", {
            duration: t.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Qe.disabled}, .${Qe.error}):before`]: {
          borderBottom: `1px solid ${(t.vars || t).palette.text.primary}`
        },
        [`&.${Qe.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, {
      props: ({
        startAdornment: i
      }) => !!i,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        endAdornment: i
      }) => !!i,
      style: {
        paddingRight: 12
      }
    }]
  };
}), El = _(jo, {
  name: "MuiPickersFilledInput",
  slot: "sectionsContainer",
  overridesResolver: (t, o) => o.sectionsContainer
})({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      startAdornment: t
    }) => !!t,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      endAdornment: t
    }) => !!t,
    style: {
      paddingRight: 0
    }
  }, {
    props: {
      hiddenLabel: !0
    },
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: {
      hiddenLabel: !0,
      size: "small"
    },
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }]
}), Ll = (t) => {
  const {
    classes: o,
    disableUnderline: n
  } = t, a = me({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, Il, o);
  return b({}, o, a);
}, No = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiPickersFilledInput"
  }), {
    label: a,
    disableUnderline: s = !1,
    ownerState: i
  } = r, l = ne(r, Vl), c = Gt(), p = b({}, r, i, c, {
    color: (c == null ? void 0 : c.color) || "primary"
  }), m = Ll(p);
  return /* @__PURE__ */ u(no, b({
    slots: {
      root: Al,
      input: El
    },
    slotProps: {
      root: {
        disableUnderline: s
      }
    }
  }, l, {
    label: a,
    classes: m,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (No.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: e.bool.isRequired,
  className: e.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: e.bool.isRequired,
  disableUnderline: e.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: e.arrayOf(e.shape({
    after: e.object.isRequired,
    before: e.object.isRequired,
    container: e.object.isRequired,
    content: e.object.isRequired
  })).isRequired,
  endAdornment: e.node,
  fullWidth: e.bool,
  hiddenLabel: e.bool,
  id: e.string,
  inputProps: e.object,
  inputRef: Pe,
  label: e.node,
  margin: e.oneOf(["dense", "none", "normal"]),
  name: e.string,
  onChange: e.func.isRequired,
  onClick: e.func.isRequired,
  onInput: e.func.isRequired,
  onKeyDown: e.func.isRequired,
  onPaste: e.func.isRequired,
  ownerState: e.any,
  readOnly: e.bool,
  renderSuffix: e.func,
  sectionListRef: e.oneOfType([e.func, e.shape({
    current: e.shape({
      getRoot: e.func.isRequired,
      getSectionContainer: e.func.isRequired,
      getSectionContent: e.func.isRequired,
      getSectionIndexFromDOMElement: e.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: e.object,
  startAdornment: e.node,
  style: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  value: e.string.isRequired
});
No.muiName = "Input";
function $l(t) {
  return ge("MuiPickersFilledInput", t);
}
const Ct = b({}, it, he("MuiPickersInput", ["root", "input"])), jl = ["label", "autoFocus", "disableUnderline", "ownerState"], Bl = _(oo, {
  name: "MuiPickersInput",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})(({
  theme: t
}) => {
  let n = t.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return t.vars && (n = `rgba(${t.vars.palette.common.onBackgroundChannel} / ${t.vars.opacity.inputUnderline})`), {
    "label + &": {
      marginTop: 16
    },
    variants: [...Object.keys((t.vars ?? t).palette).filter((r) => (t.vars ?? t).palette[r].main).map((r) => ({
      props: {
        color: r
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(t.vars || t).palette[r].main}`
        }
      }
    })), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          background: "red",
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: t.transitions.create("transform", {
            duration: t.transitions.duration.shorter,
            easing: t.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Ct.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Ct.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (t.vars || t).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: t.transitions.create("border-bottom-color", {
            duration: t.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Ct.disabled}, .${Ct.error}):before`]: {
          borderBottom: `2px solid ${(t.vars || t).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${Ct.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }]
  };
}), Nl = (t) => {
  const {
    classes: o,
    disableUnderline: n
  } = t, a = me({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, $l, o);
  return b({}, o, a);
}, qo = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiPickersInput"
  }), {
    label: a,
    disableUnderline: s = !1,
    ownerState: i
  } = r, l = ne(r, jl), c = Gt(), p = b({}, r, i, c, {
    disableUnderline: s,
    color: (c == null ? void 0 : c.color) || "primary"
  }), m = Nl(p);
  return /* @__PURE__ */ u(no, b({
    slots: {
      root: Bl
    }
  }, l, {
    label: a,
    classes: m,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (qo.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: e.bool.isRequired,
  className: e.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: e.bool.isRequired,
  disableUnderline: e.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: e.arrayOf(e.shape({
    after: e.object.isRequired,
    before: e.object.isRequired,
    container: e.object.isRequired,
    content: e.object.isRequired
  })).isRequired,
  endAdornment: e.node,
  fullWidth: e.bool,
  id: e.string,
  inputProps: e.object,
  inputRef: Pe,
  label: e.node,
  margin: e.oneOf(["dense", "none", "normal"]),
  name: e.string,
  onChange: e.func.isRequired,
  onClick: e.func.isRequired,
  onInput: e.func.isRequired,
  onKeyDown: e.func.isRequired,
  onPaste: e.func.isRequired,
  ownerState: e.any,
  readOnly: e.bool,
  renderSuffix: e.func,
  sectionListRef: e.oneOfType([e.func, e.shape({
    current: e.shape({
      getRoot: e.func.isRequired,
      getSectionContainer: e.func.isRequired,
      getSectionContent: e.func.isRequired,
      getSectionIndexFromDOMElement: e.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: e.object,
  startAdornment: e.node,
  style: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  value: e.string.isRequired
});
qo.muiName = "Input";
const ql = ["onFocus", "onBlur", "className", "color", "disabled", "error", "variant", "required", "InputProps", "inputProps", "inputRef", "sectionListRef", "elements", "areAllSectionsEmpty", "onClick", "onKeyDown", "onKeyUp", "onPaste", "onInput", "endAdornment", "startAdornment", "tabIndex", "contentEditable", "focused", "value", "onChange", "fullWidth", "id", "name", "helperText", "FormHelperTextProps", "label", "InputLabelProps"], Wl = {
  standard: qo,
  filled: No,
  outlined: Bo
}, _l = _(Es, {
  name: "MuiPickersTextField",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({}), Hl = (t) => {
  const {
    focused: o,
    disabled: n,
    classes: r,
    required: a
  } = t;
  return me({
    root: ["root", o && !n && "focused", n && "disabled", a && "required"]
  }, dl, r);
}, ro = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiPickersTextField"
  }), {
    // Props used by FormControl
    onFocus: a,
    onBlur: s,
    className: i,
    color: l = "primary",
    disabled: c = !1,
    error: p = !1,
    variant: m = "outlined",
    required: f = !1,
    // Props used by PickersInput
    InputProps: d,
    inputProps: g,
    inputRef: h,
    sectionListRef: D,
    elements: y,
    areAllSectionsEmpty: x,
    onClick: v,
    onKeyDown: P,
    onKeyUp: T,
    onPaste: S,
    onInput: k,
    endAdornment: M,
    startAdornment: w,
    tabIndex: q,
    contentEditable: B,
    focused: O,
    value: V,
    onChange: N,
    fullWidth: A,
    id: F,
    name: L,
    // Props used by FormHelperText
    helperText: ee,
    FormHelperTextProps: Q,
    // Props used by InputLabel
    label: ae,
    InputLabelProps: se
  } = r, re = ne(r, ql), ce = C.useRef(null), ye = Le(n, ce), de = Ft(F), $ = ee && de ? `${de}-helper-text` : void 0, X = ae && de ? `${de}-label` : void 0, H = b({}, r, {
    color: l,
    disabled: c,
    error: p,
    focused: O,
    required: f,
    variant: m
  }), E = Hl(H), I = Wl[m];
  return /* @__PURE__ */ z(_l, b({
    className: Ce(E.root, i),
    ref: ye,
    focused: O,
    onFocus: a,
    onBlur: s,
    disabled: c,
    variant: m,
    error: p,
    color: l,
    fullWidth: A,
    required: f,
    ownerState: H
  }, re, {
    children: [/* @__PURE__ */ u(Vs, b({
      htmlFor: de,
      id: X
    }, se, {
      children: ae
    })), /* @__PURE__ */ u(I, b({
      elements: y,
      areAllSectionsEmpty: x,
      onClick: v,
      onKeyDown: P,
      onKeyUp: T,
      onInput: k,
      onPaste: S,
      endAdornment: M,
      startAdornment: w,
      tabIndex: q,
      contentEditable: B,
      value: V,
      onChange: N,
      id: de,
      fullWidth: A,
      inputProps: g,
      inputRef: h,
      sectionListRef: D,
      label: ae,
      name: L,
      role: "group",
      "aria-labelledby": X
    }, d)), ee && /* @__PURE__ */ u(As, b({
      id: $
    }, Q, {
      children: ee
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (ro.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: e.bool.isRequired,
  className: e.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: e.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: e.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: e.bool.isRequired,
  disabled: e.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: e.arrayOf(e.shape({
    after: e.object.isRequired,
    before: e.object.isRequired,
    container: e.object.isRequired,
    content: e.object.isRequired
  })).isRequired,
  endAdornment: e.node,
  error: e.bool.isRequired,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: e.bool,
  FormHelperTextProps: e.object,
  fullWidth: e.bool,
  /**
   * The helper text content.
   */
  helperText: e.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: e.bool,
  id: e.string,
  InputLabelProps: e.object,
  inputProps: e.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: e.object,
  inputRef: Pe,
  label: e.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: e.oneOf(["dense", "none", "normal"]),
  name: e.string,
  onBlur: e.func.isRequired,
  onChange: e.func.isRequired,
  onClick: e.func.isRequired,
  onFocus: e.func.isRequired,
  onInput: e.func.isRequired,
  onKeyDown: e.func.isRequired,
  onPaste: e.func.isRequired,
  readOnly: e.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: e.bool,
  sectionListRef: e.oneOfType([e.func, e.shape({
    current: e.shape({
      getRoot: e.func.isRequired,
      getSectionContainer: e.func.isRequired,
      getSectionContent: e.func.isRequired,
      getSectionIndexFromDOMElement: e.func.isRequired
    })
  })]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: e.oneOf(["medium", "small"]),
  startAdornment: e.node,
  style: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  value: e.string.isRequired,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: e.oneOf(["filled", "outlined", "standard"])
});
const zl = ["enableAccessibleFieldDOMStructure"], Ul = ["InputProps", "readOnly"], Yl = ["onPaste", "onKeyDown", "inputMode", "readOnly", "InputProps", "inputProps", "inputRef"], Wo = (t) => {
  let {
    enableAccessibleFieldDOMStructure: o
  } = t, n = ne(t, zl);
  if (o) {
    const {
      InputProps: f,
      readOnly: d
    } = n, g = ne(n, Ul);
    return b({}, g, {
      InputProps: b({}, f ?? {}, {
        readOnly: d
      })
    });
  }
  const {
    onPaste: r,
    onKeyDown: a,
    inputMode: s,
    readOnly: i,
    InputProps: l,
    inputProps: c,
    inputRef: p
  } = n, m = ne(n, Yl);
  return b({}, m, {
    InputProps: b({}, l ?? {}, {
      readOnly: i
    }),
    inputProps: b({}, c ?? {}, {
      inputMode: s,
      onPaste: r,
      onKeyDown: a,
      ref: p
    })
  });
}, Kl = ["slots", "slotProps", "InputProps", "inputProps"], _o = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiDateField"
  }), {
    slots: a,
    slotProps: s,
    InputProps: i,
    inputProps: l
  } = r, c = ne(r, Kl), p = r, m = (a == null ? void 0 : a.textField) ?? (o.enableAccessibleFieldDOMStructure ? ro : Vo), f = pe({
    elementType: m,
    externalSlotProps: s == null ? void 0 : s.textField,
    externalForwardedProps: c,
    additionalProps: {
      ref: n
    },
    ownerState: p
  });
  f.inputProps = b({}, l, f.inputProps), f.InputProps = b({}, i, f.InputProps);
  const d = ul(f), g = Wo(d), h = Lo(b({}, g, {
    slots: a,
    slotProps: s
  }));
  return /* @__PURE__ */ u(m, b({}, h));
});
process.env.NODE_ENV !== "production" && (_o.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: e.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: e.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: e.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: e.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: e.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: e.bool,
  /**
   * The helper text content.
   */
  helperText: e.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: e.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: e.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: e.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: e.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: e.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: e.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: e.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: e.object,
  /**
   * Name attribute of the `input` element.
   */
  name: e.string,
  onBlur: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  onFocus: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: e.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: e.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: e.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: e.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: e.bool,
  /**
   * The size of the component.
   */
  size: e.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  style: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: e.oneOfType([e.func, e.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: e.oneOf(["filled", "outlined", "standard"])
});
const Gl = (t) => {
  const o = ll(t), {
    forwardedProps: n,
    internalProps: r
  } = $o(o, "time");
  return Eo({
    forwardedProps: n,
    internalProps: r,
    valueManager: xe,
    fieldValueManager: xo,
    validator: It,
    valueType: "time"
  });
}, Ql = ["slots", "slotProps", "InputProps", "inputProps"], Ho = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiTimeField"
  }), {
    slots: a,
    slotProps: s,
    InputProps: i,
    inputProps: l
  } = r, c = ne(r, Ql), p = r, m = (a == null ? void 0 : a.textField) ?? (o.enableAccessibleFieldDOMStructure ? ro : Vo), f = pe({
    elementType: m,
    externalSlotProps: s == null ? void 0 : s.textField,
    externalForwardedProps: c,
    ownerState: p,
    additionalProps: {
      ref: n
    }
  });
  f.inputProps = b({}, l, f.inputProps), f.InputProps = b({}, i, f.InputProps);
  const d = Gl(f), g = Wo(d), h = Lo(b({}, g, {
    slots: a,
    slotProps: s
  }));
  return /* @__PURE__ */ u(m, b({}, h));
});
process.env.NODE_ENV !== "production" && (Ho.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: e.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: e.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: e.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: e.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: e.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: e.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: e.bool,
  /**
   * The helper text content.
   */
  helperText: e.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: e.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: e.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: e.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: e.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: e.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: e.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: e.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: e.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: e.number,
  /**
   * Name attribute of the `input` element.
   */
  name: e.string,
  onBlur: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  onFocus: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: e.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: e.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: e.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: e.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: e.bool,
  /**
   * The size of the component.
   */
  size: e.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  style: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: e.oneOfType([e.func, e.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: e.oneOf(["filled", "outlined", "standard"])
});
const Zl = (t) => {
  const o = cl(t), {
    forwardedProps: n,
    internalProps: r
  } = $o(o, "date-time");
  return Eo({
    forwardedProps: n,
    internalProps: r,
    valueManager: xe,
    fieldValueManager: xo,
    validator: to,
    valueType: "date-time"
  });
}, Xl = ["slots", "slotProps", "InputProps", "inputProps"], zo = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiDateTimeField"
  }), {
    slots: a,
    slotProps: s,
    InputProps: i,
    inputProps: l
  } = r, c = ne(r, Xl), p = r, m = (a == null ? void 0 : a.textField) ?? (o.enableAccessibleFieldDOMStructure ? ro : Vo), f = pe({
    elementType: m,
    externalSlotProps: s == null ? void 0 : s.textField,
    externalForwardedProps: c,
    ownerState: p,
    additionalProps: {
      ref: n
    }
  });
  f.inputProps = b({}, l, f.inputProps), f.InputProps = b({}, i, f.InputProps);
  const d = Zl(f), g = Wo(d), h = Lo(b({}, g, {
    slots: a,
    slotProps: s
  }));
  return /* @__PURE__ */ u(m, b({}, h));
});
process.env.NODE_ENV !== "production" && (zo.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: e.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: e.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: e.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: e.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: e.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: e.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: e.bool,
  /**
   * The helper text content.
   */
  helperText: e.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: e.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: e.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: e.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: e.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: e.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: e.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: e.object,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: e.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: e.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: e.object,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: e.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: e.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: e.number,
  /**
   * Name attribute of the `input` element.
   */
  name: e.string,
  onBlur: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  onFocus: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: e.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: e.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: e.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: e.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: e.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: e.bool,
  /**
   * The size of the component.
   */
  size: e.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  style: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: e.oneOfType([e.func, e.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: e.oneOf(["filled", "outlined", "standard"])
});
const br = ({
  shouldDisableDate: t,
  shouldDisableMonth: o,
  shouldDisableYear: n,
  minDate: r,
  maxDate: a,
  disableFuture: s,
  disablePast: i,
  timezone: l
}) => {
  const c = Ht();
  return C.useCallback((p) => bt({
    adapter: c,
    value: p,
    timezone: l,
    props: {
      shouldDisableDate: t,
      shouldDisableMonth: o,
      shouldDisableYear: n,
      minDate: r,
      maxDate: a,
      disableFuture: s,
      disablePast: i
    }
  }) !== null, [c, t, o, n, r, a, s, i, l]);
}, Jl = (t, o, n) => (r, a) => {
  switch (a.type) {
    case "changeMonth":
      return b({}, r, {
        slideDirection: a.direction,
        currentMonth: a.newMonth,
        isMonthSwitchingAnimating: !t
      });
    case "changeMonthTimezone": {
      const s = a.newTimezone;
      if (n.getTimezone(r.currentMonth) === s)
        return r;
      let i = n.setTimezone(r.currentMonth, s);
      return n.getMonth(i) !== n.getMonth(r.currentMonth) && (i = n.setMonth(i, n.getMonth(r.currentMonth))), b({}, r, {
        currentMonth: i
      });
    }
    case "finishMonthSwitchingAnimation":
      return b({}, r, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (r.focusedDay != null && a.focusedDay != null && n.isSameDay(a.focusedDay, r.focusedDay))
        return r;
      const s = a.focusedDay != null && !o && !n.isSameMonth(r.currentMonth, a.focusedDay);
      return b({}, r, {
        focusedDay: a.focusedDay,
        isMonthSwitchingAnimating: s && !t && !a.withoutMonthSwitchingAnimation,
        currentMonth: s ? n.startOfMonth(a.focusedDay) : r.currentMonth,
        slideDirection: a.focusedDay != null && n.isAfterDay(a.focusedDay, r.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, ec = (t) => {
  const {
    value: o,
    referenceDate: n,
    disableFuture: r,
    disablePast: a,
    disableSwitchToMonthOnDayFocus: s = !1,
    maxDate: i,
    minDate: l,
    onMonthChange: c,
    reduceAnimations: p,
    shouldDisableDate: m,
    timezone: f
  } = t, d = ue(), g = C.useRef(Jl(!!p, s, d)).current, h = C.useMemo(
    () => xe.getInitialReferenceValue({
      value: o,
      utils: d,
      timezone: f,
      props: t,
      referenceDate: n,
      granularity: Po.day
    }),
    // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, f]
  ), [D, y] = C.useReducer(g, {
    isMonthSwitchingAnimating: !1,
    focusedDay: h,
    currentMonth: d.startOfMonth(h),
    slideDirection: "left"
  });
  C.useEffect(() => {
    y({
      type: "changeMonthTimezone",
      newTimezone: d.getTimezone(h)
    });
  }, [h, d]);
  const x = C.useCallback((k) => {
    y(b({
      type: "changeMonth"
    }, k)), c && c(k.newMonth);
  }, [c]), v = C.useCallback((k) => {
    const M = k;
    d.isSameMonth(M, D.currentMonth) || x({
      newMonth: d.startOfMonth(M),
      direction: d.isAfterDay(M, D.currentMonth) ? "left" : "right"
    });
  }, [D.currentMonth, x, d]), P = br({
    shouldDisableDate: m,
    minDate: l,
    maxDate: i,
    disableFuture: r,
    disablePast: a,
    timezone: f
  }), T = C.useCallback(() => {
    y({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), S = Z((k, M) => {
    P(k) || y({
      type: "changeFocusedDay",
      focusedDay: k,
      withoutMonthSwitchingAnimation: M
    });
  });
  return {
    referenceDate: h,
    calendarState: D,
    changeMonth: v,
    changeFocusedDay: S,
    isDateDisabled: P,
    onMonthSwitchingAnimationEnd: T,
    handleChangeMonth: x
  };
}, tc = (t) => ge("MuiPickersFadeTransitionGroup", t);
he("MuiPickersFadeTransitionGroup", ["root"]);
const oc = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"]
  }, tc, o);
}, nc = _(Zn, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({
  display: "block",
  position: "relative"
});
function hr(t) {
  const o = le({
    props: t,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    children: n,
    className: r,
    reduceAnimations: a,
    transKey: s
  } = o, i = oc(o), l = Qn();
  return a ? n : /* @__PURE__ */ u(nc, {
    className: Ce(i.root, r),
    children: /* @__PURE__ */ u(Kt, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: l.transitions.duration.enteringScreen,
        enter: l.transitions.duration.enteringScreen,
        exit: 0
      },
      children: n
    }, s)
  });
}
const rc = (t) => ge("MuiPickersSlideTransition", t), Ie = he("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), ac = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], sc = (t) => {
  const {
    classes: o,
    slideDirection: n
  } = t, r = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${n}`],
    exitActive: [`slideExitActiveLeft-${n}`]
  };
  return me(r, rc, o);
}, ic = _(Zn, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (t, o) => [o.root, {
    [`.${Ie["slideEnter-left"]}`]: o["slideEnter-left"]
  }, {
    [`.${Ie["slideEnter-right"]}`]: o["slideEnter-right"]
  }, {
    [`.${Ie.slideEnterActive}`]: o.slideEnterActive
  }, {
    [`.${Ie.slideExit}`]: o.slideExit
  }, {
    [`.${Ie["slideExitActiveLeft-left"]}`]: o["slideExitActiveLeft-left"]
  }, {
    [`.${Ie["slideExitActiveLeft-right"]}`]: o["slideExitActiveLeft-right"]
  }]
})(({
  theme: t
}) => {
  const o = t.transitions.create("transform", {
    duration: t.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${Ie["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${Ie["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${Ie.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: o
    },
    [`& .${Ie.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${Ie["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: o,
      zIndex: 0
    },
    [`& .${Ie["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: o,
      zIndex: 0
    }
  };
});
function lc(t) {
  const o = le({
    props: t,
    name: "MuiPickersSlideTransition"
  }), {
    children: n,
    className: r,
    reduceAnimations: a,
    transKey: s
    // extracting `classes` from `other`
  } = o, i = ne(o, ac), l = sc(o), c = Qn();
  if (a)
    return /* @__PURE__ */ u("div", {
      className: Ce(l.root, r),
      children: n
    });
  const p = {
    exit: l.exit,
    enterActive: l.enterActive,
    enter: l.enter,
    exitActive: l.exitActive
  };
  return /* @__PURE__ */ u(ic, {
    className: Ce(l.root, r),
    childFactory: (m) => /* @__PURE__ */ C.cloneElement(m, {
      classNames: p
    }),
    role: "presentation",
    children: /* @__PURE__ */ u(Fs, b({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: c.transitions.duration.complex,
      classNames: p
    }, i, {
      children: n
    }), s)
  });
}
const cc = (t) => ge("MuiDayCalendar", t);
he("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const uc = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], dc = ["ownerState"], pc = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  }, cc, o);
}, gr = (Rt + _t * 2) * 6, fc = _("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({}), mc = _("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (t, o) => o.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), bc = _(mt, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (t, o) => o.weekDayLabel
})(({
  theme: t
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (t.vars || t).palette.text.secondary
})), hc = _(mt, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (t, o) => o.weekNumberLabel
})(({
  theme: t
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: t.palette.text.disabled
})), gc = _(mt, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (t, o) => o.weekNumber
})(({
  theme: t
}) => b({}, t.typography.caption, {
  width: Rt,
  height: Rt,
  padding: 0,
  margin: `0 ${_t}px`,
  color: t.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), yc = _("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (t, o) => o.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: gr
}), Dc = _(lc, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (t, o) => o.slideTransition
})({
  minHeight: gr
}), Cc = _("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (t, o) => o.monthContainer
})({
  overflow: "hidden"
}), vc = _("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (t, o) => o.weekContainer
})({
  margin: `${_t}px 0`,
  display: "flex",
  justifyContent: "center"
});
function wc(t) {
  let {
    parentProps: o,
    day: n,
    focusableDay: r,
    selectedDays: a,
    isDateDisabled: s,
    currentMonthNumber: i,
    isViewFocused: l
  } = t, c = ne(t, uc);
  const {
    disabled: p,
    disableHighlightToday: m,
    isMonthSwitchingAnimating: f,
    showDaysOutsideCurrentMonth: d,
    slots: g,
    slotProps: h,
    timezone: D
  } = o, y = ue(), x = Ut(D), v = r !== null && y.isSameDay(n, r), P = a.some((V) => y.isSameDay(V, n)), T = y.isSameDay(n, x), S = (g == null ? void 0 : g.day) ?? ar, k = pe({
    elementType: S,
    externalSlotProps: h == null ? void 0 : h.day,
    additionalProps: b({
      disableHighlightToday: m,
      showDaysOutsideCurrentMonth: d,
      role: "gridcell",
      isAnimating: f,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": y.toJsDate(n).valueOf()
    }, c),
    ownerState: b({}, o, {
      day: n,
      selected: P
    })
  }), M = ne(k, dc), w = C.useMemo(() => p || s(n), [p, s, n]), q = C.useMemo(() => y.getMonth(n) !== i, [y, n, i]), B = C.useMemo(() => {
    const V = y.startOfMonth(y.setMonth(n, i));
    return d ? y.isSameDay(n, y.startOfWeek(V)) : y.isSameDay(n, V);
  }, [i, n, d, y]), O = C.useMemo(() => {
    const V = y.endOfMonth(y.setMonth(n, i));
    return d ? y.isSameDay(n, y.endOfWeek(V)) : y.isSameDay(n, V);
  }, [i, n, d, y]);
  return /* @__PURE__ */ u(S, b({}, M, {
    day: n,
    disabled: w,
    autoFocus: l && v,
    today: T,
    outsideCurrentMonth: q,
    isFirstVisibleCell: B,
    isLastVisibleCell: O,
    selected: P,
    tabIndex: v ? 0 : -1,
    "aria-selected": P,
    "aria-current": T ? "date" : void 0
  }));
}
function Tc(t) {
  const o = le({
    props: t,
    name: "MuiDayCalendar"
  }), n = ue(), {
    onFocusedDayChange: r,
    className: a,
    currentMonth: s,
    selectedDays: i,
    focusedDay: l,
    loading: c,
    onSelectedDaysChange: p,
    onMonthSwitchingAnimationEnd: m,
    readOnly: f,
    reduceAnimations: d,
    renderLoading: g = () => /* @__PURE__ */ u("span", {
      children: "..."
    }),
    slideDirection: h,
    TransitionProps: D,
    disablePast: y,
    disableFuture: x,
    minDate: v,
    maxDate: P,
    shouldDisableDate: T,
    shouldDisableMonth: S,
    shouldDisableYear: k,
    dayOfWeekFormatter: M = (j) => n.format(j, "weekdayShort").charAt(0).toUpperCase(),
    hasFocus: w,
    onFocusedViewChange: q,
    gridLabelId: B,
    displayWeekNumber: O,
    fixedWeekNumber: V,
    autoFocus: N,
    timezone: A
  } = o, F = Ut(A), L = pc(o), ee = _e(), Q = br({
    shouldDisableDate: T,
    shouldDisableMonth: S,
    shouldDisableYear: k,
    minDate: v,
    maxDate: P,
    disablePast: y,
    disableFuture: x,
    timezone: A
  }), ae = ke(), [se, re] = zt({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: w,
    default: N ?? !1
  }), [ce, ye] = C.useState(() => l || F), de = Z((j) => {
    f || p(j);
  }), $ = (j) => {
    Q(j) || (r(j), ye(j), q == null || q(!0), re(!0));
  }, X = Z((j, oe) => {
    switch (j.key) {
      case "ArrowUp":
        $(n.addDays(oe, -7)), j.preventDefault();
        break;
      case "ArrowDown":
        $(n.addDays(oe, 7)), j.preventDefault();
        break;
      case "ArrowLeft": {
        const Y = n.addDays(oe, ee ? 1 : -1), ie = n.addMonths(oe, ee ? 1 : -1), be = xt({
          utils: n,
          date: Y,
          minDate: ee ? Y : n.startOfMonth(ie),
          maxDate: ee ? n.endOfMonth(ie) : Y,
          isDateDisabled: Q,
          timezone: A
        });
        $(be || Y), j.preventDefault();
        break;
      }
      case "ArrowRight": {
        const Y = n.addDays(oe, ee ? -1 : 1), ie = n.addMonths(oe, ee ? -1 : 1), be = xt({
          utils: n,
          date: Y,
          minDate: ee ? n.startOfMonth(ie) : Y,
          maxDate: ee ? Y : n.endOfMonth(ie),
          isDateDisabled: Q,
          timezone: A
        });
        $(be || Y), j.preventDefault();
        break;
      }
      case "Home":
        $(n.startOfWeek(oe)), j.preventDefault();
        break;
      case "End":
        $(n.endOfWeek(oe)), j.preventDefault();
        break;
      case "PageUp":
        $(n.addMonths(oe, 1)), j.preventDefault();
        break;
      case "PageDown":
        $(n.addMonths(oe, -1)), j.preventDefault();
        break;
    }
  }), H = Z((j, oe) => $(oe)), E = Z((j, oe) => {
    se && n.isSameDay(ce, oe) && (q == null || q(!1));
  }), I = n.getMonth(s), J = n.getYear(s), te = C.useMemo(() => i.filter((j) => !!j).map((j) => n.startOfDay(j)), [n, i]), U = `${J}-${I}`, R = C.useMemo(() => /* @__PURE__ */ C.createRef(), [U]), W = C.useMemo(() => {
    const j = n.startOfMonth(s), oe = n.endOfMonth(s);
    return Q(ce) || n.isAfterDay(ce, oe) || n.isBeforeDay(ce, j) ? xt({
      utils: n,
      date: ce,
      minDate: j,
      maxDate: oe,
      disablePast: y,
      disableFuture: x,
      isDateDisabled: Q,
      timezone: A
    }) : ce;
  }, [s, x, y, ce, Q, n, A]), G = C.useMemo(() => {
    const j = n.getWeekArray(s);
    let oe = n.addMonths(s, 1);
    for (; V && j.length < V; ) {
      const Y = n.getWeekArray(oe), ie = n.isSameDay(j[j.length - 1][0], Y[0][0]);
      Y.slice(ie ? 1 : 0).forEach((be) => {
        j.length < V && j.push(be);
      }), oe = n.addMonths(oe, 1);
    }
    return j;
  }, [s, V, n]);
  return /* @__PURE__ */ z(fc, {
    role: "grid",
    "aria-labelledby": B,
    className: L.root,
    children: [/* @__PURE__ */ z(mc, {
      role: "row",
      className: L.header,
      children: [O && /* @__PURE__ */ u(hc, {
        variant: "caption",
        role: "columnheader",
        "aria-label": ae.calendarWeekNumberHeaderLabel,
        className: L.weekNumberLabel,
        children: ae.calendarWeekNumberHeaderText
      }), hs(n, F).map((j, oe) => /* @__PURE__ */ u(bc, {
        variant: "caption",
        role: "columnheader",
        "aria-label": n.format(j, "weekday"),
        className: L.weekDayLabel,
        children: M(j)
      }, oe.toString()))]
    }), c ? /* @__PURE__ */ u(yc, {
      className: L.loadingContainer,
      children: g()
    }) : /* @__PURE__ */ u(Dc, b({
      transKey: U,
      onExited: m,
      reduceAnimations: d,
      slideDirection: h,
      className: Ce(a, L.slideTransition)
    }, D, {
      nodeRef: R,
      children: /* @__PURE__ */ u(Cc, {
        ref: R,
        role: "rowgroup",
        className: L.monthContainer,
        children: G.map((j, oe) => /* @__PURE__ */ z(vc, {
          role: "row",
          className: L.weekContainer,
          "aria-rowindex": oe + 1,
          children: [O && /* @__PURE__ */ u(gc, {
            className: L.weekNumber,
            role: "rowheader",
            "aria-label": ae.calendarWeekNumberAriaLabelText(n.getWeekNumber(j[0])),
            children: ae.calendarWeekNumberText(n.getWeekNumber(j[0]))
          }), j.map((Y, ie) => /* @__PURE__ */ u(wc, {
            parentProps: o,
            day: Y,
            selectedDays: te,
            focusableDay: W,
            onKeyDown: X,
            onFocus: H,
            onBlur: E,
            onDaySelect: de,
            isDateDisabled: Q,
            currentMonthNumber: I,
            isViewFocused: se,
            "aria-colindex": ie + 1
          }, Y.toString()))]
        }, `week-${j[0]}`))
      })
    }))]
  });
}
function xc(t) {
  return ge("MuiPickersMonth", t);
}
const At = he("MuiPickersMonth", ["root", "monthButton", "disabled", "selected"]), Pc = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow", "slots", "slotProps"], Sc = (t) => {
  const {
    disabled: o,
    selected: n,
    classes: r
  } = t;
  return me({
    root: ["root"],
    monthButton: ["monthButton", o && "disabled", n && "selected"]
  }, xc, r);
}, kc = _("div", {
  name: "MuiPickersMonth",
  slot: "Root",
  overridesResolver: (t, o) => [o.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      monthsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), Rc = _("button", {
  name: "MuiPickersMonth",
  slot: "MonthButton",
  overridesResolver: (t, o) => [o.monthButton, {
    [`&.${At.disabled}`]: o.disabled
  }, {
    [`&.${At.selected}`]: o.selected
  }]
})(({
  theme: t
}) => b({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, t.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: t.vars ? `rgba(${t.vars.palette.action.activeChannel} / ${t.vars.palette.action.hoverOpacity})` : dt(t.palette.action.active, t.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: t.vars ? `rgba(${t.vars.palette.action.activeChannel} / ${t.vars.palette.action.hoverOpacity})` : dt(t.palette.action.active, t.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${At.disabled}`]: {
    color: (t.vars || t).palette.text.secondary
  },
  [`&.${At.selected}`]: {
    color: (t.vars || t).palette.primary.contrastText,
    backgroundColor: (t.vars || t).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (t.vars || t).palette.primary.dark
    }
  }
})), Mc = /* @__PURE__ */ C.memo(function(o) {
  const n = le({
    props: o,
    name: "MuiPickersMonth"
  }), {
    autoFocus: r,
    className: a,
    children: s,
    disabled: i,
    selected: l,
    value: c,
    tabIndex: p,
    onClick: m,
    onKeyDown: f,
    onFocus: d,
    onBlur: g,
    "aria-current": h,
    "aria-label": D,
    slots: y,
    slotProps: x
  } = n, v = ne(n, Pc), P = C.useRef(null), T = Sc(n);
  Ye(() => {
    var M;
    r && ((M = P.current) == null || M.focus());
  }, [r]);
  const S = (y == null ? void 0 : y.monthButton) ?? Rc, k = pe({
    elementType: S,
    externalSlotProps: x == null ? void 0 : x.monthButton,
    additionalProps: {
      children: s,
      disabled: i,
      tabIndex: p,
      ref: P,
      type: "button",
      role: "radio",
      "aria-current": h,
      "aria-checked": l,
      "aria-label": D,
      onClick: (M) => m(M, c),
      onKeyDown: (M) => f(M, c),
      onFocus: (M) => d(M, c),
      onBlur: (M) => g(M, c)
    },
    ownerState: n,
    className: T.monthButton
  });
  return /* @__PURE__ */ u(kc, b({
    className: Ce(T.root, a),
    ownerState: n
  }, v, {
    children: /* @__PURE__ */ u(S, b({}, k))
  }));
});
function Oc(t) {
  return ge("MuiMonthCalendar", t);
}
he("MuiMonthCalendar", ["root"]);
const Fc = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], Ic = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"]
  }, Oc, o);
};
function Vc(t, o) {
  const n = ue(), r = et(), a = le({
    props: t,
    name: o
  });
  return b({
    disableFuture: !1,
    disablePast: !1
  }, a, {
    minDate: Se(n, a.minDate, r.minDate),
    maxDate: Se(n, a.maxDate, r.maxDate)
  });
}
const Ac = _("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  padding: "0 4px",
  width: So,
  // avoid padding increasing width over defined
  boxSizing: "border-box"
}), yr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = Vc(o, "MuiMonthCalendar"), {
    className: a,
    value: s,
    defaultValue: i,
    referenceDate: l,
    disabled: c,
    disableFuture: p,
    disablePast: m,
    maxDate: f,
    minDate: d,
    onChange: g,
    shouldDisableMonth: h,
    readOnly: D,
    autoFocus: y = !1,
    onMonthFocus: x,
    hasFocus: v,
    onFocusedViewChange: P,
    monthsPerRow: T = 3,
    timezone: S,
    gridLabelId: k,
    slots: M,
    slotProps: w
  } = r, q = ne(r, Fc), {
    value: B,
    handleValueChange: O,
    timezone: V
  } = ko({
    name: "MonthCalendar",
    timezone: S,
    value: s,
    defaultValue: i,
    referenceDate: l,
    onChange: g,
    valueManager: xe
  }), N = Ut(V), A = _e(), F = ue(), L = C.useMemo(
    () => xe.getInitialReferenceValue({
      value: B,
      utils: F,
      props: r,
      timezone: V,
      referenceDate: l,
      granularity: Po.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), ee = r, Q = Ic(ee), ae = C.useMemo(() => F.getMonth(N), [F, N]), se = C.useMemo(() => B != null ? F.getMonth(B) : null, [B, F]), [re, ce] = C.useState(() => se || F.getMonth(L)), [ye, de] = zt({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: v,
    default: y ?? !1
  }), $ = Z((U) => {
    de(U), P && P(U);
  }), X = C.useCallback((U) => {
    const R = F.startOfMonth(m && F.isAfter(N, d) ? N : d), W = F.startOfMonth(p && F.isBefore(N, f) ? N : f), G = F.startOfMonth(U);
    return F.isBefore(G, R) || F.isAfter(G, W) ? !0 : h ? h(G) : !1;
  }, [p, m, f, d, N, h, F]), H = Z((U, R) => {
    if (D)
      return;
    const W = F.setMonth(B ?? L, R);
    O(W);
  }), E = Z((U) => {
    X(F.setMonth(B ?? L, U)) || (ce(U), $(!0), x && x(U));
  });
  C.useEffect(() => {
    ce((U) => se !== null && U !== se ? se : U);
  }, [se]);
  const I = Z((U, R) => {
    switch (U.key) {
      case "ArrowUp":
        E((12 + R - 3) % 12), U.preventDefault();
        break;
      case "ArrowDown":
        E((12 + R + 3) % 12), U.preventDefault();
        break;
      case "ArrowLeft":
        E((12 + R + (A ? 1 : -1)) % 12), U.preventDefault();
        break;
      case "ArrowRight":
        E((12 + R + (A ? -1 : 1)) % 12), U.preventDefault();
        break;
    }
  }), J = Z((U, R) => {
    E(R);
  }), te = Z((U, R) => {
    re === R && $(!1);
  });
  return /* @__PURE__ */ u(Ac, b({
    ref: n,
    className: Ce(Q.root, a),
    ownerState: ee,
    role: "radiogroup",
    "aria-labelledby": k
  }, q, {
    children: gs(F, B ?? L).map((U) => {
      const R = F.getMonth(U), W = F.format(U, "monthShort"), G = F.format(U, "month"), j = R === se, oe = c || X(U);
      return /* @__PURE__ */ u(Mc, {
        selected: j,
        value: R,
        onClick: H,
        onKeyDown: I,
        autoFocus: ye && R === re,
        disabled: oe,
        tabIndex: R === re && !oe ? 0 : -1,
        onFocus: J,
        onBlur: te,
        "aria-current": ae === R ? "date" : void 0,
        "aria-label": G,
        monthsPerRow: T,
        slots: M,
        slotProps: w,
        children: W
      }, W);
    })
  }));
});
process.env.NODE_ENV !== "production" && (yr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: e.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  className: e.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true` picker is disabled
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  gridLabelId: e.string,
  hasFocus: e.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: e.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: e.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: e.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: e.func,
  onFocusedViewChange: e.func,
  onMonthFocus: e.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: e.object,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object
});
function Ec(t) {
  return ge("MuiPickersYear", t);
}
const Et = he("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]), Lc = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow", "slots", "slotProps"], $c = (t) => {
  const {
    disabled: o,
    selected: n,
    classes: r
  } = t;
  return me({
    root: ["root"],
    yearButton: ["yearButton", o && "disabled", n && "selected"]
  }, Ec, r);
}, jc = _("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (t, o) => [o.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      yearsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), Bc = _("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (t, o) => [o.yearButton, {
    [`&.${Et.disabled}`]: o.disabled
  }, {
    [`&.${Et.selected}`]: o.selected
  }]
})(({
  theme: t
}) => b({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, t.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: t.vars ? `rgba(${t.vars.palette.action.activeChannel} / ${t.vars.palette.action.focusOpacity})` : dt(t.palette.action.active, t.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: t.vars ? `rgba(${t.vars.palette.action.activeChannel} / ${t.vars.palette.action.hoverOpacity})` : dt(t.palette.action.active, t.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${Et.disabled}`]: {
    color: (t.vars || t).palette.text.secondary
  },
  [`&.${Et.selected}`]: {
    color: (t.vars || t).palette.primary.contrastText,
    backgroundColor: (t.vars || t).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (t.vars || t).palette.primary.dark
    }
  }
})), Nc = /* @__PURE__ */ C.memo(function(o) {
  const n = le({
    props: o,
    name: "MuiPickersYear"
  }), {
    autoFocus: r,
    className: a,
    children: s,
    disabled: i,
    selected: l,
    value: c,
    tabIndex: p,
    onClick: m,
    onKeyDown: f,
    onFocus: d,
    onBlur: g,
    "aria-current": h,
    slots: D,
    slotProps: y
  } = n, x = ne(n, Lc), v = C.useRef(null), P = $c(n);
  Ye(() => {
    var k;
    r && ((k = v.current) == null || k.focus());
  }, [r]);
  const T = (D == null ? void 0 : D.yearButton) ?? Bc, S = pe({
    elementType: T,
    externalSlotProps: y == null ? void 0 : y.yearButton,
    additionalProps: {
      children: s,
      disabled: i,
      tabIndex: p,
      ref: v,
      type: "button",
      role: "radio",
      "aria-current": h,
      "aria-checked": l,
      onClick: (k) => m(k, c),
      onKeyDown: (k) => f(k, c),
      onFocus: (k) => d(k, c),
      onBlur: (k) => g(k, c)
    },
    ownerState: n,
    className: P.yearButton
  });
  return /* @__PURE__ */ u(jc, b({
    className: Ce(P.root, a),
    ownerState: n
  }, x, {
    children: /* @__PURE__ */ u(T, b({}, S))
  }));
});
function qc(t) {
  return ge("MuiYearCalendar", t);
}
he("MuiYearCalendar", ["root"]);
const Wc = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsOrder", "yearsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], _c = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"]
  }, qc, o);
};
function Hc(t, o) {
  const n = ue(), r = et(), a = le({
    props: t,
    name: o
  });
  return b({
    disablePast: !1,
    disableFuture: !1
  }, a, {
    yearsPerRow: a.yearsPerRow ?? 3,
    minDate: Se(n, a.minDate, r.minDate),
    maxDate: Se(n, a.maxDate, r.maxDate)
  });
}
const zc = _("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: So,
  maxHeight: ys,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
}), Dr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = Hc(o, "MuiYearCalendar"), {
    autoFocus: a,
    className: s,
    value: i,
    defaultValue: l,
    referenceDate: c,
    disabled: p,
    disableFuture: m,
    disablePast: f,
    maxDate: d,
    minDate: g,
    onChange: h,
    readOnly: D,
    shouldDisableYear: y,
    onYearFocus: x,
    hasFocus: v,
    onFocusedViewChange: P,
    yearsOrder: T = "asc",
    yearsPerRow: S,
    timezone: k,
    gridLabelId: M,
    slots: w,
    slotProps: q
  } = r, B = ne(r, Wc), {
    value: O,
    handleValueChange: V,
    timezone: N
  } = ko({
    name: "YearCalendar",
    timezone: k,
    value: i,
    defaultValue: l,
    referenceDate: c,
    onChange: h,
    valueManager: xe
  }), A = Ut(N), F = _e(), L = ue(), ee = C.useMemo(
    () => xe.getInitialReferenceValue({
      value: O,
      utils: L,
      props: r,
      timezone: N,
      referenceDate: c,
      granularity: Po.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), Q = r, ae = _c(Q), se = C.useMemo(() => L.getYear(A), [L, A]), re = C.useMemo(() => O != null ? L.getYear(O) : null, [O, L]), [ce, ye] = C.useState(() => re || L.getYear(ee)), [de, $] = zt({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: v,
    default: a ?? !1
  }), X = Z((Y) => {
    $(Y), P && P(Y);
  }), H = C.useCallback((Y) => {
    if (f && L.isBeforeYear(Y, A) || m && L.isAfterYear(Y, A) || g && L.isBeforeYear(Y, g) || d && L.isAfterYear(Y, d))
      return !0;
    if (!y)
      return !1;
    const ie = L.startOfYear(Y);
    return y(ie);
  }, [m, f, d, g, A, y, L]), E = Z((Y, ie) => {
    if (D)
      return;
    const be = L.setYear(O ?? ee, ie);
    V(be);
  }), I = Z((Y) => {
    H(L.setYear(O ?? ee, Y)) || (ye(Y), X(!0), x == null || x(Y));
  });
  C.useEffect(() => {
    ye((Y) => re !== null && Y !== re ? re : Y);
  }, [re]);
  const J = T !== "desc" ? S * 1 : S * -1, te = F && T === "asc" || !F && T === "desc" ? -1 : 1, U = Z((Y, ie) => {
    switch (Y.key) {
      case "ArrowUp":
        I(ie - J), Y.preventDefault();
        break;
      case "ArrowDown":
        I(ie + J), Y.preventDefault();
        break;
      case "ArrowLeft":
        I(ie - te), Y.preventDefault();
        break;
      case "ArrowRight":
        I(ie + te), Y.preventDefault();
        break;
    }
  }), R = Z((Y, ie) => {
    I(ie);
  }), W = Z((Y, ie) => {
    ce === ie && X(!1);
  }), G = C.useRef(null), j = Le(n, G);
  C.useEffect(() => {
    if (a || G.current === null)
      return;
    const Y = G.current.querySelector('[tabindex="0"]');
    if (!Y)
      return;
    const ie = Y.offsetHeight, be = Y.offsetTop, Ke = G.current.clientHeight, tt = G.current.scrollTop, ao = be + ie;
    ie > Ke || be < tt || (G.current.scrollTop = ao - Ke / 2 - ie / 2);
  }, [a]);
  const oe = L.getYearRange([g, d]);
  return T === "desc" && oe.reverse(), /* @__PURE__ */ u(zc, b({
    ref: j,
    className: Ce(ae.root, s),
    ownerState: Q,
    role: "radiogroup",
    "aria-labelledby": M
  }, B, {
    children: oe.map((Y) => {
      const ie = L.getYear(Y), be = ie === re, Ke = p || H(Y);
      return /* @__PURE__ */ u(Nc, {
        selected: be,
        value: ie,
        onClick: E,
        onKeyDown: U,
        autoFocus: de && ie === ce,
        disabled: Ke,
        tabIndex: ie === ce && !Ke ? 0 : -1,
        onFocus: R,
        onBlur: W,
        "aria-current": se === ie ? "date" : void 0,
        yearsPerRow: S,
        slots: w,
        slotProps: q,
        children: L.format(Y, "year")
      }, L.format(Y, "year"));
    })
  }));
});
process.env.NODE_ENV !== "production" && (Dr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: e.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  className: e.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true` picker is disabled
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  gridLabelId: e.string,
  hasFocus: e.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: e.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: e.object,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: e.func,
  onFocusedViewChange: e.func,
  onYearFocus: e.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: e.object,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: e.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: e.oneOf([3, 4])
});
const Uc = (t) => ge("MuiPickersCalendarHeader", t), Yc = he("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]), Kc = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone", "format"], Gc = ["ownerState"], Qc = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  }, Uc, o);
}, Zc = _("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 12,
  marginBottom: 4,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 40,
  minHeight: 40
}), Xc = _("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (t, o) => o.labelContainer
})(({
  theme: t
}) => b({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, t.typography.body1, {
  fontWeight: t.typography.fontWeightMedium
})), Jc = _("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (t, o) => o.label
})({
  marginRight: 6
}), eu = _(Io, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (t, o) => o.switchViewButton
})({
  marginRight: "auto",
  variants: [{
    props: {
      view: "year"
    },
    style: {
      [`.${Yc.switchViewIcon}`]: {
        transform: "rotate(180deg)"
      }
    }
  }]
}), tu = _(Ds, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (t, o) => o.switchViewIcon
})(({
  theme: t
}) => ({
  willChange: "transform",
  transition: t.transitions.create("transform"),
  transform: "rotate(0deg)"
})), Cr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = ke(), a = ue(), s = le({
    props: o,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: i,
    slotProps: l,
    currentMonth: c,
    disabled: p,
    disableFuture: m,
    disablePast: f,
    maxDate: d,
    minDate: g,
    onMonthChange: h,
    onViewChange: D,
    view: y,
    reduceAnimations: x,
    views: v,
    labelId: P,
    className: T,
    timezone: S,
    format: k = `${a.formats.month} ${a.formats.year}`
  } = s, M = ne(s, Kc), w = s, q = Qc(s), B = (i == null ? void 0 : i.switchViewButton) ?? eu, O = pe({
    elementType: B,
    externalSlotProps: l == null ? void 0 : l.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": r.calendarViewSwitchingButtonAriaLabel(y)
    },
    ownerState: w,
    className: q.switchViewButton
  }), V = (i == null ? void 0 : i.switchViewIcon) ?? tu, N = pe({
    elementType: V,
    externalSlotProps: l == null ? void 0 : l.switchViewIcon,
    ownerState: w,
    className: q.switchViewIcon
  }), A = ne(N, Gc), F = () => h(a.addMonths(c, 1), "left"), L = () => h(a.addMonths(c, -1), "right"), ee = Cs(c, {
    disableFuture: m,
    maxDate: d,
    timezone: S
  }), Q = vs(c, {
    disablePast: f,
    minDate: g,
    timezone: S
  }), ae = () => {
    if (!(v.length === 1 || !D || p))
      if (v.length === 2)
        D(v.find((re) => re !== y) || v[0]);
      else {
        const re = v.indexOf(y) !== 0 ? 0 : 1;
        D(v[re]);
      }
  };
  if (v.length === 1 && v[0] === "year")
    return null;
  const se = a.formatByString(c, k);
  return /* @__PURE__ */ z(Zc, b({}, M, {
    ownerState: w,
    className: Ce(q.root, T),
    ref: n,
    children: [/* @__PURE__ */ z(Xc, {
      role: "presentation",
      onClick: ae,
      ownerState: w,
      "aria-live": "polite",
      className: q.labelContainer,
      children: [/* @__PURE__ */ u(hr, {
        reduceAnimations: x,
        transKey: se,
        children: /* @__PURE__ */ u(Jc, {
          id: P,
          ownerState: w,
          className: q.label,
          children: se
        })
      }), v.length > 1 && !p && /* @__PURE__ */ u(B, b({}, O, {
        children: /* @__PURE__ */ u(V, b({}, A))
      }))]
    }), /* @__PURE__ */ u(Kt, {
      in: y === "day",
      children: /* @__PURE__ */ u(ws, {
        slots: i,
        slotProps: l,
        onGoToPrevious: L,
        isPreviousDisabled: Q,
        previousLabel: r.previousMonth,
        onGoToNext: F,
        isNextDisabled: ee,
        nextLabel: r.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (Cr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  className: e.string,
  currentMonth: e.object.isRequired,
  disabled: e.bool,
  disableFuture: e.bool,
  disablePast: e.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: e.string,
  /**
   * Id of the calendar text element.
   * It is used to establish an `aria-labelledby` relationship with the calendar `grid` element.
   */
  labelId: e.string,
  maxDate: e.object.isRequired,
  minDate: e.object.isRequired,
  onMonthChange: e.func.isRequired,
  onViewChange: e.func,
  reduceAnimations: e.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  timezone: e.string.isRequired,
  view: e.oneOf(["day", "month", "year"]).isRequired,
  views: e.arrayOf(e.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const ou = "@media (prefers-reduced-motion: reduce)", lt = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), gn = lt && lt[1] ? parseInt(lt[1], 10) : null, yn = lt && lt[2] ? parseInt(lt[2], 10) : null, nu = gn && gn < 10 || yn && yn < 13 || !1, vr = () => Yt(ou, {
  defaultMatches: !1
}) || nu, ru = (t) => ge("MuiDateCalendar", t);
he("MuiDateCalendar", ["root", "viewTransitionContainer"]);
const au = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsOrder", "yearsPerRow", "monthsPerRow", "timezone"], su = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, ru, o);
};
function iu(t, o) {
  const n = ue(), r = et(), a = vr(), s = le({
    props: t,
    name: o
  });
  return b({}, s, {
    loading: s.loading ?? !1,
    disablePast: s.disablePast ?? !1,
    disableFuture: s.disableFuture ?? !1,
    openTo: s.openTo ?? "day",
    views: s.views ?? ["year", "day"],
    reduceAnimations: s.reduceAnimations ?? a,
    renderLoading: s.renderLoading ?? (() => /* @__PURE__ */ u("span", {
      children: "..."
    })),
    minDate: Se(n, s.minDate, r.minDate),
    maxDate: Se(n, s.maxDate, r.maxDate)
  });
}
const lu = _(Ts, {
  name: "MuiDateCalendar",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({
  display: "flex",
  flexDirection: "column",
  height: Ro
}), cu = _(hr, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer",
  overridesResolver: (t, o) => o.viewTransitionContainer
})({}), wr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = ue(), a = Ft(), s = iu(o, "MuiDateCalendar"), {
    autoFocus: i,
    onViewChange: l,
    value: c,
    defaultValue: p,
    referenceDate: m,
    disableFuture: f,
    disablePast: d,
    onChange: g,
    onYearChange: h,
    onMonthChange: D,
    reduceAnimations: y,
    shouldDisableDate: x,
    shouldDisableMonth: v,
    shouldDisableYear: P,
    view: T,
    views: S,
    openTo: k,
    className: M,
    disabled: w,
    readOnly: q,
    minDate: B,
    maxDate: O,
    disableHighlightToday: V,
    focusedView: N,
    onFocusedViewChange: A,
    showDaysOutsideCurrentMonth: F,
    fixedWeekNumber: L,
    dayOfWeekFormatter: ee,
    slots: Q,
    slotProps: ae,
    loading: se,
    renderLoading: re,
    displayWeekNumber: ce,
    yearsOrder: ye,
    yearsPerRow: de,
    monthsPerRow: $,
    timezone: X
  } = s, H = ne(s, au), {
    value: E,
    handleValueChange: I,
    timezone: J
  } = ko({
    name: "DateCalendar",
    timezone: X,
    value: c,
    defaultValue: p,
    referenceDate: m,
    onChange: g,
    valueManager: xe
  }), {
    view: te,
    setView: U,
    focusedView: R,
    setFocusedView: W,
    goToNextView: G,
    setValueAndGoToNextView: j
  } = Hn({
    view: T,
    views: S,
    openTo: k,
    onChange: I,
    onViewChange: l,
    autoFocus: i,
    focusedView: N,
    onFocusedViewChange: A
  }), {
    referenceDate: oe,
    calendarState: Y,
    changeFocusedDay: ie,
    changeMonth: be,
    handleChangeMonth: Ke,
    isDateDisabled: tt,
    onMonthSwitchingAnimationEnd: ao
  } = ec({
    value: E,
    referenceDate: m,
    reduceAnimations: y,
    onMonthChange: D,
    minDate: B,
    maxDate: O,
    shouldDisableDate: x,
    disablePast: d,
    disableFuture: f,
    timezone: J
  }), sa = w && E || B, ia = w && E || O, en = `${a}-grid-label`, so = R !== null, tn = (Q == null ? void 0 : Q.calendarHeader) ?? Cr, la = pe({
    elementType: tn,
    externalSlotProps: ae == null ? void 0 : ae.calendarHeader,
    additionalProps: {
      views: S,
      view: te,
      currentMonth: Y.currentMonth,
      onViewChange: U,
      onMonthChange: (De, He) => Ke({
        newMonth: De,
        direction: He
      }),
      minDate: sa,
      maxDate: ia,
      disabled: w,
      disablePast: d,
      disableFuture: f,
      reduceAnimations: y,
      timezone: J,
      labelId: en
    },
    ownerState: s
  }), ca = Z((De) => {
    const He = r.startOfMonth(De), gt = r.endOfMonth(De), Ue = tt(De) ? xt({
      utils: r,
      date: De,
      minDate: r.isBefore(B, He) ? He : B,
      maxDate: r.isAfter(O, gt) ? gt : O,
      disablePast: d,
      disableFuture: f,
      isDateDisabled: tt,
      timezone: J
    }) : De;
    Ue ? (j(Ue, "finish"), D == null || D(He)) : (G(), be(He)), ie(Ue, !0);
  }), ua = Z((De) => {
    const He = r.startOfYear(De), gt = r.endOfYear(De), Ue = tt(De) ? xt({
      utils: r,
      date: De,
      minDate: r.isBefore(B, He) ? He : B,
      maxDate: r.isAfter(O, gt) ? gt : O,
      disablePast: d,
      disableFuture: f,
      isDateDisabled: tt,
      timezone: J
    }) : De;
    Ue ? (j(Ue, "finish"), h == null || h(Ue)) : (G(), be(He)), ie(Ue, !0);
  }), da = Z((De) => I(De && xs(r, De, E ?? oe), "finish", te));
  C.useEffect(() => {
    E != null && r.isValid(E) && be(E);
  }, [E]);
  const io = s, on = su(io), lo = {
    disablePast: d,
    disableFuture: f,
    maxDate: O,
    minDate: B
  }, co = {
    disableHighlightToday: V,
    readOnly: q,
    disabled: w,
    timezone: J,
    gridLabelId: en,
    slots: Q,
    slotProps: ae
  }, uo = C.useRef(te);
  C.useEffect(() => {
    uo.current !== te && (R === uo.current && W(te, !0), uo.current = te);
  }, [R, W, te]);
  const pa = C.useMemo(() => [E], [E]);
  return /* @__PURE__ */ z(lu, b({
    ref: n,
    className: Ce(on.root, M),
    ownerState: io
  }, H, {
    children: [/* @__PURE__ */ u(tn, b({}, la, {
      slots: Q,
      slotProps: ae
    })), /* @__PURE__ */ u(cu, {
      reduceAnimations: y,
      className: on.viewTransitionContainer,
      transKey: te,
      ownerState: io,
      children: /* @__PURE__ */ z("div", {
        children: [te === "year" && /* @__PURE__ */ u(Dr, b({}, lo, co, {
          value: E,
          onChange: ua,
          shouldDisableYear: P,
          hasFocus: so,
          onFocusedViewChange: (De) => W("year", De),
          yearsOrder: ye,
          yearsPerRow: de,
          referenceDate: oe
        })), te === "month" && /* @__PURE__ */ u(yr, b({}, lo, co, {
          hasFocus: so,
          className: M,
          value: E,
          onChange: ca,
          shouldDisableMonth: v,
          onFocusedViewChange: (De) => W("month", De),
          monthsPerRow: $,
          referenceDate: oe
        })), te === "day" && /* @__PURE__ */ u(Tc, b({}, Y, lo, co, {
          onMonthSwitchingAnimationEnd: ao,
          onFocusedDayChange: ie,
          reduceAnimations: y,
          selectedDays: pa,
          onSelectedDaysChange: da,
          shouldDisableDate: x,
          shouldDisableMonth: v,
          shouldDisableYear: P,
          hasFocus: so,
          onFocusedViewChange: (De) => W("day", De),
          showDaysOutsideCurrentMonth: F,
          fixedWeekNumber: L,
          dayOfWeekFormatter: ee,
          displayWeekNumber: ce,
          loading: se,
          renderLoading: re
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (wr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  className: e.string,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: e.func,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: e.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: e.number,
  /**
   * Controlled focused view.
   */
  focusedView: e.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: e.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: e.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: e.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: e.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: e.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: e.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: e.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: e.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: e.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: e.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: e.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: e.oneOf([3, 4])
});
function Tr(t) {
  return ge("MuiPickersToolbar", t);
}
const uu = he("MuiPickersToolbar", ["root", "content"]), du = ["children", "className", "toolbarTitle", "hidden", "titleId", "isLandscape", "classes", "landscapeDirection"], pu = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"],
    content: ["content"]
  }, Tr, o);
}, fu = _("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})(({
  theme: t
}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: t.spacing(2, 3),
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      height: "auto",
      maxWidth: 160,
      padding: 16,
      justifyContent: "flex-start",
      flexWrap: "wrap"
    }
  }]
})), mu = _("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (t, o) => o.content
})({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  flex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column"
    }
  }, {
    props: {
      isLandscape: !0,
      landscapeDirection: "row"
    },
    style: {
      flexDirection: "row"
    }
  }]
}), Uo = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiPickersToolbar"
  }), {
    children: a,
    className: s,
    toolbarTitle: i,
    hidden: l,
    titleId: c
  } = r, p = ne(r, du), m = r, f = pu(m);
  return l ? null : /* @__PURE__ */ z(fu, b({
    ref: n,
    className: Ce(f.root, s),
    ownerState: m
  }, p, {
    children: [/* @__PURE__ */ u(mt, {
      color: "text.secondary",
      variant: "overline",
      id: c,
      children: i
    }), /* @__PURE__ */ u(mu, {
      className: f.content,
      ownerState: m,
      children: a
    })]
  }));
});
function bu(t) {
  return ge("MuiDatePickerToolbar", t);
}
he("MuiDatePickerToolbar", ["root", "title"]);
const hu = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views", "className", "onViewChange", "view"], gu = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"],
    title: ["title"]
  }, bu, o);
}, yu = _(Uo, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({}), Du = _(mt, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (t, o) => o.title
})({
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "auto 16px auto auto"
    }
  }]
}), xr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiDatePickerToolbar"
  }), {
    value: a,
    isLandscape: s,
    toolbarFormat: i,
    toolbarPlaceholder: l = "––",
    views: c,
    className: p
  } = r, m = ne(r, hu), f = ue(), d = ke(), g = gu(r), h = C.useMemo(() => {
    if (!a)
      return l;
    const y = Mt(f, {
      format: i,
      views: c
    }, !0);
    return f.formatByString(a, y);
  }, [a, i, l, f, c]), D = r;
  return /* @__PURE__ */ u(yu, b({
    ref: n,
    toolbarTitle: d.datePickerToolbarTitle,
    isLandscape: s,
    className: Ce(g.root, p)
  }, m, {
    children: /* @__PURE__ */ u(Du, {
      variant: "h4",
      align: s ? "left" : "center",
      ownerState: D,
      className: g.title,
      children: h
    })
  }));
});
process.env.NODE_ENV !== "production" && (xr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  className: e.string,
  disabled: e.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: e.bool,
  isLandscape: e.bool.isRequired,
  onChange: e.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: e.func.isRequired,
  readOnly: e.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  titleId: e.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: e.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: e.node,
  value: e.object,
  /**
   * Currently visible picker view.
   */
  view: e.oneOf(["day", "month", "year"]).isRequired,
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["day", "month", "year"]).isRequired).isRequired
});
function Pr(t, o) {
  const n = ue(), r = et(), a = le({
    props: t,
    name: o
  }), s = C.useMemo(() => {
    var i;
    return ((i = a.localeText) == null ? void 0 : i.toolbarTitle) == null ? a.localeText : b({}, a.localeText, {
      datePickerToolbarTitle: a.localeText.toolbarTitle
    });
  }, [a.localeText]);
  return b({}, a, {
    localeText: s
  }, Mo({
    views: a.views,
    openTo: a.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: a.disableFuture ?? !1,
    disablePast: a.disablePast ?? !1,
    minDate: Se(n, a.minDate, r.minDate),
    maxDate: Se(n, a.maxDate, r.maxDate),
    slots: b({
      toolbar: xr
    }, a.slots)
  });
}
function Cu(t) {
  return ge("MuiPickersPopper", t);
}
he("MuiPickersPopper", ["root", "paper"]);
const vu = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], wu = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"],
    paper: ["paper"]
  }, Cu, o);
}, Tu = _(js, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})(({
  theme: t
}) => ({
  zIndex: t.zIndex.modal
})), xu = _($s, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (t, o) => o.paper
})({
  outline: 0,
  transformOrigin: "top center",
  variants: [{
    props: ({
      placement: t
    }) => ["top", "top-start", "top-end"].includes(t),
    style: {
      transformOrigin: "bottom center"
    }
  }]
});
function Pu(t, o) {
  return o.documentElement.clientWidth < t.clientX || o.documentElement.clientHeight < t.clientY;
}
function Su(t, o) {
  const n = C.useRef(!1), r = C.useRef(!1), a = C.useRef(null), s = C.useRef(!1);
  C.useEffect(() => {
    if (!t)
      return;
    function c() {
      s.current = !0;
    }
    return document.addEventListener("mousedown", c, !0), document.addEventListener("touchstart", c, !0), () => {
      document.removeEventListener("mousedown", c, !0), document.removeEventListener("touchstart", c, !0), s.current = !1;
    };
  }, [t]);
  const i = Z((c) => {
    if (!s.current)
      return;
    const p = r.current;
    r.current = !1;
    const m = po(a.current);
    if (!a.current || // is a TouchEvent?
    "clientX" in c && Pu(c, m))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let f;
    c.composedPath ? f = c.composedPath().indexOf(a.current) > -1 : f = !m.documentElement.contains(c.target) || a.current.contains(c.target), !f && !p && o(c);
  }), l = () => {
    r.current = !0;
  };
  return C.useEffect(() => {
    if (t) {
      const c = po(a.current), p = () => {
        n.current = !0;
      };
      return c.addEventListener("touchstart", i), c.addEventListener("touchmove", p), () => {
        c.removeEventListener("touchstart", i), c.removeEventListener("touchmove", p);
      };
    }
  }, [t, i]), C.useEffect(() => {
    if (t) {
      const c = po(a.current);
      return c.addEventListener("click", i), () => {
        c.removeEventListener("click", i), r.current = !1;
      };
    }
  }, [t, i]), [a, l, l];
}
const ku = /* @__PURE__ */ C.forwardRef((t, o) => {
  const {
    PaperComponent: n,
    popperPlacement: r,
    ownerState: a,
    children: s,
    paperSlotProps: i,
    paperClasses: l,
    onPaperClick: c,
    onPaperTouchStart: p
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = t, m = ne(t, vu), f = b({}, a, {
    placement: r
  }), d = pe({
    elementType: n,
    externalSlotProps: i,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: o
    },
    className: l,
    ownerState: f
  });
  return /* @__PURE__ */ u(n, b({}, m, d, {
    onClick: (g) => {
      var h;
      c(g), (h = d.onClick) == null || h.call(d, g);
    },
    onTouchStart: (g) => {
      var h;
      p(g), (h = d.onTouchStart) == null || h.call(d, g);
    },
    ownerState: f,
    children: s
  }));
});
function Ru(t) {
  const o = le({
    props: t,
    name: "MuiPickersPopper"
  }), {
    anchorEl: n,
    children: r,
    containerRef: a = null,
    shouldRestoreFocus: s,
    onBlur: i,
    onDismiss: l,
    open: c,
    role: p,
    placement: m,
    slots: f,
    slotProps: d,
    reduceAnimations: g
  } = o;
  C.useEffect(() => {
    function F(L) {
      c && L.key === "Escape" && l();
    }
    return document.addEventListener("keydown", F), () => {
      document.removeEventListener("keydown", F);
    };
  }, [l, c]);
  const h = C.useRef(null);
  C.useEffect(() => {
    p === "tooltip" || s && !s() || (c ? h.current = Ve(document) : h.current && h.current instanceof HTMLElement && setTimeout(() => {
      h.current instanceof HTMLElement && h.current.focus();
    }));
  }, [c, p, s]);
  const [D, y, x] = Su(c, i ?? l), v = C.useRef(null), P = Le(v, a), T = Le(P, D), S = o, k = wu(S), M = vr(), w = g ?? M, q = (F) => {
    F.key === "Escape" && (F.stopPropagation(), l());
  }, B = (f == null ? void 0 : f.desktopTransition) ?? w ? Kt : Ls, O = (f == null ? void 0 : f.desktopTrapFocus) ?? Bs, V = (f == null ? void 0 : f.desktopPaper) ?? xu, N = (f == null ? void 0 : f.popper) ?? Tu, A = pe({
    elementType: N,
    externalSlotProps: d == null ? void 0 : d.popper,
    additionalProps: {
      transition: !0,
      role: p,
      open: c,
      anchorEl: n,
      placement: m,
      onKeyDown: q
    },
    className: k.root,
    ownerState: o
  });
  return /* @__PURE__ */ u(N, b({}, A, {
    children: ({
      TransitionProps: F,
      placement: L
    }) => /* @__PURE__ */ u(O, b({
      open: c,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: p === "tooltip",
      isEnabled: () => !0
    }, d == null ? void 0 : d.desktopTrapFocus, {
      children: /* @__PURE__ */ u(B, b({}, F, d == null ? void 0 : d.desktopTransition, {
        children: /* @__PURE__ */ u(ku, {
          PaperComponent: V,
          ownerState: S,
          popperPlacement: L,
          ref: T,
          onPaperClick: y,
          onPaperTouchStart: x,
          paperClasses: k.paper,
          paperSlotProps: d == null ? void 0 : d.desktopPaper,
          children: r
        })
      }))
    }))
  }));
}
const Dn = /* @__PURE__ */ new Set();
function Mu(t, o = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const n = Array.isArray(t) ? t.join(`
`) : t;
  Dn.has(n) || (Dn.add(n), o === "error" ? console.error(n) : console.warn(n));
}
const Ou = ({
  open: t,
  onOpen: o,
  onClose: n
}) => {
  const r = C.useRef(typeof t == "boolean").current, [a, s] = C.useState(!1);
  C.useEffect(() => {
    if (r) {
      if (typeof t != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      s(t);
    }
  }, [r, t]);
  const i = C.useCallback((l) => {
    r || s(l), l && o && o(), !l && n && n();
  }, [r, o, n]);
  return {
    isOpen: a,
    setIsOpen: i
  };
}, Fu = (t) => {
  const {
    action: o,
    hasChanged: n,
    dateState: r,
    isControlled: a
  } = t, s = !a && !r.hasBeenModifiedSinceMount;
  return o.name === "setValueFromField" ? !0 : o.name === "setValueFromAction" ? s && ["accept", "today", "clear"].includes(o.pickerAction) ? !0 : n(r.lastPublishedValue) : o.name === "setValueFromView" && o.selectionState !== "shallow" || o.name === "setValueFromShortcut" ? s ? !0 : n(r.lastPublishedValue) : !1;
}, Iu = (t) => {
  const {
    action: o,
    hasChanged: n,
    dateState: r,
    isControlled: a,
    closeOnSelect: s
  } = t, i = !a && !r.hasBeenModifiedSinceMount;
  return o.name === "setValueFromAction" ? i && ["accept", "today", "clear"].includes(o.pickerAction) ? !0 : n(r.lastCommittedValue) : o.name === "setValueFromView" && o.selectionState === "finish" && s ? i ? !0 : n(r.lastCommittedValue) : o.name === "setValueFromShortcut" ? o.changeImportance === "accept" && n(r.lastCommittedValue) : !1;
}, Vu = (t) => {
  const {
    action: o,
    closeOnSelect: n
  } = t;
  return o.name === "setValueFromAction" ? !0 : o.name === "setValueFromView" ? o.selectionState === "finish" && n : o.name === "setValueFromShortcut" ? o.changeImportance === "accept" : !1;
}, Au = ({
  props: t,
  valueManager: o,
  valueType: n,
  wrapperVariant: r,
  validator: a
}) => {
  const {
    onAccept: s,
    onChange: i,
    value: l,
    defaultValue: c,
    closeOnSelect: p = r === "desktop",
    timezone: m,
    referenceDate: f
  } = t, {
    current: d
  } = C.useRef(c), {
    current: g
  } = C.useRef(l !== void 0), [h, D] = C.useState(m);
  process.env.NODE_ENV !== "production" && (C.useEffect(() => {
    g !== (l !== void 0) && console.error([`MUI X: A component is changing the ${g ? "" : "un"}controlled value of a picker to be ${g ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [l]), C.useEffect(() => {
    !g && d !== c && console.error(["MUI X: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(d)]));
  const y = ue(), x = Ht(), {
    isOpen: v,
    setIsOpen: P
  } = Ou(t), {
    timezone: T,
    value: S,
    handleValueChange: k
  } = _n({
    timezone: m,
    value: l,
    defaultValue: d,
    referenceDate: f,
    onChange: i,
    valueManager: o
  }), [M, w] = C.useState(() => {
    let I;
    return S !== void 0 ? I = S : d !== void 0 ? I = d : I = o.emptyValue, {
      draft: I,
      lastPublishedValue: I,
      lastCommittedValue: I,
      lastControlledValue: l,
      hasBeenModifiedSinceMount: !1
    };
  }), q = o.getTimezone(y, M.draft);
  h !== m && (D(m), m && q && m !== q && w((I) => b({}, I, {
    draft: o.setTimezone(y, m, I.draft)
  })));
  const {
    getValidationErrorForNewValue: B
  } = ir({
    props: t,
    validator: a,
    timezone: T,
    value: M.draft,
    onError: t.onError
  }), O = Z((I) => {
    const J = {
      action: I,
      dateState: M,
      hasChanged: (j) => !o.areValuesEqual(y, I.value, j),
      isControlled: g,
      closeOnSelect: p
    }, te = Fu(J), U = Iu(J), R = Vu(J);
    w((j) => b({}, j, {
      draft: I.value,
      lastPublishedValue: te ? I.value : j.lastPublishedValue,
      lastCommittedValue: U ? I.value : j.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    }));
    let W = null;
    const G = () => (W || (W = {
      validationError: I.name === "setValueFromField" ? I.context.validationError : B(I.value)
    }, I.name === "setValueFromShortcut" && (W.shortcut = I.shortcut)), W);
    te && k(I.value, G()), U && s && s(I.value, G()), R && P(!1);
  });
  if (M.lastControlledValue !== l) {
    const I = o.areValuesEqual(y, M.draft, S);
    w((J) => b({}, J, {
      lastControlledValue: l
    }, I ? {} : {
      lastCommittedValue: S,
      lastPublishedValue: S,
      draft: S,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const V = Z(() => {
    O({
      value: o.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), N = Z(() => {
    O({
      value: M.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), A = Z(() => {
    O({
      value: M.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), F = Z(() => {
    O({
      value: M.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), L = Z(() => {
    O({
      value: o.getTodayValue(y, T, n),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), ee = Z((I) => {
    I.preventDefault(), P(!0);
  }), Q = Z((I) => {
    I == null || I.preventDefault(), P(!1);
  }), ae = Z((I, J = "partial") => O({
    name: "setValueFromView",
    value: I,
    selectionState: J
  })), se = Z((I, J, te) => O({
    name: "setValueFromShortcut",
    value: I,
    changeImportance: J,
    shortcut: te
  })), re = Z((I, J) => O({
    name: "setValueFromField",
    value: I,
    context: J
  })), ce = {
    onClear: V,
    onAccept: N,
    onDismiss: A,
    onCancel: F,
    onSetToday: L,
    onOpen: ee,
    onClose: Q
  }, ye = {
    value: M.draft,
    onChange: re
  }, de = C.useMemo(() => o.cleanValue(y, M.draft), [y, o, M.draft]), $ = {
    value: de,
    onChange: ae,
    onClose: Q,
    open: v
  }, H = b({}, ce, {
    value: de,
    onChange: ae,
    onSelectShortcut: se,
    isValid: (I) => {
      const J = a({
        adapter: x,
        value: I,
        timezone: T,
        props: t
      });
      return !o.hasError(J);
    }
  }), E = C.useMemo(() => ({
    onOpen: ee,
    onClose: Q,
    open: v
  }), [v, Q, ee]);
  return {
    open: v,
    fieldProps: ye,
    viewProps: $,
    layoutProps: H,
    actions: ce,
    contextValue: E
  };
}, Eu = ["className", "sx"], Lu = ({
  props: t,
  propsFromPickerValue: o,
  additionalViewProps: n,
  autoFocusView: r,
  rendererInterceptor: a,
  fieldRef: s
}) => {
  const {
    onChange: i,
    open: l,
    onClose: c
  } = o, {
    view: p,
    views: m,
    openTo: f,
    onViewChange: d,
    viewRenderers: g,
    timezone: h
  } = t, D = ne(t, Eu), {
    view: y,
    setView: x,
    defaultView: v,
    focusedView: P,
    setFocusedView: T,
    setValueAndGoToNextView: S
  } = Hn({
    view: p,
    views: m,
    openTo: f,
    onChange: i,
    onViewChange: d,
    autoFocus: r
  }), {
    hasUIView: k,
    viewModeLookup: M
  } = C.useMemo(() => m.reduce((A, F) => {
    let L;
    return g[F] != null ? L = "UI" : L = "field", A.viewModeLookup[F] = L, L === "UI" && (A.hasUIView = !0), A;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [g, m]), w = C.useMemo(() => m.reduce((A, F) => g[F] != null && zn(F) ? A + 1 : A, 0), [g, m]), q = M[y], B = Z(() => q === "UI"), [O, V] = C.useState(q === "UI" ? y : null);
  return O !== y && M[y] === "UI" && V(y), Ye(() => {
    q === "field" && l && (c(), setTimeout(() => {
      var A, F;
      (A = s == null ? void 0 : s.current) == null || A.setSelectedSections(y), (F = s == null ? void 0 : s.current) == null || F.focusField(y);
    }));
  }, [y]), Ye(() => {
    if (!l)
      return;
    let A = y;
    q === "field" && O != null && (A = O), A !== v && M[A] === "UI" && M[v] === "UI" && (A = v), A !== y && x(A), T(A, !0);
  }, [l]), {
    hasUIView: k,
    shouldRestoreFocus: B,
    layoutProps: {
      views: m,
      view: O,
      onViewChange: x
    },
    renderCurrentView: () => {
      if (O == null)
        return null;
      const A = g[O];
      if (A == null)
        return null;
      const F = b({}, D, n, o, {
        views: m,
        timezone: h,
        onChange: S,
        view: O,
        onViewChange: x,
        focusedView: P,
        onFocusedViewChange: T,
        showViewSwitcher: w > 1,
        timeViewsCount: w
      });
      return a ? a(g, O, F) : A(F);
    }
  };
};
function Cn() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const $u = (t, o) => {
  const [n, r] = C.useState(Cn);
  return Ye(() => {
    const s = () => {
      r(Cn());
    };
    return window.addEventListener("orientationchange", s), () => {
      window.removeEventListener("orientationchange", s);
    };
  }, []), nt(t, ["hours", "minutes", "seconds"]) ? !1 : (o || n) === "landscape";
}, ju = ({
  props: t,
  propsFromPickerValue: o,
  propsFromPickerViews: n,
  wrapperVariant: r
}) => {
  const {
    orientation: a
  } = t, s = $u(n.views, a), i = _e();
  return {
    layoutProps: b({}, n, o, {
      isLandscape: s,
      isRtl: i,
      wrapperVariant: r,
      disabled: t.disabled,
      readOnly: t.readOnly
    })
  };
};
function Bu(t) {
  const {
    props: o,
    pickerValueResponse: n
  } = t;
  return C.useMemo(() => ({
    value: n.viewProps.value,
    open: n.open,
    disabled: o.disabled ?? !1,
    readOnly: o.readOnly ?? !1
  }), [n.viewProps.value, n.open, o.disabled, o.readOnly]);
}
const Sr = ({
  props: t,
  valueManager: o,
  valueType: n,
  wrapperVariant: r,
  additionalViewProps: a,
  validator: s,
  autoFocusView: i,
  rendererInterceptor: l,
  fieldRef: c
}) => {
  process.env.NODE_ENV !== "production" && t.renderInput != null && Mu(["MUI X: The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]);
  const p = Au({
    props: t,
    valueManager: o,
    valueType: n,
    wrapperVariant: r,
    validator: s
  }), m = Lu({
    props: t,
    additionalViewProps: a,
    autoFocusView: i,
    fieldRef: c,
    propsFromPickerValue: p.viewProps,
    rendererInterceptor: l
  }), f = ju({
    props: t,
    wrapperVariant: r,
    propsFromPickerValue: p.layoutProps,
    propsFromPickerViews: m.layoutProps
  }), d = Bu({
    props: t,
    pickerValueResponse: p
  });
  return {
    // Picker value
    open: p.open,
    actions: p.actions,
    fieldProps: p.fieldProps,
    // Picker views
    renderCurrentView: m.renderCurrentView,
    hasUIView: m.hasUIView,
    shouldRestoreFocus: m.shouldRestoreFocus,
    // Picker layout
    layoutProps: f.layoutProps,
    // Picker context
    contextValue: p.contextValue,
    // Picker owner state
    ownerState: d
  };
};
function kr(t) {
  return ge("MuiPickersLayout", t);
}
const qe = he("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]), Nu = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function Rr(t) {
  const {
    onAccept: o,
    onClear: n,
    onCancel: r,
    onSetToday: a,
    actions: s
  } = t, i = ne(t, Nu), l = ke();
  if (s == null || s.length === 0)
    return null;
  const c = s == null ? void 0 : s.map((p) => {
    switch (p) {
      case "clear":
        return /* @__PURE__ */ u(wt, {
          onClick: n,
          children: l.clearButtonLabel
        }, p);
      case "cancel":
        return /* @__PURE__ */ u(wt, {
          onClick: r,
          children: l.cancelButtonLabel
        }, p);
      case "accept":
        return /* @__PURE__ */ u(wt, {
          onClick: o,
          children: l.okButtonLabel
        }, p);
      case "today":
        return /* @__PURE__ */ u(wt, {
          onClick: a,
          children: l.todayButtonLabel
        }, p);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ u(Ns, b({}, i, {
    children: c
  }));
}
process.env.NODE_ENV !== "production" && (Rr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: e.arrayOf(e.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: e.bool,
  onAccept: e.func.isRequired,
  onCancel: e.func.isRequired,
  onClear: e.func.isRequired,
  onSetToday: e.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object])
});
const qu = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], Wu = ["getValue"];
function Mr(t) {
  const {
    items: o,
    changeImportance: n = "accept",
    onChange: r,
    isValid: a
  } = t, s = ne(t, qu);
  if (o == null || o.length === 0)
    return null;
  const i = o.map((l) => {
    let {
      getValue: c
    } = l, p = ne(l, Wu);
    const m = c({
      isValid: a
    });
    return b({}, p, {
      label: p.label,
      onClick: () => {
        r(m, n, p);
      },
      disabled: !a(m)
    });
  });
  return /* @__PURE__ */ u(qs, b({
    dense: !0,
    sx: [{
      maxHeight: Ro,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(s.sx) ? s.sx : [s.sx]]
  }, s, {
    children: i.map((l) => /* @__PURE__ */ u(Ws, {
      children: /* @__PURE__ */ u(_s, b({}, l))
    }, l.id ?? l.label))
  }));
}
process.env.NODE_ENV !== "production" && (Mr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: e.oneOf(["accept", "set"]),
  className: e.string,
  component: e.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: e.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: e.bool,
  isLandscape: e.bool.isRequired,
  isValid: e.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default []
   */
  items: e.arrayOf(e.shape({
    getValue: e.func.isRequired,
    id: e.string,
    label: e.string.isRequired
  })),
  onChange: e.func.isRequired,
  style: e.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: e.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object])
});
function _u(t) {
  return t.view !== null;
}
const Hu = (t) => {
  const {
    classes: o,
    isLandscape: n
  } = t;
  return me({
    root: ["root", n && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, kr, o);
}, Or = (t) => {
  const {
    wrapperVariant: o,
    onAccept: n,
    onClear: r,
    onCancel: a,
    onSetToday: s,
    view: i,
    views: l,
    onViewChange: c,
    value: p,
    onChange: m,
    onSelectShortcut: f,
    isValid: d,
    isLandscape: g,
    disabled: h,
    readOnly: D,
    children: y,
    slots: x,
    slotProps: v
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = t, P = Hu(t), T = (x == null ? void 0 : x.actionBar) ?? Rr, S = pe({
    elementType: T,
    externalSlotProps: v == null ? void 0 : v.actionBar,
    additionalProps: {
      onAccept: n,
      onClear: r,
      onCancel: a,
      onSetToday: s,
      actions: o === "desktop" ? [] : ["cancel", "accept"]
    },
    className: P.actionBar,
    ownerState: b({}, t, {
      wrapperVariant: o
    })
  }), k = /* @__PURE__ */ u(T, b({}, S)), M = x == null ? void 0 : x.toolbar, w = pe({
    elementType: M,
    externalSlotProps: v == null ? void 0 : v.toolbar,
    additionalProps: {
      isLandscape: g,
      onChange: m,
      value: p,
      view: i,
      onViewChange: c,
      views: l,
      disabled: h,
      readOnly: D
    },
    className: P.toolbar,
    ownerState: b({}, t, {
      wrapperVariant: o
    })
  }), q = _u(w) && M ? /* @__PURE__ */ u(M, b({}, w)) : null, B = y, O = x == null ? void 0 : x.tabs, V = i && O ? /* @__PURE__ */ u(O, b({
    view: i,
    onViewChange: c,
    className: P.tabs
  }, v == null ? void 0 : v.tabs)) : null, N = (x == null ? void 0 : x.shortcuts) ?? Mr, A = pe({
    elementType: N,
    externalSlotProps: v == null ? void 0 : v.shortcuts,
    additionalProps: {
      isValid: d,
      isLandscape: g,
      onChange: f
    },
    className: P.shortcuts,
    ownerState: {
      isValid: d,
      isLandscape: g,
      onChange: f,
      wrapperVariant: o
    }
  }), F = i && N ? /* @__PURE__ */ u(N, b({}, A)) : null;
  return {
    toolbar: q,
    content: B,
    tabs: V,
    actionBar: k,
    shortcuts: F
  };
}, zu = (t) => {
  const {
    isLandscape: o,
    classes: n
  } = t;
  return me({
    root: ["root", o && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, kr, n);
}, Fr = _("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${qe.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      [`& .${qe.toolbar}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      },
      [`.${qe.shortcuts}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      }
    }
  }, {
    props: {
      isLandscape: !0,
      isRtl: !0
    },
    style: {
      [`& .${qe.toolbar}`]: {
        gridColumn: 3
      }
    }
  }, {
    props: {
      isLandscape: !1
    },
    style: {
      [`& .${qe.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      },
      [`& .${qe.shortcuts}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      }
    }
  }, {
    props: {
      isLandscape: !1,
      isRtl: !0
    },
    style: {
      [`& .${qe.shortcuts}`]: {
        gridColumn: 3
      }
    }
  }]
}), Ir = _("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (t, o) => o.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), Yo = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiPickersLayout"
  }), {
    toolbar: a,
    content: s,
    tabs: i,
    actionBar: l,
    shortcuts: c
  } = Or(r), {
    sx: p,
    className: m,
    isLandscape: f,
    wrapperVariant: d
  } = r, g = zu(r);
  return /* @__PURE__ */ z(Fr, {
    ref: n,
    sx: p,
    className: Ce(g.root, m),
    ownerState: r,
    children: [f ? c : a, f ? a : c, /* @__PURE__ */ u(Ir, {
      className: g.contentWrapper,
      children: d === "desktop" ? /* @__PURE__ */ z(C.Fragment, {
        children: [s, i]
      }) : /* @__PURE__ */ z(C.Fragment, {
        children: [i, s]
      })
    }), l]
  });
});
process.env.NODE_ENV !== "production" && (Yo.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  className: e.string,
  disabled: e.bool,
  isLandscape: e.bool.isRequired,
  /**
   * `true` if the application is in right-to-left direction.
   */
  isRtl: e.bool.isRequired,
  isValid: e.func.isRequired,
  onAccept: e.func.isRequired,
  onCancel: e.func.isRequired,
  onChange: e.func.isRequired,
  onClear: e.func.isRequired,
  onClose: e.func.isRequired,
  onDismiss: e.func.isRequired,
  onOpen: e.func.isRequired,
  onSelectShortcut: e.func.isRequired,
  onSetToday: e.func.isRequired,
  onViewChange: e.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  value: e.any,
  view: e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: e.arrayOf(e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: e.oneOf(["desktop", "mobile"])
});
const Uu = ["props", "getOpenDialogAriaText"], Yu = ["ownerState"], Ku = ["ownerState"], Ko = (t) => {
  var G;
  let {
    props: o,
    getOpenDialogAriaText: n
  } = t, r = ne(t, Uu);
  const {
    slots: a,
    slotProps: s,
    className: i,
    sx: l,
    format: c,
    formatDensity: p,
    enableAccessibleFieldDOMStructure: m,
    selectedSections: f,
    onSelectedSectionsChange: d,
    timezone: g,
    name: h,
    label: D,
    inputRef: y,
    readOnly: x,
    disabled: v,
    autoFocus: P,
    localeText: T,
    reduceAnimations: S
  } = o, k = C.useRef(null), M = C.useRef(null), w = Ft(), q = ((G = s == null ? void 0 : s.toolbar) == null ? void 0 : G.hidden) ?? !1, {
    open: B,
    actions: O,
    hasUIView: V,
    layoutProps: N,
    renderCurrentView: A,
    shouldRestoreFocus: F,
    fieldProps: L,
    contextValue: ee,
    ownerState: Q
  } = Sr(b({}, r, {
    props: o,
    fieldRef: M,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), ae = a.inputAdornment ?? Xn, se = pe({
    elementType: ae,
    externalSlotProps: s == null ? void 0 : s.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: o
  }), re = ne(se, Yu), ce = a.openPickerButton ?? Io, ye = pe({
    elementType: ce,
    externalSlotProps: s == null ? void 0 : s.openPickerButton,
    additionalProps: {
      disabled: v || x,
      onClick: B ? O.onClose : O.onOpen,
      "aria-label": n(L.value),
      edge: re.position
    },
    ownerState: o
  }), de = ne(ye, Ku), $ = a.openPickerIcon, X = pe({
    elementType: $,
    externalSlotProps: s == null ? void 0 : s.openPickerIcon,
    ownerState: Q
  }), H = a.field, E = pe({
    elementType: H,
    externalSlotProps: s == null ? void 0 : s.field,
    additionalProps: b({}, L, q && {
      id: w
    }, {
      readOnly: x,
      disabled: v,
      className: i,
      sx: l,
      format: c,
      formatDensity: p,
      enableAccessibleFieldDOMStructure: m,
      selectedSections: f,
      onSelectedSectionsChange: d,
      timezone: g,
      label: D,
      name: h,
      autoFocus: P && !o.open,
      focused: B ? !0 : void 0
    }, y ? {
      inputRef: y
    } : {}),
    ownerState: o
  });
  V && (E.InputProps = b({}, E.InputProps, {
    ref: k
  }, !o.disableOpenPicker && {
    [`${re.position}Adornment`]: /* @__PURE__ */ u(ae, b({}, re, {
      children: /* @__PURE__ */ u(ce, b({}, de, {
        children: /* @__PURE__ */ u($, b({}, X))
      }))
    }))
  }));
  const I = b({
    textField: a.textField,
    clearIcon: a.clearIcon,
    clearButton: a.clearButton
  }, E.slots), J = a.layout ?? Yo;
  let te = w;
  q && (D ? te = `${w}-label` : te = void 0);
  const U = b({}, s, {
    toolbar: b({}, s == null ? void 0 : s.toolbar, {
      titleId: w
    }),
    popper: b({
      "aria-labelledby": te
    }, s == null ? void 0 : s.popper)
  }), R = Le(M, E.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ z(lr, {
      contextValue: ee,
      localeText: T,
      children: [/* @__PURE__ */ u(H, b({}, E, {
        slots: I,
        slotProps: U,
        unstableFieldRef: R
      })), /* @__PURE__ */ u(Ru, b({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: k.current
      }, O, {
        open: B,
        slots: a,
        slotProps: U,
        shouldRestoreFocus: F,
        reduceAnimations: S,
        children: /* @__PURE__ */ u(J, b({}, N, U == null ? void 0 : U.layout, {
          slots: a,
          slotProps: U,
          children: A()
        }))
      }))]
    })
  };
}, Ee = ({
  view: t,
  onViewChange: o,
  views: n,
  focusedView: r,
  onFocusedViewChange: a,
  value: s,
  defaultValue: i,
  referenceDate: l,
  onChange: c,
  className: p,
  classes: m,
  disableFuture: f,
  disablePast: d,
  minDate: g,
  maxDate: h,
  shouldDisableDate: D,
  shouldDisableMonth: y,
  shouldDisableYear: x,
  reduceAnimations: v,
  onMonthChange: P,
  monthsPerRow: T,
  onYearChange: S,
  yearsOrder: k,
  yearsPerRow: M,
  slots: w,
  slotProps: q,
  loading: B,
  renderLoading: O,
  disableHighlightToday: V,
  readOnly: N,
  disabled: A,
  showDaysOutsideCurrentMonth: F,
  dayOfWeekFormatter: L,
  sx: ee,
  autoFocus: Q,
  fixedWeekNumber: ae,
  displayWeekNumber: se,
  timezone: re
}) => /* @__PURE__ */ u(wr, {
  view: t,
  onViewChange: o,
  views: n.filter(ut),
  focusedView: r && ut(r) ? r : null,
  onFocusedViewChange: a,
  value: s,
  defaultValue: i,
  referenceDate: l,
  onChange: c,
  className: p,
  classes: m,
  disableFuture: f,
  disablePast: d,
  minDate: g,
  maxDate: h,
  shouldDisableDate: D,
  shouldDisableMonth: y,
  shouldDisableYear: x,
  reduceAnimations: v,
  onMonthChange: P,
  monthsPerRow: T,
  onYearChange: S,
  yearsOrder: k,
  yearsPerRow: M,
  slots: w,
  slotProps: q,
  loading: B,
  renderLoading: O,
  disableHighlightToday: V,
  readOnly: N,
  disabled: A,
  showDaysOutsideCurrentMonth: F,
  dayOfWeekFormatter: L,
  sx: ee,
  autoFocus: Q,
  fixedWeekNumber: ae,
  displayWeekNumber: se,
  timezone: re
}), Vr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  var p, m;
  const r = ke(), a = ue(), s = Pr(o, "MuiDesktopDatePicker"), i = b({
    day: Ee,
    month: Ee,
    year: Ee
  }, s.viewRenderers), l = b({}, s, {
    viewRenderers: i,
    format: Mt(a, s, !1),
    yearsPerRow: s.yearsPerRow ?? 4,
    slots: b({
      openPickerIcon: Un,
      field: _o
    }, s.slots),
    slotProps: b({}, s.slotProps, {
      field: (f) => {
        var d;
        return b({}, Xe((d = s.slotProps) == null ? void 0 : d.field, f), ht(s), {
          ref: n
        });
      },
      toolbar: b({
        hidden: !0
      }, (p = s.slotProps) == null ? void 0 : p.toolbar)
    })
  }), {
    renderPicker: c
  } = Ko({
    props: l,
    valueManager: xe,
    valueType: "date",
    getOpenDialogAriaText: ft({
      utils: a,
      formatKey: "fullDate",
      contextTranslation: r.openDatePickerDialogue,
      propsTranslation: (m = l.localeText) == null ? void 0 : m.openDatePickerDialogue
    }),
    validator: bt
  });
  return c();
});
Vr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: e.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: e.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: e.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: e.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: e.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: e.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: e.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: e.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: e.shape({
    day: e.func,
    month: e.func,
    year: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: e.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: e.oneOf([3, 4])
};
const Gu = _(zs)({
  [`& .${fn.container}`]: {
    outline: 0
  },
  [`& .${fn.paper}`]: {
    outline: 0,
    minWidth: So
  }
}), Qu = _(Hs)({
  "&:first-of-type": {
    padding: 0
  }
});
function Zu(t) {
  const {
    children: o,
    onDismiss: n,
    open: r,
    slots: a,
    slotProps: s
  } = t, i = (a == null ? void 0 : a.dialog) ?? Gu, l = (a == null ? void 0 : a.mobileTransition) ?? Kt;
  return /* @__PURE__ */ u(i, b({
    open: r,
    onClose: n
  }, s == null ? void 0 : s.dialog, {
    TransitionComponent: l,
    TransitionProps: s == null ? void 0 : s.mobileTransition,
    PaperComponent: a == null ? void 0 : a.mobilePaper,
    PaperProps: s == null ? void 0 : s.mobilePaper,
    children: /* @__PURE__ */ u(Qu, {
      children: o
    })
  }));
}
const Xu = ["props", "getOpenDialogAriaText"], Go = (t) => {
  var re;
  let {
    props: o,
    getOpenDialogAriaText: n
  } = t, r = ne(t, Xu);
  const {
    slots: a,
    slotProps: s,
    className: i,
    sx: l,
    format: c,
    formatDensity: p,
    enableAccessibleFieldDOMStructure: m,
    selectedSections: f,
    onSelectedSectionsChange: d,
    timezone: g,
    name: h,
    label: D,
    inputRef: y,
    readOnly: x,
    disabled: v,
    localeText: P
  } = o, T = C.useRef(null), S = Ft(), k = ((re = s == null ? void 0 : s.toolbar) == null ? void 0 : re.hidden) ?? !1, {
    open: M,
    actions: w,
    layoutProps: q,
    renderCurrentView: B,
    fieldProps: O,
    contextValue: V
  } = Sr(b({}, r, {
    props: o,
    fieldRef: T,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), N = a.field, A = pe({
    elementType: N,
    externalSlotProps: s == null ? void 0 : s.field,
    additionalProps: b({}, O, k && {
      id: S
    }, !(v || x) && {
      onClick: w.onOpen,
      onKeyDown: Ps(w.onOpen)
    }, {
      readOnly: x ?? !0,
      disabled: v,
      className: i,
      sx: l,
      format: c,
      formatDensity: p,
      enableAccessibleFieldDOMStructure: m,
      selectedSections: f,
      onSelectedSectionsChange: d,
      timezone: g,
      label: D,
      name: h
    }, y ? {
      inputRef: y
    } : {}),
    ownerState: o
  });
  A.inputProps = b({}, A.inputProps, {
    "aria-label": n(O.value)
  });
  const F = b({
    textField: a.textField
  }, A.slots), L = a.layout ?? Yo;
  let ee = S;
  k && (D ? ee = `${S}-label` : ee = void 0);
  const Q = b({}, s, {
    toolbar: b({}, s == null ? void 0 : s.toolbar, {
      titleId: S
    }),
    mobilePaper: b({
      "aria-labelledby": ee
    }, s == null ? void 0 : s.mobilePaper)
  }), ae = Le(T, A.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ z(lr, {
      contextValue: V,
      localeText: P,
      children: [/* @__PURE__ */ u(N, b({}, A, {
        slots: F,
        slotProps: Q,
        unstableFieldRef: ae
      })), /* @__PURE__ */ u(Zu, b({}, w, {
        open: M,
        slots: a,
        slotProps: Q,
        children: /* @__PURE__ */ u(L, b({}, q, Q == null ? void 0 : Q.layout, {
          slots: a,
          slotProps: Q,
          children: B()
        }))
      }))]
    })
  };
}, Ar = /* @__PURE__ */ C.forwardRef(function(o, n) {
  var p, m;
  const r = ke(), a = ue(), s = Pr(o, "MuiMobileDatePicker"), i = b({
    day: Ee,
    month: Ee,
    year: Ee
  }, s.viewRenderers), l = b({}, s, {
    viewRenderers: i,
    format: Mt(a, s, !1),
    slots: b({
      field: _o
    }, s.slots),
    slotProps: b({}, s.slotProps, {
      field: (f) => {
        var d;
        return b({}, Xe((d = s.slotProps) == null ? void 0 : d.field, f), ht(s), {
          ref: n
        });
      },
      toolbar: b({
        hidden: !1
      }, (p = s.slotProps) == null ? void 0 : p.toolbar)
    })
  }), {
    renderPicker: c
  } = Go({
    props: l,
    valueManager: xe,
    valueType: "date",
    getOpenDialogAriaText: ft({
      utils: a,
      formatKey: "fullDate",
      contextTranslation: r.openDatePickerDialogue,
      propsTranslation: (m = l.localeText) == null ? void 0 : m.openDatePickerDialogue
    }),
    validator: bt
  });
  return c();
});
Ar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: e.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: e.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: e.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: e.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: e.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: e.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: e.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: e.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: e.shape({
    day: e.func,
    month: e.func,
    year: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: e.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: e.oneOf([3, 4])
};
const Ju = ["desktopModeMediaQuery"], Er = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiDatePicker"
  }), {
    desktopModeMediaQuery: a = Oo
  } = r, s = ne(r, Ju);
  return Yt(a, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ u(Vr, b({
    ref: n
  }, s)) : /* @__PURE__ */ u(Ar, b({
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (Er.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: e.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: e.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: e.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: e.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: e.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: e.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: e.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: e.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: e.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: e.shape({
    day: e.func,
    month: e.func,
    year: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: e.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: e.oneOf([3, 4])
});
function ed(t) {
  return ge("MuiPickersToolbarText", t);
}
const yo = he("MuiPickersToolbarText", ["root", "selected"]), td = ["className", "selected", "value"], od = (t) => {
  const {
    classes: o,
    selected: n
  } = t;
  return me({
    root: ["root", n && "selected"]
  }, ed, o);
}, nd = _(mt, {
  name: "MuiPickersToolbarText",
  slot: "Root",
  overridesResolver: (t, o) => [o.root, {
    [`&.${yo.selected}`]: o.selected
  }]
})(({
  theme: t
}) => ({
  transition: t.transitions.create("color"),
  color: (t.vars || t).palette.text.secondary,
  [`&.${yo.selected}`]: {
    color: (t.vars || t).palette.text.primary
  }
})), Qo = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiPickersToolbarText"
  }), {
    className: a,
    value: s
  } = r, i = ne(r, td), l = od(r);
  return /* @__PURE__ */ u(nd, b({
    ref: n,
    className: Ce(l.root, a),
    component: "span"
  }, i, {
    children: s
  }));
}), rd = ["align", "className", "selected", "typographyClassName", "value", "variant", "width"], ad = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"]
  }, Tr, o);
}, sd = _(wt, {
  name: "MuiPickersToolbarButton",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({
  padding: 0,
  minWidth: 16,
  textTransform: "none"
}), Me = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiPickersToolbarButton"
  }), {
    align: a,
    className: s,
    selected: i,
    typographyClassName: l,
    value: c,
    variant: p,
    width: m
  } = r, f = ne(r, rd), d = ad(r);
  return /* @__PURE__ */ u(sd, b({
    variant: "text",
    ref: n,
    className: Ce(d.root, s)
  }, m ? {
    sx: {
      width: m
    }
  } : {}, f, {
    children: /* @__PURE__ */ u(Qo, {
      align: a,
      className: l,
      variant: p,
      value: c,
      selected: i
    })
  }));
});
function id(t) {
  return ge("MuiTimePickerToolbar", t);
}
const St = he("MuiTimePickerToolbar", ["root", "separator", "hourMinuteLabel", "hourMinuteLabelLandscape", "hourMinuteLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), ld = ["ampm", "ampmInClock", "value", "isLandscape", "onChange", "view", "onViewChange", "views", "disabled", "readOnly", "className"], cd = (t) => {
  const {
    isLandscape: o,
    classes: n,
    isRtl: r
  } = t;
  return me({
    root: ["root"],
    separator: ["separator"],
    hourMinuteLabel: ["hourMinuteLabel", o && "hourMinuteLabelLandscape", r && "hourMinuteLabelReverse"],
    ampmSelection: ["ampmSelection", o && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  }, id, n);
}, ud = _(Uo, {
  name: "MuiTimePickerToolbar",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({}), dd = _(Qo, {
  name: "MuiTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (t, o) => o.separator
})({
  outline: 0,
  margin: "0 4px 0 2px",
  cursor: "default"
}), pd = _("div", {
  name: "MuiTimePickerToolbar",
  slot: "HourMinuteLabel",
  overridesResolver: (t, o) => [{
    [`&.${St.hourMinuteLabelLandscape}`]: o.hourMinuteLabelLandscape,
    [`&.${St.hourMinuteLabelReverse}`]: o.hourMinuteLabelReverse
  }, o.hourMinuteLabel]
})({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      isLandscape: !0
    },
    style: {
      marginTop: "auto"
    }
  }]
}), fd = _("div", {
  name: "MuiTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (t, o) => [{
    [`.${St.ampmLabel}`]: o.ampmLabel
  }, {
    [`&.${St.ampmLandscape}`]: o.ampmLandscape
  }, o.ampmSelection]
})({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12,
  [`& .${St.ampmLabel}`]: {
    fontSize: 17
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "4px 0 auto",
      flexDirection: "row",
      justifyContent: "space-around",
      flexBasis: "100%"
    }
  }]
});
function Lr(t) {
  const o = le({
    props: t,
    name: "MuiTimePickerToolbar"
  }), {
    ampm: n,
    ampmInClock: r,
    value: a,
    isLandscape: s,
    onChange: i,
    view: l,
    onViewChange: c,
    views: p,
    disabled: m,
    readOnly: f,
    className: d
  } = o, g = ne(o, ld), h = ue(), D = ke(), y = _e(), x = !!(n && !r && p.includes("hours")), {
    meridiemMode: v,
    handleMeridiemChange: P
  } = Yn(a, n, i), T = (w) => n ? h.format(w, "hours12h") : h.format(w, "hours24h"), S = b({}, o, {
    isRtl: y
  }), k = cd(S), M = /* @__PURE__ */ u(dd, {
    tabIndex: -1,
    value: ":",
    variant: "h3",
    selected: !1,
    className: k.separator
  });
  return /* @__PURE__ */ z(ud, b({
    landscapeDirection: "row",
    toolbarTitle: D.timePickerToolbarTitle,
    isLandscape: s,
    ownerState: S,
    className: Ce(k.root, d)
  }, g, {
    children: [/* @__PURE__ */ z(pd, {
      className: k.hourMinuteLabel,
      ownerState: S,
      children: [nt(p, "hours") && /* @__PURE__ */ u(Me, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => c("hours"),
        selected: l === "hours",
        value: a ? T(a) : "--"
      }), nt(p, ["hours", "minutes"]) && M, nt(p, "minutes") && /* @__PURE__ */ u(Me, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => c("minutes"),
        selected: l === "minutes",
        value: a ? h.format(a, "minutes") : "--"
      }), nt(p, ["minutes", "seconds"]) && M, nt(p, "seconds") && /* @__PURE__ */ u(Me, {
        variant: "h3",
        onClick: () => c("seconds"),
        selected: l === "seconds",
        value: a ? h.format(a, "seconds") : "--"
      })]
    }), x && /* @__PURE__ */ z(fd, {
      className: k.ampmSelection,
      ownerState: S,
      children: [/* @__PURE__ */ u(Me, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: v === "am",
        typographyClassName: k.ampmLabel,
        value: Pt(h, "am"),
        onClick: f ? void 0 : () => P("am"),
        disabled: m
      }), /* @__PURE__ */ u(Me, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: v === "pm",
        typographyClassName: k.ampmLabel,
        value: Pt(h, "pm"),
        onClick: f ? void 0 : () => P("pm"),
        disabled: m
      })]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (Lr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  ampm: e.bool,
  ampmInClock: e.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  className: e.string,
  disabled: e.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: e.bool,
  isLandscape: e.bool.isRequired,
  onChange: e.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: e.func.isRequired,
  readOnly: e.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  titleId: e.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: e.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: e.node,
  value: e.object,
  /**
   * Currently visible picker view.
   */
  view: e.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired,
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired).isRequired
});
function $r(t, o) {
  var i;
  const n = ue(), r = le({
    props: t,
    name: o
  }), a = r.ampm ?? n.is12HourCycleInCurrentLocale(), s = C.useMemo(() => {
    var l;
    return ((l = r.localeText) == null ? void 0 : l.toolbarTitle) == null ? r.localeText : b({}, r.localeText, {
      timePickerToolbarTitle: r.localeText.toolbarTitle
    });
  }, [r.localeText]);
  return b({}, r, {
    ampm: a,
    localeText: s
  }, Mo({
    views: r.views,
    openTo: r.openTo,
    defaultViews: ["hours", "minutes"],
    defaultOpenTo: "hours"
  }), {
    disableFuture: r.disableFuture ?? !1,
    disablePast: r.disablePast ?? !1,
    slots: b({
      toolbar: Lr
    }, r.slots),
    slotProps: b({}, r.slotProps, {
      toolbar: b({
        ampm: a,
        ampmInClock: r.ampmInClock
      }, (i = r.slotProps) == null ? void 0 : i.toolbar)
    })
  });
}
const md = ["views", "format"], jr = (t, o, n) => {
  let {
    views: r,
    format: a
  } = o, s = ne(o, md);
  if (a)
    return a;
  const i = [], l = [];
  if (r.forEach((m) => {
    zn(m) ? l.push(m) : ut(m) && i.push(m);
  }), l.length === 0)
    return Mt(t, b({
      views: i
    }, s), !1);
  if (i.length === 0)
    return $t(t, b({
      views: l
    }, s));
  const c = $t(t, b({
    views: l
  }, s));
  return `${Mt(t, b({
    views: i
  }, s), !1)} ${c}`;
}, bd = (t, o, n) => n ? o.filter((r) => !vt(r) || r === "hours") : t ? [...o, "meridiem"] : o, hd = (t, o) => 24 * 60 / ((t.hours ?? 1) * (t.minutes ?? 5)) <= o;
function Br({
  thresholdToRenderTimeInASingleColumn: t,
  ampm: o,
  timeSteps: n,
  views: r
}) {
  const a = t ?? 24, s = b({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, n), i = hd(s, a);
  return {
    thresholdToRenderTimeInASingleColumn: a,
    timeSteps: s,
    shouldRenderTimeInASingleColumn: i,
    views: bd(o, r, i)
  };
}
const Nr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  var x, v, P, T;
  const r = ke(), a = ue(), s = $r(o, "MuiDesktopTimePicker"), {
    shouldRenderTimeInASingleColumn: i,
    views: l,
    timeSteps: c
  } = Br(s), p = i ? Kn : jt, m = b({
    hours: p,
    minutes: p,
    seconds: p,
    meridiem: p
  }, s.viewRenderers), f = s.ampmInClock ?? !0, d = i ? [] : ["accept"], h = ((x = m.hours) == null ? void 0 : x.name) === jt.name ? l : l.filter((S) => S !== "meridiem"), D = b({}, s, {
    ampmInClock: f,
    timeSteps: c,
    viewRenderers: m,
    format: $t(a, s),
    // Setting only `hours` time view in case of single column time picker
    // Allows for easy view lifecycle management
    views: i ? ["hours"] : h,
    slots: b({
      field: Ho,
      openPickerIcon: Ss
    }, s.slots),
    slotProps: b({}, s.slotProps, {
      field: (S) => {
        var k;
        return b({}, Xe((k = s.slotProps) == null ? void 0 : k.field, S), ht(s), {
          ref: n
        });
      },
      toolbar: b({
        hidden: !0,
        ampmInClock: f
      }, (v = s.slotProps) == null ? void 0 : v.toolbar),
      actionBar: b({
        actions: d
      }, (P = s.slotProps) == null ? void 0 : P.actionBar)
    })
  }), {
    renderPicker: y
  } = Ko({
    props: D,
    valueManager: xe,
    valueType: "time",
    getOpenDialogAriaText: ft({
      utils: a,
      formatKey: "fullTime",
      contextTranslation: r.openTimePickerDialogue,
      propsTranslation: (T = D.localeText) == null ? void 0 : T.openTimePickerDialogue
    }),
    validator: It
  });
  return y();
});
Nr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: e.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: e.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.any,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: e.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: e.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: e.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.object,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: e.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: e.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: e.shape({
    hours: e.number,
    minutes: e.number,
    seconds: e.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: e.shape({
    hours: e.func,
    meridiem: e.func,
    minutes: e.func,
    seconds: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const qr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  var m, f;
  const r = ke(), a = ue(), s = $r(o, "MuiMobileTimePicker"), i = b({
    hours: at,
    minutes: at,
    seconds: at
  }, s.viewRenderers), l = s.ampmInClock ?? !1, c = b({}, s, {
    ampmInClock: l,
    viewRenderers: i,
    format: $t(a, s),
    slots: b({
      field: Ho
    }, s.slots),
    slotProps: b({}, s.slotProps, {
      field: (d) => {
        var g;
        return b({}, Xe((g = s.slotProps) == null ? void 0 : g.field, d), ht(s), {
          ref: n
        });
      },
      toolbar: b({
        hidden: !1,
        ampmInClock: l
      }, (m = s.slotProps) == null ? void 0 : m.toolbar)
    })
  }), {
    renderPicker: p
  } = Go({
    props: c,
    valueManager: xe,
    valueType: "time",
    getOpenDialogAriaText: ft({
      utils: a,
      formatKey: "fullTime",
      contextTranslation: r.openTimePickerDialogue,
      propsTranslation: (f = c.localeText) == null ? void 0 : f.openTimePickerDialogue
    }),
    validator: It
  });
  return p();
});
qr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: e.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: e.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.any,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: e.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: e.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: e.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.object,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: e.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: e.shape({
    hours: e.func,
    minutes: e.func,
    seconds: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const gd = ["desktopModeMediaQuery"], Wr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiTimePicker"
  }), {
    desktopModeMediaQuery: a = Oo
  } = r, s = ne(r, gd);
  return Yt(a, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ u(Nr, b({
    ref: n
  }, s)) : /* @__PURE__ */ u(qr, b({
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (Wr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: e.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: e.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: e.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.any,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: e.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: e.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: e.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.object,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: e.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: e.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: e.shape({
    hours: e.number,
    minutes: e.number,
    seconds: e.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: e.shape({
    hours: e.func,
    meridiem: e.func,
    minutes: e.func,
    seconds: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
function yd(t) {
  return ge("MuiDateTimePickerTabs", t);
}
he("MuiDateTimePickerTabs", ["root"]);
const Dd = (t) => ut(t) ? "date" : "time", Cd = (t) => t === "date" ? "day" : "hours", vd = (t) => {
  const {
    classes: o
  } = t;
  return me({
    root: ["root"]
  }, yd, o);
}, wd = _(Us, {
  name: "MuiDateTimePickerTabs",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})(({
  theme: t
}) => ({
  boxShadow: `0 -1px 0 0 inset ${(t.vars || t).palette.divider}`,
  "&:last-child": {
    boxShadow: `0 1px 0 0 inset ${(t.vars || t).palette.divider}`,
    [`& .${Ys.indicator}`]: {
      bottom: "auto",
      top: 0
    }
  }
})), _r = function(o) {
  const n = le({
    props: o,
    name: "MuiDateTimePickerTabs"
  }), {
    dateIcon: r = /* @__PURE__ */ u(ks, {}),
    onViewChange: a,
    timeIcon: s = /* @__PURE__ */ u(Rs, {}),
    view: i,
    hidden: l = typeof window > "u" || window.innerHeight < 667,
    className: c,
    sx: p
  } = n, m = ke(), f = vd(n), d = (g, h) => {
    a(Cd(h));
  };
  return l ? null : /* @__PURE__ */ z(wd, {
    ownerState: n,
    variant: "fullWidth",
    value: Dd(i),
    onChange: d,
    className: Ce(c, f.root),
    sx: p,
    children: [/* @__PURE__ */ u(mn, {
      value: "date",
      "aria-label": m.dateTableLabel,
      icon: /* @__PURE__ */ u(C.Fragment, {
        children: r
      })
    }), /* @__PURE__ */ u(mn, {
      value: "time",
      "aria-label": m.timeTableLabel,
      icon: /* @__PURE__ */ u(C.Fragment, {
        children: s
      })
    })]
  });
};
process.env.NODE_ENV !== "production" && (_r.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  className: e.string,
  /**
   * Date tab icon.
   * @default DateRange
   */
  dateIcon: e.node,
  /**
   * Toggles visibility of the tabs allowing view switching.
   * @default `window.innerHeight < 667` for `DesktopDateTimePicker` and `MobileDateTimePicker`, `displayStaticWrapperAs === 'desktop'` for `StaticDateTimePicker`
   */
  hidden: e.bool,
  /**
   * Callback called when a tab is clicked.
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: e.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Time tab icon.
   * @default Time
   */
  timeIcon: e.node,
  /**
   * Currently visible picker view.
   */
  view: e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired
});
function Td(t) {
  return ge("MuiDateTimePickerToolbar", t);
}
const fo = he("MuiDateTimePickerToolbar", ["root", "dateContainer", "timeContainer", "timeDigitsContainer", "separator", "timeLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), xd = ["ampm", "ampmInClock", "value", "onChange", "view", "isLandscape", "onViewChange", "toolbarFormat", "toolbarPlaceholder", "views", "disabled", "readOnly", "toolbarVariant", "toolbarTitle", "className"], Pd = (t) => {
  const {
    classes: o,
    isLandscape: n,
    isRtl: r
  } = t;
  return me({
    root: ["root"],
    dateContainer: ["dateContainer"],
    timeContainer: ["timeContainer", r && "timeLabelReverse"],
    timeDigitsContainer: ["timeDigitsContainer", r && "timeLabelReverse"],
    separator: ["separator"],
    ampmSelection: ["ampmSelection", n && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  }, Td, o);
}, Sd = _(Uo, {
  name: "MuiDateTimePickerToolbar",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})(({
  theme: t
}) => ({
  paddingLeft: 16,
  paddingRight: 16,
  justifyContent: "space-around",
  position: "relative",
  variants: [{
    props: {
      toolbarVariant: "desktop"
    },
    style: {
      borderBottom: `1px solid ${(t.vars || t).palette.divider}`,
      [`& .${uu.content} .${yo.selected}`]: {
        color: (t.vars || t).palette.primary.main,
        fontWeight: t.typography.fontWeightBold
      }
    }
  }, {
    props: {
      toolbarVariant: "desktop",
      isLandscape: !0
    },
    style: {
      borderRight: `1px solid ${(t.vars || t).palette.divider}`
    }
  }, {
    props: {
      toolbarVariant: "desktop",
      isLandscape: !1
    },
    style: {
      paddingLeft: 24,
      paddingRight: 0
    }
  }]
})), kd = _("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "DateContainer",
  overridesResolver: (t, o) => o.dateContainer
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start"
}), Rd = _("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "TimeContainer",
  overridesResolver: (t, o) => o.timeContainer
})({
  display: "flex",
  flexDirection: "row",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      toolbarVariant: "desktop",
      isLandscape: !1
    },
    style: {
      gap: 9,
      marginRight: 4,
      alignSelf: "flex-end"
    }
  }, {
    props: ({
      isLandscape: t,
      toolbarVariant: o
    }) => t && o !== "desktop",
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      isLandscape: t,
      toolbarVariant: o,
      isRtl: n
    }) => t && o !== "desktop" && n,
    style: {
      flexDirection: "column-reverse"
    }
  }]
}), Md = _("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "TimeDigitsContainer",
  overridesResolver: (t, o) => o.timeDigitsContainer
})({
  display: "flex",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      toolbarVariant: "desktop"
    },
    style: {
      gap: 1.5
    }
  }]
}), vn = _(Qo, {
  name: "MuiDateTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (t, o) => o.separator
})({
  margin: "0 4px 0 2px",
  cursor: "default",
  variants: [{
    props: {
      toolbarVariant: "desktop"
    },
    style: {
      margin: 0
    }
  }]
}), Od = _("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (t, o) => [{
    [`.${fo.ampmLabel}`]: o.ampmLabel
  }, {
    [`&.${fo.ampmLandscape}`]: o.ampmLandscape
  }, o.ampmSelection]
})({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12,
  [`& .${fo.ampmLabel}`]: {
    fontSize: 17
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "4px 0 auto",
      flexDirection: "row",
      justifyContent: "space-around",
      width: "100%"
    }
  }]
});
function Hr(t) {
  const o = le({
    props: t,
    name: "MuiDateTimePickerToolbar"
  }), {
    ampm: n,
    ampmInClock: r,
    value: a,
    onChange: s,
    view: i,
    isLandscape: l,
    onViewChange: c,
    toolbarFormat: p,
    toolbarPlaceholder: m = "––",
    views: f,
    disabled: d,
    readOnly: g,
    toolbarVariant: h = "mobile",
    toolbarTitle: D,
    className: y
  } = o, x = ne(o, xd), v = _e(), P = b({}, o, {
    isRtl: v
  }), T = ue(), {
    meridiemMode: S,
    handleMeridiemChange: k
  } = Yn(a, n, s), M = !!(n && !r), w = h === "desktop", q = ke(), B = Pd(P), O = D ?? q.dateTimePickerToolbarTitle, V = (A) => n ? T.format(A, "hours12h") : T.format(A, "hours24h"), N = C.useMemo(() => a ? p ? T.formatByString(a, p) : T.format(a, "shortDate") : m, [a, p, m, T]);
  return /* @__PURE__ */ z(Sd, b({
    isLandscape: l,
    className: Ce(B.root, y),
    toolbarTitle: O
  }, x, {
    ownerState: P,
    children: [/* @__PURE__ */ z(kd, {
      className: B.dateContainer,
      ownerState: P,
      children: [f.includes("year") && /* @__PURE__ */ u(Me, {
        tabIndex: -1,
        variant: "subtitle1",
        onClick: () => c("year"),
        selected: i === "year",
        value: a ? T.format(a, "year") : "–"
      }), f.includes("day") && /* @__PURE__ */ u(Me, {
        tabIndex: -1,
        variant: w ? "h5" : "h4",
        onClick: () => c("day"),
        selected: i === "day",
        value: N
      })]
    }), /* @__PURE__ */ z(Rd, {
      className: B.timeContainer,
      ownerState: P,
      children: [/* @__PURE__ */ z(Md, {
        className: B.timeDigitsContainer,
        ownerState: P,
        children: [f.includes("hours") && /* @__PURE__ */ z(C.Fragment, {
          children: [/* @__PURE__ */ u(Me, {
            variant: w ? "h5" : "h3",
            width: w && !l ? Vt : void 0,
            onClick: () => c("hours"),
            selected: i === "hours",
            value: a ? V(a) : "--"
          }), /* @__PURE__ */ u(vn, {
            variant: w ? "h5" : "h3",
            value: ":",
            className: B.separator,
            ownerState: P
          }), /* @__PURE__ */ u(Me, {
            variant: w ? "h5" : "h3",
            width: w && !l ? Vt : void 0,
            onClick: () => c("minutes"),
            selected: i === "minutes" || !f.includes("minutes") && i === "hours",
            value: a ? T.format(a, "minutes") : "--",
            disabled: !f.includes("minutes")
          })]
        }), f.includes("seconds") && /* @__PURE__ */ z(C.Fragment, {
          children: [/* @__PURE__ */ u(vn, {
            variant: w ? "h5" : "h3",
            value: ":",
            className: B.separator,
            ownerState: P
          }), /* @__PURE__ */ u(Me, {
            variant: w ? "h5" : "h3",
            width: w && !l ? Vt : void 0,
            onClick: () => c("seconds"),
            selected: i === "seconds",
            value: a ? T.format(a, "seconds") : "--"
          })]
        })]
      }), M && !w && /* @__PURE__ */ z(Od, {
        className: B.ampmSelection,
        ownerState: P,
        children: [/* @__PURE__ */ u(Me, {
          variant: "subtitle2",
          selected: S === "am",
          typographyClassName: B.ampmLabel,
          value: Pt(T, "am"),
          onClick: g ? void 0 : () => k("am"),
          disabled: d
        }), /* @__PURE__ */ u(Me, {
          variant: "subtitle2",
          selected: S === "pm",
          typographyClassName: B.ampmLabel,
          value: Pt(T, "pm"),
          onClick: g ? void 0 : () => k("pm"),
          disabled: d
        })]
      }), n && w && /* @__PURE__ */ u(Me, {
        variant: "h5",
        onClick: () => c("meridiem"),
        selected: i === "meridiem",
        value: a && S ? Pt(T, S) : "--",
        width: Vt
      })]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (Hr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  ampm: e.bool,
  ampmInClock: e.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  className: e.string,
  disabled: e.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: e.bool,
  isLandscape: e.bool.isRequired,
  onChange: e.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: e.func.isRequired,
  readOnly: e.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  titleId: e.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: e.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: e.node,
  /**
   * If provided, it will be used instead of `dateTimePickerToolbarTitle` from localization.
   */
  toolbarTitle: e.node,
  toolbarVariant: e.oneOf(["desktop", "mobile"]),
  value: e.object,
  /**
   * Currently visible picker view.
   */
  view: e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired
});
function zr(t, o) {
  var l;
  const n = ue(), r = et(), a = le({
    props: t,
    name: o
  }), s = a.ampm ?? n.is12HourCycleInCurrentLocale(), i = C.useMemo(() => {
    var c;
    return ((c = a.localeText) == null ? void 0 : c.toolbarTitle) == null ? a.localeText : b({}, a.localeText, {
      dateTimePickerToolbarTitle: a.localeText.toolbarTitle
    });
  }, [a.localeText]);
  return b({}, a, Mo({
    views: a.views,
    openTo: a.openTo,
    defaultViews: ["year", "day", "hours", "minutes"],
    defaultOpenTo: "day"
  }), {
    ampm: s,
    localeText: i,
    orientation: a.orientation ?? "portrait",
    // TODO: Remove from public API
    disableIgnoringDatePartForTimeValidation: a.disableIgnoringDatePartForTimeValidation ?? !!(a.minDateTime || a.maxDateTime || // allow time clock to correctly check time validity: https://github.com/mui/mui-x/issues/8520
    a.disablePast || a.disableFuture),
    disableFuture: a.disableFuture ?? !1,
    disablePast: a.disablePast ?? !1,
    minDate: Se(n, a.minDateTime ?? a.minDate, r.minDate),
    maxDate: Se(n, a.maxDateTime ?? a.maxDate, r.maxDate),
    minTime: a.minDateTime ?? a.minTime,
    maxTime: a.maxDateTime ?? a.maxTime,
    slots: b({
      toolbar: Hr,
      tabs: _r
    }, a.slots),
    slotProps: b({}, a.slotProps, {
      toolbar: b({
        ampm: s
      }, (l = a.slotProps) == null ? void 0 : l.toolbar)
    })
  });
}
const Ur = /* @__PURE__ */ C.forwardRef(function(o, n) {
  var D;
  const r = _e(), {
    toolbar: a,
    tabs: s,
    content: i,
    actionBar: l,
    shortcuts: c
  } = Or(o), {
    sx: p,
    className: m,
    isLandscape: f,
    classes: d
  } = o, g = l && (((D = l.props.actions) == null ? void 0 : D.length) ?? 0) > 0, h = b({}, o, {
    isRtl: r
  });
  return /* @__PURE__ */ z(Fr, {
    ref: n,
    className: Ce(qe.root, d == null ? void 0 : d.root, m),
    sx: [{
      [`& .${qe.tabs}`]: {
        gridRow: 4,
        gridColumn: "1 / 4"
      },
      [`& .${qe.actionBar}`]: {
        gridRow: 5
      }
    }, ...Array.isArray(p) ? p : [p]],
    ownerState: h,
    children: [f ? c : a, f ? a : c, /* @__PURE__ */ z(Ir, {
      className: Ce(qe.contentWrapper, d == null ? void 0 : d.contentWrapper),
      sx: {
        display: "grid"
      },
      children: [i, s, g && /* @__PURE__ */ u(Jn, {
        sx: {
          gridRow: 3,
          gridColumn: "1 / 4"
        }
      })]
    }), l]
  });
});
process.env.NODE_ENV !== "production" && (Ur.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  className: e.string,
  disabled: e.bool,
  isLandscape: e.bool.isRequired,
  /**
   * `true` if the application is in right-to-left direction.
   */
  isRtl: e.bool.isRequired,
  isValid: e.func.isRequired,
  onAccept: e.func.isRequired,
  onCancel: e.func.isRequired,
  onChange: e.func.isRequired,
  onClear: e.func.isRequired,
  onClose: e.func.isRequired,
  onDismiss: e.func.isRequired,
  onOpen: e.func.isRequired,
  onSelectShortcut: e.func.isRequired,
  onSetToday: e.func.isRequired,
  onViewChange: e.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  value: e.any,
  view: e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: e.arrayOf(e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: e.oneOf(["desktop", "mobile"])
});
const Fd = ["openTo", "focusedView", "timeViewsCount"], Id = function(o, n, r) {
  var m, f;
  const {
    openTo: a,
    focusedView: s,
    timeViewsCount: i
  } = r, l = ne(r, Fd), c = b({}, l, {
    focusedView: null,
    sx: [{
      [`&.${pn.root}`]: {
        borderBottom: 0
      },
      [`&.${pn.root}, .${Ms.root}, &.${Os.root}`]: {
        maxHeight: Ro
      }
    }]
  }), p = vt(n);
  return /* @__PURE__ */ z(C.Fragment, {
    children: [(m = o[p ? "day" : n]) == null ? void 0 : m.call(o, b({}, r, {
      view: p ? "day" : n,
      focusedView: s && ut(s) ? s : null,
      views: r.views.filter(ut),
      sx: [{
        gridColumn: 1
      }, ...c.sx]
    })), i > 0 && /* @__PURE__ */ z(C.Fragment, {
      children: [/* @__PURE__ */ u(Jn, {
        orientation: "vertical",
        sx: {
          gridColumn: 2
        }
      }), (f = o[p ? n : "hours"]) == null ? void 0 : f.call(o, b({}, c, {
        view: p ? n : "hours",
        focusedView: s && vt(s) ? s : null,
        openTo: vt(a) ? a : "hours",
        views: r.views.filter(vt),
        sx: [{
          gridColumn: 3
        }, ...c.sx]
      }))]
    })]
  });
}, Yr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  var v, P, T, S;
  const r = ke(), a = ue(), s = zr(o, "MuiDesktopDateTimePicker"), {
    shouldRenderTimeInASingleColumn: i,
    thresholdToRenderTimeInASingleColumn: l,
    views: c,
    timeSteps: p
  } = Br(s), m = i ? Kn : jt, f = b({
    day: Ee,
    month: Ee,
    year: Ee,
    hours: m,
    minutes: m,
    seconds: m,
    meridiem: m
  }, s.viewRenderers), d = s.ampmInClock ?? !0, h = ((v = f.hours) == null ? void 0 : v.name) === jt.name ? c : c.filter((k) => k !== "meridiem"), D = i ? [] : ["accept"], y = b({}, s, {
    viewRenderers: f,
    format: jr(a, s),
    views: h,
    yearsPerRow: s.yearsPerRow ?? 4,
    ampmInClock: d,
    timeSteps: p,
    thresholdToRenderTimeInASingleColumn: l,
    shouldRenderTimeInASingleColumn: i,
    slots: b({
      field: zo,
      layout: Ur,
      openPickerIcon: Un
    }, s.slots),
    slotProps: b({}, s.slotProps, {
      field: (k) => {
        var M;
        return b({}, Xe((M = s.slotProps) == null ? void 0 : M.field, k), ht(s), {
          ref: n
        });
      },
      toolbar: b({
        hidden: !0,
        ampmInClock: d,
        toolbarVariant: "desktop"
      }, (P = s.slotProps) == null ? void 0 : P.toolbar),
      tabs: b({
        hidden: !0
      }, (T = s.slotProps) == null ? void 0 : T.tabs),
      actionBar: (k) => {
        var M;
        return b({
          actions: D
        }, Xe((M = s.slotProps) == null ? void 0 : M.actionBar, k));
      }
    })
  }), {
    renderPicker: x
  } = Ko({
    props: y,
    valueManager: xe,
    valueType: "date-time",
    getOpenDialogAriaText: ft({
      utils: a,
      formatKey: "fullDate",
      contextTranslation: r.openDatePickerDialogue,
      propsTranslation: (S = y.localeText) == null ? void 0 : S.openDatePickerDialogue
    }),
    validator: to,
    rendererInterceptor: Id
  });
  return x();
});
Yr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: e.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: e.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: e.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: e.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: e.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: e.object,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: e.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: e.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: e.object,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: e.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: e.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: e.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: e.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: e.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: e.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: e.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: e.bool,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: e.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: e.shape({
    hours: e.number,
    minutes: e.number,
    seconds: e.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: e.shape({
    day: e.func,
    hours: e.func,
    meridiem: e.func,
    minutes: e.func,
    month: e.func,
    seconds: e.func,
    year: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: e.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: e.oneOf([3, 4])
};
const Kr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  var m, f, d;
  const r = ke(), a = ue(), s = zr(o, "MuiMobileDateTimePicker"), i = b({
    day: Ee,
    month: Ee,
    year: Ee,
    hours: at,
    minutes: at,
    seconds: at
  }, s.viewRenderers), l = s.ampmInClock ?? !1, c = b({}, s, {
    viewRenderers: i,
    format: jr(a, s),
    ampmInClock: l,
    slots: b({
      field: zo
    }, s.slots),
    slotProps: b({}, s.slotProps, {
      field: (g) => {
        var h;
        return b({}, Xe((h = s.slotProps) == null ? void 0 : h.field, g), ht(s), {
          ref: n
        });
      },
      toolbar: b({
        hidden: !1,
        ampmInClock: l
      }, (m = s.slotProps) == null ? void 0 : m.toolbar),
      tabs: b({
        hidden: !1
      }, (f = s.slotProps) == null ? void 0 : f.tabs)
    })
  }), {
    renderPicker: p
  } = Go({
    props: c,
    valueManager: xe,
    valueType: "date-time",
    getOpenDialogAriaText: ft({
      utils: a,
      formatKey: "fullDate",
      contextTranslation: r.openDatePickerDialogue,
      propsTranslation: (d = c.localeText) == null ? void 0 : d.openDatePickerDialogue
    }),
    validator: to
  });
  return p();
});
Kr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: e.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: e.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: e.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: e.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: e.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: e.object,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: e.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: e.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: e.object,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: e.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: e.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: e.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: e.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: e.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: e.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: e.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: e.shape({
    day: e.func,
    hours: e.func,
    minutes: e.func,
    month: e.func,
    seconds: e.func,
    year: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: e.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: e.oneOf([3, 4])
};
const Vd = ["desktopModeMediaQuery"], Gr = /* @__PURE__ */ C.forwardRef(function(o, n) {
  const r = le({
    props: o,
    name: "MuiDateTimePicker"
  }), {
    desktopModeMediaQuery: a = Oo
  } = r, s = ne(r, Vd);
  return Yt(a, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ u(Yr, b({
    ref: n
  }, s)) : /* @__PURE__ */ u(Kr, b({
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (Gr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: e.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: e.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: e.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: e.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: e.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: e.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: e.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Pe,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: e.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: e.object,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: e.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: e.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: e.object,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: e.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: e.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: e.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: e.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: e.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: e.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: e.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: e.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: e.bool,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: e.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: e.shape({
    hours: e.number,
    minutes: e.number,
    seconds: e.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: e.shape({
    day: e.func,
    hours: e.func,
    meridiem: e.func,
    minutes: e.func,
    month: e.func,
    seconds: e.func,
    year: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: e.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: e.oneOf([3, 4])
});
const Ad = K(fe)({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}), Ed = K(fe)({
  visibility: "hidden",
  pointerEvents: "none"
});
function Ld({
  children: t,
  loading: o,
  disabled: n,
  startIcon: r,
  endIcon: a,
  loadingPosition: s,
  ...i
}, l) {
  const c = /* @__PURE__ */ u(pt, { size: 18, color: "inherit" }), p = o && s === void 0, m = () => p ? /* @__PURE__ */ z(fe, { sx: { position: "relative" }, children: [
    /* @__PURE__ */ u(Ad, { children: c }),
    /* @__PURE__ */ u(Ed, { children: t })
  ] }) : t, f = (d) => {
    if (!p)
      return o && s !== void 0 ? s === d ? c : void 0 : d === "start" ? r : a;
  };
  return /* @__PURE__ */ u(
    On,
    {
      disabled: o || n,
      startIcon: f("start"),
      endIcon: f("end"),
      ...i,
      ref: l,
      children: /* @__PURE__ */ u(Re, { variant: "inherit", color: "inherit", noWrap: !0, component: "span", children: m() })
    }
  );
}
const Gf = ze(Ld), $d = K(fe)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  gap: t.spacing(0.5)
})), jd = K(Re)(({ theme: t }) => ({
  ".Mui-disabled &": {
    color: t.palette.text.disabled
  }
})), Bd = K(fe)(({ theme: t }) => ({
  display: "flex",
  svg: {
    width: Tt,
    height: Tt,
    fontSize: Tt,
    path: {
      fill: t.palette.text.secondary,
      ".Mui-disabled &": {
        fill: t.palette.text.disabled
      }
    }
  }
}));
function Zo({
  label: t,
  type: o,
  icon: n,
  inheritSize: r
}) {
  return /* @__PURE__ */ z($d, { children: [
    t,
    o && /* @__PURE__ */ u(
      jd,
      {
        component: "span",
        variant: r ? "inherit" : "caption",
        color: "textSecondary",
        weight: "regular",
        children: o === "required" ? "(required)" : "(optional)"
      }
    ),
    n && /* @__PURE__ */ u(Bd, { children: n })
  ] });
}
function Nd({ InputProps: t, size: o = "small", ...n }, r) {
  const a = je(), s = $e(a), [i, l] = Oe(!1);
  return /* @__PURE__ */ u(
    Fn,
    {
      ...n,
      ref: r,
      type: i ? "text" : "password",
      size: o,
      InputProps: {
        ...t,
        endAdornment: /* @__PURE__ */ u(Co, { position: "end", children: /* @__PURE__ */ u(We, { size: o, onClick: () => l(!i), children: /* @__PURE__ */ u(
          Je,
          {
            title: s.formatMessage({
              id: `c4r.form.${i ? "hidePassword" : "showPassword"}`
            }),
            children: i ? /* @__PURE__ */ u(Ya, {}) : /* @__PURE__ */ u(Ka, {})
          }
        ) }) })
      }
    }
  );
}
const Qf = ze(Nd), mo = {};
function qd(t = "$lodash$") {
  mo[t] || (mo[t] = 0);
  const o = ++mo[t];
  return t === "$lodash$" ? `${o}` : `${t}${o}`;
}
const Wd = K(ba)(({ theme: t }) => ({
  "& .MuiInputAdornment-positionStart": {
    paddingLeft: t.spacing(2),
    "&.MuiInputAdornment-sizeSmall": {
      paddingLeft: t.spacing(1.5)
    }
  },
  "& .MuiInputBase-inputAdornedStart": {
    paddingLeft: "0px !important"
  },
  "& .MuiSelect-select .MuiMenuItem-root:hover": {
    backgroundColor: "transparent"
  },
  "&.MuiInputBase-root .MuiSelect-select.MuiSelect-multiple": {
    paddingRight: t.spacing(7)
  }
})), _d = K(In)(() => ({
  display: "none"
}));
function Hd({
  children: t,
  placeholder: o,
  size: n = "small",
  displayEmpty: r,
  menuProps: a,
  inputProps: s,
  labelId: i,
  label: l,
  labelSecondary: c,
  helperText: p,
  name: m,
  error: f,
  focused: d,
  disabled: g,
  fullWidth: h,
  required: D,
  "aria-label": y,
  ...x
}, v) {
  const P = n === "small", [T] = Oe(() => qd("select-label-")), S = l ? i ?? T : void 0;
  return /* @__PURE__ */ z(
    ha,
    {
      size: n,
      error: f,
      focused: d,
      disabled: g,
      fullWidth: h,
      required: D,
      children: [
        /* @__PURE__ */ z(fe, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
          l && /* @__PURE__ */ u(ga, { shrink: !0, id: S, children: l }),
          c && /* @__PURE__ */ u(fe, { display: "flex", alignItems: "center", ml: 2, mb: 0.5, children: c })
        ] }),
        /* @__PURE__ */ z(
          Wd,
          {
            ...x,
            labelId: S,
            name: m,
            ref: v,
            size: n,
            fullWidth: h,
            displayEmpty: r ?? !!o,
            inputProps: {
              ...s,
              "aria-label": y
            },
            MenuProps: {
              ...a,
              PopoverClasses: {
                paper: P ? "MuiMenu-paper-sizeSmall" : void 0
              },
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              transformOrigin: {
                vertical: 0,
                horizontal: "left"
              }
            },
            children: [
              o && /* @__PURE__ */ u(_d, { disabled: !0, value: "", children: /* @__PURE__ */ u(
                Re,
                {
                  variant: P ? "body2" : "body1",
                  color: "text.hint",
                  component: "span",
                  children: o
                }
              ) }),
              t
            ]
          }
        ),
        p && /* @__PURE__ */ u(Vn, { "aria-label": `${m}-helper`, children: p })
      ]
    }
  );
}
const zd = ze(Hd), Ud = K(ya, {
  shouldForwardProp: (t) => t !== "variant" && t !== "backgroundColor"
})(({ variant: t, backgroundColor: o, theme: n }) => ({
  // Variants
  ...t === "contained" && {
    boxShadow: "none"
  },
  ...t === "unbounded" && {
    boxShadow: "none",
    borderRadius: n.spacing(0.5),
    "& .MuiDivider-root": {
      height: n.spacing(4),
      "&.MuiToggleButtonGroup-groupedHorizontal": {
        height: n.spacing(4)
      },
      "&.MuiToggleButtonGroup-groupedVertical": {
        height: "auto",
        width: n.spacing(4),
        margin: `${n.spacing(0.5, 0, 1)} !important`,
        borderRadius: "0 !important"
      }
    },
    "& .MuiToggleButton-sizeSmall": {
      margin: 0,
      "&.MuiToggleButtonGroup-grouped:not(.MuiDivider-root)": {
        margin: 0
      },
      "& + .MuiDivider-root.MuiToggleButtonGroup-groupedHorizontal": {
        height: n.spacing(3)
      },
      "& + .MuiDivider-root.MuiToggleButtonGroup-groupedVertical": {
        height: "auto",
        width: n.spacing(3)
      }
    },
    ".MuiToggleButtonGroup-grouped:not(.MuiDivider-root)": {
      margin: 0,
      "&:first-of-type": {
        marginLeft: 0
      },
      "&:not(:last-of-type)": {
        marginRight: n.spacing(0.5)
      }
    },
    "&.MuiToggleButtonGroup-horizontal:not(.MuiDivider-root)": {
      ".MuiToggleButtonGroup-grouped": {
        margin: n.spacing(0, 0.5)
      }
    },
    "&.MuiToggleButtonGroup-vertical:not(.MuiDivider-root)": {
      ".MuiToggleButtonGroup-grouped": {
        margin: n.spacing(0, 0, 0.5),
        "&:not(:last-of-type)": {
          marginRight: 0
        },
        "&:last-of-type": {
          marginBottom: 0
        }
      }
    }
  },
  // Colors
  ...o === "primary" && {
    backgroundColor: n.palette.background.paper
  },
  ...o === "secondary" && {
    backgroundColor: n.palette.background.default
  },
  ...o === "transparent" && {
    backgroundColor: "transparent"
  }
}));
function Zf({
  children: t,
  variant: o = "floating",
  backgroundColor: n,
  ...r
}) {
  return /* @__PURE__ */ u(
    Ud,
    {
      ...r,
      variant: o,
      backgroundColor: n ?? (o === "unbounded" ? "transparent" : "primary"),
      children: t
    }
  );
}
const Yd = K("div")(({ theme: t }) => ({
  position: "relative",
  display: "inline-flex",
  // TODO: Remove this once we have a better way to handle the spacing between icon buttons:
  // https://app.shortcut.com/cartoteam/story/471284/create-iconbuttongroup-component-to-properly-group-several-icons
  "& + &, & + .optionIconButton": {
    marginLeft: t.spacing(0.5)
  }
})), Kd = K(We, {
  shouldForwardProp: (t) => !["active"].includes(t)
})(({ active: t, theme: o }) => ({
  ...t && {
    color: o.palette.primary.main,
    backgroundColor: o.palette.primary.background,
    "& svg:not(.doNotFillIcon) path": {
      fill: o.palette.primary.main
    }
  }
}));
function Gd({
  tooltip: t,
  tooltipPlacement: o = "top",
  icon: n,
  size: r = "medium",
  variant: a = "icon",
  color: s = "default",
  sx: i,
  className: l,
  loading: c,
  disabled: p,
  active: m,
  ...f
}, d) {
  return /* @__PURE__ */ u(Je, { placement: o, title: t ?? "", children: /* @__PURE__ */ u(
    Yd,
    {
      className: `optionIconButton ${l ?? ""}`,
      sx: i,
      "data-testid": "icon-button",
      children: /* @__PURE__ */ u(
        Kd,
        {
          ...f,
          ref: d,
          size: r,
          variant: a,
          color: s,
          active: m,
          disabled: p || c,
          children: c ? /* @__PURE__ */ u(pt, { size: 18, color: "inherit" }) : n
        }
      )
    }
  ) });
}
const Qd = ze(Gd), Zd = K(Da, {
  shouldForwardProp: (t) => !["extended", "width", "height"].includes(t)
})(({ theme: t, extended: o, width: n, height: r }) => ({
  ...o && {
    ".MuiMenuItem-root": {
      minHeight: t.spacing(6)
    }
  },
  ...n && {
    ".MuiList-root": {
      width: n,
      minWidth: n
    }
  },
  ...r && {
    ".MuiMenu-paper": {
      overflow: "hidden"
    },
    ".MuiList-root": {
      maxHeight: r
    }
  }
}));
function Xf(t) {
  return /* @__PURE__ */ u(Zd, { ...t });
}
const Xd = K(Ca, {
  shouldForwardProp: (t) => !["extended", "width", "height"].includes(t)
})(({ theme: t, extended: o, width: n, height: r }) => ({
  ...o && {
    ".MuiMenuItem-root": {
      minHeight: t.spacing(6)
    }
  },
  "&.MuiList-root": {
    ...n && {
      width: n,
      minWidth: n
    },
    ...r && {
      maxHeight: r
    }
  }
}));
function Jf(t) {
  return /* @__PURE__ */ u(Xd, { ...t });
}
const Jd = K(Gn)(() => ({
  marginTop: "0 !important"
})), ep = K(va)(
  ({ disabled: t, theme: o }) => ({
    display: "flex",
    alignItems: "center",
    gap: o.spacing(1),
    width: "100%",
    textAlign: "initial",
    ...t && {
      pointerEvents: "none",
      color: o.palette.text.disabled
    }
  })
);
function Qr({
  areAllSelected: t,
  areAnySelected: o,
  selectAll: n,
  selectAllDisabled: r
}) {
  const a = je(), s = $e(a);
  return /* @__PURE__ */ u(Jd, { fixed: !0, children: /* @__PURE__ */ z(
    ep,
    {
      variant: "body2",
      color: "textPrimary",
      component: "button",
      underline: "none",
      disabled: !!r,
      onClick: n,
      tabIndex: 0,
      children: [
        /* @__PURE__ */ u(
          vo,
          {
            checked: t,
            indeterminate: o && !t,
            disabled: r
          }
        ),
        s.formatMessage({ id: "c4r.form.selectAll" })
      ]
    }
  ) });
}
function tp({
  selectedOptions: t,
  options: o,
  onChange: n
}) {
  const [r, a] = Oe(t ?? []), s = o.length === r.length, i = r.length > 0;
  return ct(() => {
    r !== t && a(r);
  }, [t]), {
    areAllSelected: s,
    areAnySelected: i,
    currentOptions: r,
    handleChange: (m) => {
      const {
        target: { value: f }
      } = m, d = typeof f == "string" ? f.split(",") : f.filter((g) => g !== void 0);
      a(d), n(d);
    },
    selectAll: () => {
      const m = o == null ? void 0 : o.filter(({ disabled: f }) => !f).map(({ value: f }) => f);
      m && (m.every(
        (d) => r.includes(d)
      ) ? (a([]), n([])) : (a(m), n(m)));
    },
    unselectAll: () => {
      a([]), n([]);
    }
  };
}
const op = K(In)(({ theme: t }) => ({
  "&.Mui-disabled": {
    pointerEvents: "auto",
    "&:hover": {
      backgroundColor: `${t.palette.background.default} !important`
    }
  }
})), np = K(Co, {
  shouldForwardProp: (t) => t !== "size"
})(({ theme: t, size: o }) => ({
  display: "none",
  position: "absolute",
  top: t.spacing(2),
  right: t.spacing(3.5),
  ".MuiInputBase-root:hover &, .MuiInputBase-root.Mui-focused &": {
    display: "flex"
  },
  ".MuiSvgIcon-root": {
    color: t.palette.text.hint
  },
  ...o === "medium" && {
    top: t.spacing(3),
    right: t.spacing(5)
  }
})), rp = [], ap = () => {
};
function sp({
  options: t = rp,
  selectedOptions: o,
  size: n = "small",
  placeholder: r,
  showCounter: a,
  showFilters: s = !0,
  onChange: i = ap,
  selectAllDisabled: l,
  tooltipPlacement: c,
  variant: p,
  ...m
}, f) {
  const {
    areAllSelected: d,
    areAnySelected: g,
    currentOptions: h,
    handleChange: D,
    selectAll: y,
    unselectAll: x
  } = tp({
    options: t,
    selectedOptions: o,
    onChange: i
  }), v = n === "small", P = v || p === "standard" ? 0 : 2, T = je(), S = $e(T), k = `${h.length} ${S.formatMessage({
    id: "c4r.form.selected"
  })}`, M = Mn(() => d ? /* @__PURE__ */ u(
    Re,
    {
      component: "span",
      variant: v ? "body2" : "body1",
      color: "textPrimary",
      ml: P,
      children: S.formatMessage({ id: "c4r.form.allSelected" })
    }
  ) : g ? /* @__PURE__ */ u(
    Re,
    {
      component: "span",
      variant: v ? "body2" : "body1",
      color: "textPrimary",
      ml: P,
      children: a && h.length > 1 ? k : h.join(", ")
    }
  ) : /* @__PURE__ */ u(
    Re,
    {
      component: "span",
      variant: v ? "body2" : "body1",
      color: "text.hint",
      ml: P,
      children: r ?? S.formatMessage({ id: "c4r.form.noneSelected" })
    }
  ), [
    d,
    g,
    k,
    h,
    S,
    v,
    P,
    r,
    a
  ]);
  return /* @__PURE__ */ z(
    zd,
    {
      ...m,
      ref: f,
      multiple: !0,
      displayEmpty: !0,
      placeholder: r,
      value: h,
      renderValue: () => M,
      onChange: D,
      size: n,
      variant: p,
      endAdornment: s && g && /* @__PURE__ */ u(np, { position: "end", size: n, children: /* @__PURE__ */ u(We, { onClick: x, size: n, children: /* @__PURE__ */ u(Ln, {}) }) }),
      menuProps: {
        PaperProps: {
          sx: {
            ".MuiList-root": {
              paddingTop: 0
            }
          }
        }
      },
      children: [
        s && /* @__PURE__ */ u(
          Qr,
          {
            areAllSelected: d,
            areAnySelected: g,
            selectAll: y,
            selectAllDisabled: l
          }
        ),
        t == null ? void 0 : t.map((w) => {
          const q = /* @__PURE__ */ z(
            op,
            {
              value: w.value,
              disabled: w.disabled,
              tabIndex: 0,
              children: [
                /* @__PURE__ */ u(
                  vo,
                  {
                    disabled: w.disabled,
                    checked: h.includes(w.value)
                  }
                ),
                /* @__PURE__ */ u(An, { primary: w.label })
              ]
            },
            w.value
          );
          return w.tooltip ? /* @__PURE__ */ u(
            Je,
            {
              title: w.tooltip,
              placement: c,
              children: q
            },
            w.value
          ) : q;
        })
      ]
    }
  );
}
const em = ze(sp), ip = K(Fn, {
  shouldForwardProp: (t) => t !== "cursor"
})(
  ({ cursor: t, theme: o }) => ({
    "&.MuiTextField-root .MuiInputBase-root": {
      cursor: t,
      paddingRight: o.spacing(1),
      "& input": {
        cursor: t
      },
      "&.Mui-disabled": {
        pointerEvents: "none",
        "& .MuiButtonBase-root": {
          color: o.palette.text.disabled
        }
      },
      "&.MuiInputBase-sizeSmall": {
        paddingRight: o.spacing(0.5)
      }
    },
    "& .MuiFormLabel-root": {
      cursor: t,
      "&.Mui-disabled": {
        pointerEvents: "none"
      }
    }
  })
);
function lp({
  buttonText: t,
  hasFiles: o,
  size: n,
  error: r,
  disabled: a,
  handleReset: s,
  handleOpen: i,
  inProgress: l
}) {
  return /* @__PURE__ */ u(Co, { position: "end", children: l ? /* @__PURE__ */ u(We, { "aria-label": "loading", disabled: !0, size: n, children: /* @__PURE__ */ u(pt, { size: 18 }) }) : o ? /* @__PURE__ */ u(
    We,
    {
      onClick: s,
      size: n,
      "aria-label": "delete",
      disabled: a,
      children: /* @__PURE__ */ u(Ln, {})
    }
  ) : /* @__PURE__ */ u(
    On,
    {
      onClick: i,
      size: n,
      variant: "text",
      color: r ? "default" : "primary",
      disabled: a,
      children: t
    }
  ) });
}
function cp({
  name: t,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  multiple: o,
  // multiple prop defined here for compatibility with cloud-native but not used in the component
  handleReset: n,
  handleOpen: r,
  dragOver: a,
  error: s,
  placeholder: i,
  focused: l,
  buttonText: c = "Browse",
  inProgress: p,
  InputProps: m,
  size: f = "small",
  hasFiles: d,
  cursor: g = "pointer",
  ...h
}) {
  return /* @__PURE__ */ u(
    ip,
    {
      ...h,
      size: f,
      error: s,
      placeholder: i,
      focused: l ?? a,
      cursor: g,
      InputProps: {
        ...m,
        name: t,
        // multiple prop cannot be used here because it is not a valid prop for TextField InputProps
        // not used for any UI logic
        readOnly: !0,
        endAdornment: /* @__PURE__ */ u(
          lp,
          {
            buttonText: c,
            hasFiles: d,
            size: f,
            error: s,
            disabled: !!a,
            handleReset: n,
            handleOpen: r,
            inProgress: p
          }
        )
      }
    }
  );
}
function up({
  onChange: t,
  files: o,
  multiple: n,
  placeholder: r,
  uploadInputRef: a
}) {
  const s = je(), i = $e(s), [l, c] = Oe(""), [p, m] = Oe(!1);
  ct(() => {
    !o || o.length === 0 ? c("") : o.length === 1 ? c(o[0].name) : c(
      i.formatMessage(
        { id: "c4r.form.filesSelected" },
        { count: o.length }
      )
    );
  }, [o, i]);
  const f = () => {
    var T;
    (T = a.current) == null || T.click();
  }, d = (T) => {
    T.preventDefault(), m(!0);
  }, g = (T) => {
    T.preventDefault(), m(!1);
  }, h = (T) => {
    T.preventDefault(), m(!1);
    const S = T.dataTransfer.items, k = D(S);
    t == null || t(k);
  }, D = (T) => {
    const S = [];
    for (const k of Array.from(T))
      if (k.kind === "file") {
        const M = k.getAsFile();
        S.push(M);
      }
    return S;
  }, y = (T) => {
    const S = Array.from(T.target.files);
    t == null || t(S);
  }, x = (T) => {
    T.stopPropagation(), c("");
  }, v = Mn(() => {
    const T = i.formatMessage(
      { id: "c4r.form.dragPlaceholder" },
      { count: n ? 0 : 1 }
    ), S = i.formatMessage(
      { id: "c4r.form.dragActivePlaceholder" },
      { count: n ? 0 : 1 }
    );
    let k = "";
    return p ? k = S : k = r ?? T, k;
  }, [p, n, r, i]);
  return {
    filesText: l,
    getPlaceholder: v,
    dragOver: p,
    inputEvents: {
      onDragOver: d,
      onDragLeave: g,
      onDrop: h,
      onClick: f
    },
    handleFiles: y,
    handleReset: x
  };
}
const dp = ["application/JSON"];
function tm({
  name: t,
  buttonText: o,
  accept: n,
  files: r,
  inProgress: a,
  onChange: s,
  multiple: i,
  placeholder: l,
  error: c,
  focused: p,
  nativeInputProps: m,
  ...f
}) {
  const d = n ?? dp, g = Do(null), {
    filesText: h,
    getPlaceholder: D,
    dragOver: y,
    inputEvents: x,
    handleFiles: v,
    handleReset: P
  } = up({
    uploadInputRef: g,
    files: r,
    onChange: s,
    multiple: i,
    placeholder: l
  });
  return /* @__PURE__ */ z(Ot, { children: [
    /* @__PURE__ */ u(
      cp,
      {
        ...f,
        placeholder: D,
        value: h,
        error: c,
        focused: p ?? y,
        handleReset: P,
        dragOver: y,
        inProgress: a,
        hasFiles: !!h,
        InputProps: x,
        buttonText: o
      }
    ),
    /* @__PURE__ */ u(
      "input",
      {
        ...m,
        ref: g,
        style: { display: "none" },
        type: "file",
        "aria-label": t,
        name: t,
        accept: String(d),
        multiple: i,
        onChange: v
      }
    )
  ] });
}
function pp({
  disabled: t,
  loading: o,
  ...n
}, r) {
  return /* @__PURE__ */ u(
    wo,
    {
      ...n,
      ref: r,
      disabled: t || o,
      popupIcon: o ? /* @__PURE__ */ u(pt, { size: 18, color: "inherit" }) : /* @__PURE__ */ u(Fo, {})
    }
  );
}
const om = ze(pp), Zr = (t) => t && typeof t == "object" ? t.title ?? String(t) : String(t), Xr = (t, o) => typeof t != "object" || t === null ? { value: t, multiple: o } : { ...t, multiple: o };
function Jr() {
  return { renderOption: (o, n, r, a, s) => {
    const {
      title: i,
      inputValue: l,
      divider: c,
      fixed: p,
      extended: m,
      dense: f,
      destructive: d,
      disabled: g,
      subtitle: h,
      iconColor: D,
      startAdornment: y,
      endAdornment: x,
      alternativeTitle: v,
      secondaryText: P,
      multiple: T
    } = n, { key: S, ...k } = o, M = typeof n == "string" || typeof n == "number", w = (q, B, O, V) => O || V || (B && typeof B == "object" && "value" in B ? String(B.value) : q(B));
    return /* @__PURE__ */ u(fa, { children: c ? /* @__PURE__ */ u(kt, {}) : /* @__PURE__ */ z(Ot, { children: [
      l && /* @__PURE__ */ u(kt, {}),
      /* @__PURE__ */ z(
        Gn,
        {
          ...k,
          ...!M && {
            fixed: p,
            extended: m,
            dense: f,
            destructive: d,
            disabled: g,
            subtitle: h,
            iconColor: D
          },
          children: [
            !h && (y || T || s) && /* @__PURE__ */ z(wa, { children: [
              s || T && /* @__PURE__ */ u(vo, { checked: r.selected }),
              y
            ] }),
            /* @__PURE__ */ z(An, { children: [
              w(
                a ?? Zr,
                n,
                v,
                i
              ),
              P && /* @__PURE__ */ u(
                Re,
                {
                  component: "p",
                  variant: "caption",
                  color: "text.secondary",
                  children: P
                }
              )
            ] }),
            x
          ]
        }
      )
    ] }) }, S);
  } };
}
function fp({
  getOptionLabel: t,
  newItemLabel: o,
  newItemIcon: n,
  multiple: r
}) {
  const a = je(), s = $e(a), i = Ta(), { renderOption: l } = Jr();
  return {
    creatableFilterOptions: (f, d) => {
      const g = i(
        f,
        d
      ), { inputValue: h } = d, D = f.some(
        (y) => h === t(y)
      );
      if (h.length > 1 && h !== "" && !D) {
        let y;
        typeof o == "function" ? y = o(h) : o ? y = `${o} "${h}"` : y = `${s.formatMessage({ id: "c4r.form.add" })} "${h}"`, g.push({
          inputValue: h,
          title: y
        });
      }
      return g;
    },
    creatableOptionLabel: (f) => typeof f == "string" ? f : f.inputValue ? f.inputValue : t(f),
    creatableRenderOption: (f, d, g) => {
      const h = d.inputValue ? n ?? /* @__PURE__ */ u(Ga, {}) : void 0, D = Xr(d, !!r);
      return l(
        f,
        D,
        g,
        t,
        h
      );
    }
  };
}
function ea({
  options: t,
  value: o,
  onChange: n,
  getOptionLabel: r
}) {
  const [a, s] = Oe(
    Array.isArray(o) ? o : o ? [o] : []
  ), { renderOption: i } = Jr();
  ct(() => {
    const d = Array.isArray(o) ? o : o ? [o] : [];
    s(d);
  }, [o]);
  const l = a.length === t.length, c = a.length > 0 && a.length < t.length;
  return {
    multipleValue: a,
    allSelected: l,
    someSelected: c,
    handleSelectAll: () => {
      s(l ? [] : [...t]);
    },
    handleChange: (d, g) => {
      s(g === null ? [] : g), n == null || n(d, g, "selectOption");
    },
    multipleRenderOption: (d, g, h) => {
      const D = Xr(g, !0);
      return i(
        d,
        D,
        h,
        r
      );
    }
  };
}
function mp({
  children: t,
  showFilters: o,
  allSelected: n,
  someSelected: r,
  handleSelectAll: a = () => {
  },
  ...s
}, i) {
  return /* @__PURE__ */ z("ul", { ref: i, ...s, children: [
    o && /* @__PURE__ */ u(
      Qr,
      {
        areAllSelected: !!n,
        areAnySelected: !!r,
        selectAll: a
      }
    ),
    t
  ] });
}
const ta = ze(mp);
function bp({
  newItemLabel: t,
  newItemIcon: o,
  getOptionLabel: n = Zr,
  multiple: r,
  disableCloseOnSelect: a,
  disabled: s,
  loading: i,
  showFilters: l,
  options: c = [],
  value: p,
  onChange: m,
  ...f
}, d) {
  const { freeSolo: g = !0, ...h } = f, {
    multipleValue: D,
    allSelected: y,
    someSelected: x,
    handleSelectAll: v,
    handleChange: P
  } = ea({
    options: c,
    value: p,
    onChange: m
  }), {
    creatableFilterOptions: T,
    creatableOptionLabel: S,
    creatableRenderOption: k
  } = fp({
    getOptionLabel: n,
    newItemLabel: t,
    newItemIcon: o,
    multiple: r
  });
  return /* @__PURE__ */ u(
    wo,
    {
      ...h,
      ref: d,
      options: c,
      value: r ? D : p,
      onChange: P,
      filterOptions: T,
      getOptionLabel: S,
      renderOption: k,
      freeSolo: g,
      forcePopupIcon: !0,
      multiple: r,
      disableCloseOnSelect: a || r,
      ListboxComponent: r ? ta : void 0,
      ListboxProps: r ? {
        showFilters: l,
        allSelected: y,
        someSelected: x,
        handleSelectAll: v
      } : void 0,
      disabled: s || i,
      popupIcon: i ? /* @__PURE__ */ u(pt, { size: 18, color: "inherit" }) : /* @__PURE__ */ u(Fo, {})
    }
  );
}
const nm = ze(bp);
function hp({
  renderOption: t,
  disableCloseOnSelect: o = !0,
  disabled: n,
  loading: r,
  showFilters: a,
  options: s,
  value: i,
  onChange: l,
  getOptionLabel: c,
  ...p
}, m) {
  const {
    multipleValue: f,
    allSelected: d,
    someSelected: g,
    handleSelectAll: h,
    handleChange: D,
    multipleRenderOption: y
  } = ea({
    options: s,
    value: i,
    onChange: l,
    getOptionLabel: c
  });
  return /* @__PURE__ */ u(
    wo,
    {
      ...p,
      ref: m,
      options: s,
      value: f,
      onChange: D,
      getOptionLabel: c,
      renderOption: t ?? y,
      ListboxComponent: ta,
      ListboxProps: {
        showFilters: a,
        allSelected: d,
        someSelected: g,
        handleSelectAll: h
      },
      multiple: !0,
      disableCloseOnSelect: o,
      disabled: n || r,
      popupIcon: r ? /* @__PURE__ */ u(pt, { size: 18, color: "inherit" }) : /* @__PURE__ */ u(Fo, {})
    }
  );
}
const rm = ze(hp), gp = K("div", {
  shouldForwardProp: (t) => t !== "variant"
})(({ variant: t, theme: o }) => ({
  width: "100%",
  borderRadius: o.spacing(0.5),
  ...t === "outlined" && {
    backgroundColor: o.palette.background.paper,
    boxShadow: `inset 0 0 0 1px ${o.palette.divider}`
  }
}));
function am({
  variant: t = "standard",
  items: o,
  ...n
}) {
  return /* @__PURE__ */ u(gp, { ...n, variant: t, children: o.map((r, a) => /* @__PURE__ */ z(
    xa,
    {
      disabled: r.disabled,
      defaultExpanded: r.defaultExpanded,
      onChange: r.onChange,
      children: [
        /* @__PURE__ */ u(
          Pa,
          {
            "aria-controls": `${a}-content`,
            id: `${a}-header`,
            children: r.summary
          }
        ),
        /* @__PURE__ */ u(Sa, { children: r.content })
      ]
    },
    a
  )) });
}
const wn = {
  large: 5,
  medium: 4,
  small: 3,
  xsmall: 2.25
}, yp = K(ka, {
  shouldForwardProp: (t) => t !== "size" && t !== "disabled"
})(({ theme: t, size: o = "medium", disabled: n = !1 }) => ({
  width: t.spacing(wn[o]),
  height: t.spacing(wn[o]),
  ...t.typography.subtitle1,
  ...o === "large" && {
    ...t.typography.h6
  },
  ...o === "small" && {
    ...t.typography.caption,
    fontWeight: 500
  },
  ...o === "xsmall" && {
    ...t.typography.caption,
    fontWeight: 500,
    svg: {
      width: Tt,
      height: Tt
    }
  },
  ...n && {
    opacity: 0.6
  }
}));
function sm(t) {
  return /* @__PURE__ */ u(yp, { ...t });
}
const oa = 480, Dp = K(Ra)(({ theme: t }) => ({
  bottom: t.spacing(2),
  right: t.spacing(2),
  left: t.spacing(2),
  [t.breakpoints.up("sm")]: {
    bottom: t.spacing(4),
    right: "auto",
    left: "50%",
    width: "100%",
    maxWidth: `${oa}px`
  }
})), Cp = K(fe, {
  shouldForwardProp: (t) => t !== "autoWidth"
})(({ autoWidth: t, theme: o }) => ({
  minWidth: "100%",
  maxWidth: `${oa}px`,
  margin: o.spacing(0, 1),
  ...t && {
    minWidth: "auto"
  },
  [o.breakpoints.up("sm")]: {
    minWidth: o.spacing(40),
    ...t && {
      minWidth: "auto"
    }
  }
})), vp = K(jn, {
  shouldForwardProp: (t) => !["hasActions", "closeable"].includes(t)
})(({ hasActions: t, closeable: o, icon: n, theme: r }) => ({
  position: "relative",
  display: "flex",
  flexWrap: "wrap",
  columnGap: r.spacing(1),
  rowGap: r.spacing(0.25),
  padding: r.spacing(1),
  paddingLeft: r.spacing(2),
  color: r.palette.common.white,
  backgroundColor: r.palette.common.black,
  ".MuiAlert-message": {
    padding: r.spacing(0.75, 0)
  },
  ".MuiAlert-message .MuiTypography-root, .MuiAlert-icon": {
    color: r.palette.common.white
  },
  ".MuiAlert-message .MuiTypography-root:not(.MuiAlertTitle-root)": {
    ...r.typography.body2
  },
  ".MuiAlert-message .MuiCircularProgress-circle": {
    color: r.palette.common.white
  },
  ".MuiAlert-icon": {
    position: "absolute",
    top: r.spacing(1),
    left: r.spacing(1.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: r.spacing(3),
    marginTop: r.spacing(0.5)
  },
  "&.MuiAlert-standardError": {
    backgroundColor: r.palette.error.main
  },
  ...n !== !1 && {
    paddingLeft: r.spacing(5.5)
  },
  ...o && {
    paddingRight: r.spacing(6)
  },
  ...!o && !t && {
    paddingRight: r.spacing(1.5)
  },
  ...t && {
    ".MuiAlert-message": {
      minWidth: "fit-content",
      padding: r.spacing(0.75, 0)
    }
  }
})), wp = K(fe)(({ theme: t }) => ({
  position: "absolute",
  top: t.spacing(1),
  right: t.spacing(1),
  "& button:hover, & button:focus-visible": {
    backgroundColor: t.palette.white[8]
  },
  svg: {
    color: t.palette.white[60]
  }
}));
function im({
  severity: t = "neutral",
  autoHideDuration: o = sn,
  closeable: n = !0,
  children: r,
  title: a,
  action: s,
  open: i,
  onClose: l = () => {
  },
  autoWidth: c,
  icon: p,
  ...m
}) {
  const f = je(), d = $e(f);
  return /* @__PURE__ */ u(Ma, { children: /* @__PURE__ */ u(
    Dp,
    {
      ...m,
      open: i,
      autoHideDuration: o === null ? null : o || sn,
      onClose: l,
      TransitionComponent: c ? Oa : En,
      "data-auto-width": c,
      children: /* @__PURE__ */ z(
        Cp,
        {
          sx: {
            position: "relative"
          },
          autoWidth: c,
          children: [
            /* @__PURE__ */ u(
              vp,
              {
                severity: t,
                action: s,
                icon: p === !1 || t === "neutral" && !p ? !1 : p,
                elevation: 6,
                hasActions: !!s,
                closeable: n,
                title: a,
                children: r
              }
            ),
            n && /* @__PURE__ */ u(wp, { children: /* @__PURE__ */ u(
              Qd,
              {
                color: "default",
                onClick: (x) => l(x, "timeout"),
                icon: /* @__PURE__ */ u($n, {}),
                tooltip: d.formatMessage({
                  id: "c4r.button.close"
                })
              }
            ) })
          ]
        }
      )
    }
  ) });
}
const Tp = K("div")(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  height: Ua,
  marginRight: t.spacing(1.5)
})), xp = K(We)(({ theme: t }) => ({
  marginRight: t.spacing(1),
  "&.MuiButtonBase-root svg path": {
    fill: t.palette.brand.appBarContrastText
  }
})), Pp = K(kt)(({ theme: t }) => ({
  borderColor: Fa(t.palette.brand.appBarContrastText, 0.12)
}));
function Sp({
  onClickMenu: t
}) {
  return (
    // replacing deprecated `<Hidden />` with sx following this MUI5 guide:
    // https://mui.com/material-ui/migration/v5-component-changes/#hidden
    /* @__PURE__ */ u(
      fe,
      {
        sx: {
          display: { md: "none", xs: "block" }
        },
        children: /* @__PURE__ */ z(Tp, { children: [
          /* @__PURE__ */ u(xp, { onClick: t, children: /* @__PURE__ */ u(Qa, {}) }),
          /* @__PURE__ */ u(Pp, { orientation: "vertical", flexItem: !0 })
        ] })
      }
    )
  );
}
const kp = K("div")(({ theme: t }) => ({
  display: "flex",
  marginRight: t.spacing(1.5),
  "& a": {
    display: "flex"
  },
  "& svg, & img": {
    width: t.spacing(4),
    height: t.spacing(4)
  }
}));
function Rp({ logo: t }) {
  return /* @__PURE__ */ u(kp, { children: t });
}
const Mp = K(Re)({
  display: "flex",
  alignItems: "center",
  whiteSpace: "nowrap"
});
function Op({ text: t }) {
  const o = Bt();
  return /* @__PURE__ */ u(
    Mp,
    {
      component: "span",
      variant: "subtitle1",
      color: o.palette.brand.appBarContrastText,
      children: t
    }
  );
}
const Fp = K(Re)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  "&::before": {
    content: '"/"',
    margin: t.spacing(0, 1),
    opacity: 0.6,
    color: t.palette.brand.appBarContrastText
  }
}));
function Ip({ text: t }) {
  const o = Bt();
  return /* @__PURE__ */ u(
    Fp,
    {
      component: "span",
      variant: "body2",
      weight: "strong",
      color: o.palette.brand.appBarContrastText,
      children: t
    }
  );
}
const Vp = K(Va)(({ theme: t }) => ({
  backgroundColor: t.palette.brand.appBarMain,
  "& .MuiTypography-root": {
    color: t.palette.brand.appBarContrastText
  },
  "& .MuiIconButton-root path": {
    fill: t.palette.brand.appBarContrastText
  }
})), Ap = K("div")(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  maxWidth: "calc(100% - 300px)",
  overflow: "hidden",
  [t.breakpoints.down("sm")]: {
    minWidth: "192px"
  }
})), Ep = K("div")(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flex: 1,
  marginLeft: t.spacing(1)
}));
function lm({
  children: t,
  brandLogo: o,
  brandText: n,
  secondaryText: r,
  showBurgerMenu: a = !1,
  onClickMenu: s,
  ...i
}) {
  return /* @__PURE__ */ u(Vp, { ...i, children: /* @__PURE__ */ z(Ia, { children: [
    /* @__PURE__ */ z(Ap, { children: [
      a && /* @__PURE__ */ u(Sp, { onClickMenu: s }),
      o && /* @__PURE__ */ u(Rp, { logo: o }),
      n && /* @__PURE__ */ u(Op, { text: n }),
      r && /* @__PURE__ */ u(Ip, { text: r })
    ] }),
    /* @__PURE__ */ u(Ep, { children: t })
  ] }) });
}
const Lp = K(fe, {
  shouldForwardProp: (t) => !["size", "variant"].includes(t)
})(({ size: t, variant: o, theme: n }) => ({
  position: "absolute",
  right: n.spacing(5.75),
  ...t === "small" && {
    right: n.spacing(4),
    top: "3px"
    // to align with design specs
  },
  ...o === "standard" && {
    right: n.spacing(4.75),
    ...t === "small" && {
      right: n.spacing(3.5)
    }
  }
}));
function Xo({
  size: t,
  variant: o,
  ...n
}) {
  const r = je(), a = $e(r);
  return /* @__PURE__ */ u(Lp, { size: t, variant: o, children: /* @__PURE__ */ u(
    We,
    {
      ...n,
      size: t,
      "aria-label": a.formatMessage({
        id: "c4r.form.clearSelection"
      })
    }
  ) });
}
const $p = K(fe, {
  shouldForwardProp: (t) => !["size", "variant", "readOnly"].includes(t)
})(({ size: t, variant: o, readOnly: n, theme: r }) => ({
  // There is no specific slot to change TextField styles at DatePicker level, so we need to wrap our component to isolate this override. https://mui.com/x/react-date-pickers/date-picker/#customization
  ".MuiInputBase-root": {
    "& .clearButton svg": {
      color: r.palette.text.hint
    },
    ...t === "small" && {
      paddingRight: `${r.spacing(1)} !important`
    },
    ...t === "medium" && {
      "& .MuiInputAdornment-root": {
        "& .MuiIconButton-edgeEnd": {
          marginRight: r.spacing(-1)
        }
      }
    },
    ...o === "standard" && {
      paddingRight: `${r.spacing(1)} !important`,
      ...t === "small" && {
        paddingRight: `${r.spacing(0.5)} !important`
      }
    },
    ...n && {
      "& .MuiInputAdornment-root": {
        "& svg": {
          color: r.palette.text.disabled
        }
      }
    }
  }
}));
function Jo({
  children: t,
  size: o,
  variant: n,
  readOnly: r,
  ...a
}) {
  return /* @__PURE__ */ u($p, { ...a, size: o, variant: n, readOnly: r, children: t });
}
function Tn({
  handleClear: t,
  variant: o = "outlined",
  size: n = "small",
  label: r,
  labelHelpTooltip: a,
  type: s,
  helperText: i,
  placeholder: l,
  slotProps: c,
  slots: p,
  error: m,
  showCalendar: f = !0,
  readOnly: d,
  ...g
}) {
  const h = je(), D = $e(h);
  return (
    // Don't remove className, it's used for styling
    /* @__PURE__ */ u(fe, { className: "CartoDatePicker-root", "data-testid": "date-picker", children: /* @__PURE__ */ u(Jo, { size: n, variant: o, readOnly: d, children: /* @__PURE__ */ u(
      Er,
      {
        ...g,
        label: r && /* @__PURE__ */ u(
          Zo,
          {
            label: r,
            type: s,
            icon: a && /* @__PURE__ */ u(Je, { title: a, children: /* @__PURE__ */ u(To, { htmlColor: "text.secondary" }) })
          }
        ),
        slotProps: {
          // https://mui.com/x/api/date-pickers/date-picker/#slots
          textField: {
            variant: o,
            helperText: i,
            placeholder: l,
            size: n,
            error: m ?? void 0,
            // undefined is needed to allow the component to control the error state for the default validation
            inputProps: {
              "data-testid": "date-picker-input"
            }
          },
          field: {
            clearable: !!t,
            onClear: t
          },
          ...c
        },
        slots: {
          clearButton: (y) => /* @__PURE__ */ u(Xo, { ...y, size: n, variant: o }),
          openPickerButton: (y) => /* @__PURE__ */ u(
            We,
            {
              ...y,
              size: n,
              "aria-label": D.formatMessage({
                id: "c4r.form.chooseDate"
              })
            }
          ),
          ...p
        },
        disableOpenPicker: !f,
        readOnly: d
      }
    ) }) })
  );
}
const jp = K(fe, {
  shouldForwardProp: (t) => ![
    "isSelected",
    "isStartDate",
    "isEndDate",
    "isSelectedMonth",
    "isLastDay",
    "isFirstDay"
  ].includes(t)
})(
  ({
    theme: t,
    isSelected: o,
    isStartDate: n,
    isEndDate: r,
    isSelectedMonth: a,
    isLastDay: s,
    isFirstDay: i
  }) => ({
    position: "relative",
    margin: t.spacing(0.25),
    "& .MuiPickersDay-root": {
      margin: 0
    },
    // Highlight the selected date range
    ...o && a && {
      // Creates a continuous background color between start and end date
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        right: "-2px",
        bottom: 0,
        left: "-2px",
        backgroundColor: t.palette.primary.background,
        // Selected start date OR first day of the month
        ...(n || i) && {
          left: 0,
          borderRadius: `${t.shape.borderRadius}px 0 0 ${t.shape.borderRadius}px`
        },
        // Selected end date OR last day of the month
        ...(r || s) && {
          right: 0,
          borderRadius: `0 ${t.shape.borderRadius}px ${t.shape.borderRadius}px 0`
        }
      },
      // First selected day
      "&:first-of-type::before": {
        left: 0,
        borderRadius: `${t.shape.borderRadius}px 0 0 ${t.shape.borderRadius}px`
      },
      // Last selected day
      "&:last-of-type::before": {
        right: 0,
        borderRadius: `0 ${t.shape.borderRadius}px ${t.shape.borderRadius}px 0`
      },
      // First day of month and last selected day in a week
      ...i && {
        "&:last-of-type::before": {
          left: 0,
          right: 0,
          borderRadius: t.shape.borderRadius
        }
      },
      // Last day of month and first selected day in a week
      ...s && {
        "&:first-of-type::before": {
          left: 0,
          right: 0,
          borderRadius: t.shape.borderRadius
        }
      },
      "& .MuiPickersDay-today": {
        borderColor: `${t.palette.default.outlinedBorder} !important`,
        ...(n || r) && {
          boxShadow: `0 0 0 1px inset ${t.palette.background.paper}`
        }
      },
      // Always having a solid background color below to avoid color blending
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: t.palette.background.paper,
        borderRadius: t.shape.borderRadius,
        transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
      },
      "&:hover::after": {
        backgroundColor: t.palette.primary.relatedLight
      }
    }
  })
), Bp = K(ar, {
  shouldForwardProp: (t) => t !== "isDateRangeLimit"
})(({ theme: t, isDateRangeLimit: o }) => ({
  "&.MuiPickersDay-root": {
    position: "relative",
    zIndex: 1,
    "&.Mui-selected": {
      color: t.palette.text.primary
    },
    // Is selected date within the range
    ...o && {
      "&.Mui-selected": {
        backgroundColor: `${t.palette.primary.main} !important`,
        color: t.palette.primary.contrastText,
        "&:hover": {
          backgroundColor: `${t.palette.primary.dark} !important`
        }
      }
    }
  }
}));
function xn({
  day: t,
  startDate: o,
  endDate: n,
  selectedMonth: r,
  ...a
}) {
  const s = !!(o && t.getTime() === o.getTime()), i = !!(n && t.getTime() === n.getTime()), l = !!(o && n && t >= o && t <= n), c = t.getDate() === 1, p = t.getDate() === new Date(t.getFullYear(), t.getMonth() + 1, 0).getDate(), m = !!(r && t.getMonth() == r.getMonth());
  return /* @__PURE__ */ u(
    jp,
    {
      isSelected: l,
      isStartDate: s,
      isEndDate: i,
      isSelectedMonth: m,
      isLastDay: p,
      isFirstDay: c,
      children: /* @__PURE__ */ u(
        Bp,
        {
          ...a,
          day: t,
          selected: l || s || i,
          isDateRangeLimit: s || i
        }
      )
    }
  );
}
const Np = K(fe, {
  shouldForwardProp: (t) => !["variant"].includes(t)
})(({ variant: t, theme: o }) => ({
  display: "flex",
  gap: t === "standard" ? o.spacing(1) : "1px",
  "& .CartoDatePicker-root": {
    // Start date field
    "&:first-of-type": {
      ".MuiInputBase-root": {
        borderRadius: o.spacing(0.5, 0, 0, 0.5),
        boxShadow: `1px 0 0 0 ${o.palette.default.outlinedBorder}`,
        ...t === "outlined" && {
          // Remove border from the right side only in its default state. Nested negation selector to target only specific Mui rules, otherwise it would force us to rewrite the state styles.
          "&:not(:hover):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
            borderRightColor: "transparent"
          }
        },
        ...t === "filled" && {
          "&::before, &::after": {
            borderRadius: o.spacing(0.5, 0, 0, 0.5)
          }
        },
        ...t === "standard" && {
          boxShadow: "none",
          borderRadius: 0
        }
      }
    },
    // End date field
    "&:last-of-type": {
      ".MuiInputBase-root": {
        borderRadius: o.spacing(0, 0.5, 0.5, 0),
        ...t === "outlined" && {
          // Remove border from the left side only in its default state
          "&:not(:hover):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
            borderLeftColor: "transparent"
          }
        },
        ...t === "filled" && {
          "&::before, &::after": {
            borderRadius: o.spacing(0, 0.5, 0.5, 0)
          }
        },
        ...t === "standard" && {
          borderRadius: 0
        }
      }
    }
  }
}));
function cm({
  globalHelperText: t,
  error: o,
  variant: n = "outlined",
  startProps: r,
  endProps: a,
  ...s
}) {
  const i = je(), l = $e(i), [c, p] = Oe(!1), [m, f] = Oe(!1), [d, g] = Oe(null), [h, D] = Oe(null), [y, x] = Oe(/* @__PURE__ */ new Date()), v = o ?? (r == null ? void 0 : r.error) ?? (a == null ? void 0 : a.error), P = (w, q) => {
    g(w), r != null && r.onChange && r.onChange(w, q), w && q.validationError === null && !m && q.trigger === null && (f(!1), p(!0));
  }, T = (w, q) => {
    D(w), a != null && a.onChange && a.onChange(w, q);
  }, S = () => {
    f(!0), p(!1), setTimeout(() => {
      x(d ?? /* @__PURE__ */ new Date());
    }, 120);
  }, k = () => {
    f(!1), p(!0), setTimeout(() => {
      x(h ?? d ?? /* @__PURE__ */ new Date());
    }, 120);
  }, M = () => {
    f(!1), p(!0), setTimeout(() => {
      x(h ?? d ?? /* @__PURE__ */ new Date());
    }, 120);
  };
  return /* @__PURE__ */ z(fe, { children: [
    /* @__PURE__ */ z(Np, { variant: n, children: [
      /* @__PURE__ */ u(
        Tn,
        {
          ...s,
          ...r,
          value: (r == null ? void 0 : r.value) ?? d,
          maxDate: h ?? void 0,
          label: (r == null ? void 0 : r.label) ?? l.formatMessage({ id: "c4r.form.startDate" }),
          slotProps: {
            popper: {
              placement: "bottom-start",
              "aria-label": l.formatMessage({
                id: "c4r.form.startDateCalendar"
              })
            },
            ...r == null ? void 0 : r.slotProps
          },
          slots: {
            openPickerIcon: Za,
            day: (w) => /* @__PURE__ */ u(
              xn,
              {
                ...w,
                startDate: d,
                endDate: h,
                selectedMonth: y
              }
            ),
            ...r == null ? void 0 : r.slots
          },
          error: (r == null ? void 0 : r.error) ?? o,
          open: m,
          onChange: P,
          onOpen: S,
          onClose: k,
          onMonthChange: (w) => x(w),
          variant: n
        }
      ),
      /* @__PURE__ */ u(
        Tn,
        {
          ...s,
          ...a,
          value: (a == null ? void 0 : a.value) ?? h,
          minDate: d ?? void 0,
          slotProps: {
            popper: {
              "aria-label": l.formatMessage({
                id: "c4r.form.endDateCalendar"
              })
            },
            ...a == null ? void 0 : a.slotProps
          },
          slots: {
            day: (w) => /* @__PURE__ */ u(
              xn,
              {
                ...w,
                startDate: d,
                endDate: h,
                selectedMonth: y
              }
            ),
            ...a == null ? void 0 : a.slots
          },
          label: (a == null ? void 0 : a.label) ?? l.formatMessage({ id: "c4r.form.endDate" }),
          error: (a == null ? void 0 : a.error) ?? o,
          open: c,
          onOpen: M,
          onClose: () => p(!1),
          onChange: T,
          onMonthChange: (w) => x(w),
          variant: n
        }
      )
    ] }),
    t && /* @__PURE__ */ u(Vn, { error: v, children: t })
  ] });
}
const na = (t, o, n, r) => {
  const a = t == null ? void 0 : t.includes("hours"), s = t == null ? void 0 : t.includes("seconds"), i = t == null ? void 0 : t.includes("minutes"), l = (t == null ? void 0 : t.length) === 1 && t[0] === "hours";
  if (r) return r;
  const c = [];
  return o && c.push("MM/dd/yyyy "), a && c.push(n ? "hh" : "HH"), l || c.push(":"), i && c.push("mm"), s && c.push(":ss"), n && c.push(" a"), c.join("");
};
function um({
  handleClear: t,
  variant: o = "outlined",
  size: n = "small",
  label: r,
  labelHelpTooltip: a,
  type: s,
  helperText: i,
  placeholder: l,
  error: c,
  showClock: p = !0,
  readOnly: m,
  slotProps: f,
  slots: d,
  ampm: g = !0,
  views: h = ["hours", "minutes"],
  format: D,
  ...y
}) {
  const x = je(), v = $e(x), P = Do(null), [T, S] = Oe(0);
  return ct(() => {
    if (!P.current) return;
    const k = new ResizeObserver((M) => {
      var q;
      const w = (q = M[0]) == null ? void 0 : q.contentRect.width;
      w && S(w);
    });
    return k.observe(P.current), () => {
      k.disconnect();
    };
  }, []), /* @__PURE__ */ u(
    Jo,
    {
      size: n,
      variant: o,
      readOnly: m,
      "data-testid": "time-picker",
      children: /* @__PURE__ */ u(
        Wr,
        {
          ...y,
          ref: P,
          label: /* @__PURE__ */ u(
            Zo,
            {
              label: r ?? v.formatMessage({ id: "c4r.form.time" }),
              type: s,
              icon: a && /* @__PURE__ */ u(Je, { title: a, children: /* @__PURE__ */ u(To, { htmlColor: "text.secondary" }) })
            }
          ),
          views: ["hours"],
          format: na(h, !1, g, D),
          slotProps: {
            textField: {
              variant: o,
              helperText: i,
              placeholder: l,
              size: n,
              error: c ?? void 0,
              // undefined is needed to allow the component to control the error state for the default validation
              inputProps: {
                "data-testid": "time-picker-input"
              }
            },
            field: {
              clearable: !!t,
              onClear: t
            },
            popper: {
              placement: "bottom-end"
            },
            layout: {
              sx: {
                width: T
              }
            },
            ...f
          },
          slots: {
            clearButton: (k) => /* @__PURE__ */ u(Xo, { ...k, size: n, variant: o }),
            openPickerButton: (k) => /* @__PURE__ */ u(
              We,
              {
                ...k,
                size: n,
                "aria-label": v.formatMessage({
                  id: "c4r.form.chooseDate"
                })
              }
            ),
            ...d
          },
          disableOpenPicker: !p,
          readOnly: m,
          ampm: g
        }
      )
    }
  );
}
function dm({
  handleClear: t,
  variant: o = "outlined",
  size: n = "small",
  label: r,
  labelHelpTooltip: a,
  type: s,
  helperText: i,
  placeholder: l,
  error: c,
  showCalendar: p = !0,
  readOnly: m,
  slotProps: f,
  slots: d,
  ampm: g = !0,
  views: h = ["hours", "minutes"],
  format: D,
  ...y
}) {
  const x = je(), v = $e(x);
  return /* @__PURE__ */ u(
    Jo,
    {
      size: n,
      variant: o,
      readOnly: m,
      "data-testid": "date-time-picker",
      children: /* @__PURE__ */ u(
        Gr,
        {
          ...y,
          label: /* @__PURE__ */ u(
            Zo,
            {
              label: r ?? v.formatMessage({ id: "c4r.form.time" }),
              type: s,
              icon: a && /* @__PURE__ */ u(Je, { title: a, children: /* @__PURE__ */ u(To, { htmlColor: "text.secondary" }) })
            }
          ),
          views: ["year", "month", "day", "hours"],
          format: na(h, !0, g, D),
          slotProps: {
            textField: {
              variant: o,
              helperText: i,
              placeholder: l,
              size: n,
              error: c ?? void 0,
              // undefined is needed to allow the component to control the error state for the default validation
              inputProps: {
                "data-testid": "date-time-picker-input"
              }
            },
            field: {
              clearable: !!t,
              onClear: t
            },
            ...f
          },
          slots: {
            clearButton: (P) => /* @__PURE__ */ u(Xo, { ...P, size: n, variant: o }),
            openPickerButton: (P) => /* @__PURE__ */ u(
              We,
              {
                ...P,
                size: n,
                "aria-label": v.formatMessage({
                  id: "c4r.form.chooseDate"
                })
              }
            ),
            ...d
          },
          disableOpenPicker: !p,
          readOnly: m,
          ampm: g
        }
      )
    }
  );
}
const qp = [{ outlinedBullet: !1, value: "" }], Wp = K("ul")(({ theme: t }) => ({
  listStyle: "none",
  paddingLeft: 0,
  margin: t.spacing(0.5, 0, 0, 0)
})), _p = K("li")(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "&:not(:last-child)": {
    marginBottom: t.spacing(0.5)
  }
})), Hp = K("span")(({ theme: t }) => ({
  width: t.spacing(1),
  height: t.spacing(1),
  marginRight: t.spacing(0.5),
  border: `2px solid ${t.palette.qualitative.bold[1]}`,
  borderRadius: "50%",
  backgroundColor: t.palette.qualitative.bold[1]
})), zp = K(Re)(({ theme: t }) => ({
  minWidth: t.spacing(10),
  marginRight: t.spacing(1.5)
}));
function pm({
  items: t = qp,
  title: o
}) {
  return /* @__PURE__ */ z(Ot, { children: [
    o && /* @__PURE__ */ u(Re, { color: "inherit", variant: "caption", weight: "medium", children: o }),
    /* @__PURE__ */ u(Wp, { children: t.map((n, r) => /* @__PURE__ */ z(_p, { children: [
      /* @__PURE__ */ u(
        Hp,
        {
          style: {
            backgroundColor: `${n.outlinedBullet ? "transparent" : n.color}`,
            borderColor: n.color
          }
        }
      ),
      n.category && /* @__PURE__ */ u(zp, { color: "inherit", variant: "caption", children: n.category }),
      /* @__PURE__ */ u(Re, { color: "inherit", variant: "caption", weight: "medium", children: n.value })
    ] }, r)) })
  ] });
}
const Pn = {
  small: "480px",
  medium: "640px",
  large: "640px",
  xlarge: "720px"
}, Sn = {
  small: {
    width: "432px",
    maxWidth: "432px"
  },
  medium: {
    width: "592px",
    maxWidth: "592px"
  },
  large: {
    width: "768px",
    maxWidth: "768px",
    minHeight: "576px"
  },
  xlarge: {
    width: "calc(100vw - 80px)",
    height: "calc(100vh - 80px)",
    maxWidth: "960px"
  }
}, kn = K(Aa, {
  shouldForwardProp: (t) => !["fullScreen", "height", "width", "hasForm"].includes(t)
})(
  ({
    fullScreen: t,
    height: o,
    width: n,
    hasForm: r,
    size: a = "small",
    theme: s
  }) => ({
    "&.MuiPaper-root": {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      margin: s.spacing(5),
      borderRadius: s.spacing(1),
      ...Sn[a],
      maxHeight: Pn[a],
      [`@media (max-height:${Pn[a]})`]: {
        maxHeight: "calc(100vh - 80px)",
        ...a === "large" && {
          minHeight: o !== "auto" ? "calc(100vh - 80px)" : "auto"
        }
      },
      ...t && {
        width: "100vw",
        maxWidth: `calc(100vw - ${s.spacing(10)})`,
        height: "100vh",
        maxHeight: `calc(100vh - ${s.spacing(10)})`,
        margin: s.spacing(5),
        borderRadius: s.spacing(1)
      },
      ...o && {
        height: o,
        minHeight: o
      },
      ...n && {
        width: n
      },
      [s.breakpoints.down("sm")]: {
        position: "absolute",
        width: "100%",
        maxWidth: "100%",
        height: "100vh",
        maxHeight: "100vh",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 0,
        borderRadius: 0,
        ...o && {
          top: "auto",
          borderRadius: s.spacing(1, 1, 0, 0),
          height: o,
          minHeight: o
        }
      },
      // Special case for Dialogs wrapped in Form
      ...r && {
        maxHeight: `calc(100vh - ${s.spacing(10)})`,
        form: {
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflow: "hidden",
          ...Sn[a],
          maxWidth: "100%",
          ...t && {
            width: "100%",
            maxWidth: "100%",
            height: "100%",
            maxHeight: "100%"
          },
          ...o && {
            height: o,
            minHeight: o
          },
          ...n && {
            width: n
          },
          [s.breakpoints.down("sm")]: {
            width: "100%",
            maxWidth: "100%",
            height: "100vh",
            maxHeight: "100vh",
            ...o && {
              top: "auto",
              borderRadius: s.spacing(1, 1, 0, 0),
              height: o,
              minHeight: o
            }
          }
        }
      }
    }
  })
);
function fm({
  nonModal: t,
  children: o,
  size: n = "small",
  PaperProps: r,
  fullScreen: a,
  height: s,
  width: i,
  hasForm: l,
  "aria-label": c,
  "data-testid": p,
  ...m
}) {
  return t ? /* @__PURE__ */ u(
    kn,
    {
      size: n,
      fullScreen: a,
      height: s,
      width: i,
      hasForm: l,
      "aria-label": c,
      "data-testid": p,
      ...m,
      children: o
    }
  ) : /* @__PURE__ */ u(
    Ea,
    {
      PaperComponent: kn,
      PaperProps: {
        ...r,
        size: n,
        fullScreen: a,
        height: s,
        width: i,
        hasForm: l
      },
      fullScreen: a,
      role: "section",
      "aria-label": c,
      "data-testid": p,
      "data-size": n,
      "data-width": i,
      "data-height": s,
      ...m,
      children: o
    }
  );
}
const Up = K(La)(() => ({
  padding: 0,
  zIndex: 10
})), Yp = K(fe)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: t.spacing(2),
  minHeight: t.spacing(8)
})), Rn = K(fe)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  gap: t.spacing(1),
  overflow: "hidden"
})), Kp = K($n)(({ theme: t }) => ({
  color: t.palette.text.secondary
})), Gp = K(kt)(() => ({
  "+ .MuiDialogContent-root": {
    borderTop: "none !important"
  }
}));
function mm({
  title: t,
  chipLabel: o,
  chipProps: n,
  children: r,
  onClose: a,
  secondaryActions: s,
  "aria-label": i,
  closeIcon: l,
  ...c
}) {
  const p = je(), m = $e(p);
  return /* @__PURE__ */ z(Ot, { children: [
    /* @__PURE__ */ z(Up, { component: "div", ...c, children: [
      /* @__PURE__ */ z(Yp, { children: [
        /* @__PURE__ */ z(Rn, { flex: 1, maxWidth: 0.8, children: [
          /* @__PURE__ */ u(
            Re,
            {
              component: "h2",
              variant: "inherit",
              noWrap: !0,
              "aria-label": i,
              children: t
            }
          ),
          o && /* @__PURE__ */ u($a, { color: "default", label: o, ...n })
        ] }),
        /* @__PURE__ */ z(Rn, { children: [
          s,
          a && /* @__PURE__ */ u(
            Je,
            {
              title: m.formatMessage({ id: "c4r.button.close" }),
              placement: "left",
              children: /* @__PURE__ */ u(We, { onClick: a, children: l || /* @__PURE__ */ u(Kp, { "data-testid": "CloseIcon" }) })
            }
          )
        ] })
      ] }),
      r
    ] }),
    r && /* @__PURE__ */ u(Gp, {})
  ] });
}
const Qp = K(ja, {
  shouldForwardProp: (t) => !["scrollableContent", "withGutter", "withBottomGutter"].includes(t)
})(({ theme: t, scrollableContent: o, withGutter: n, withBottomGutter: r }) => ({
  display: "flex",
  flexDirection: "column",
  gap: t.spacing(3),
  padding: 0,
  ...t.typography.body2,
  color: t.palette.text.secondary,
  ".MuiAlert-root": {
    minHeight: "auto"
  },
  ...o && {
    borderBottom: `1px solid ${t.palette.divider}`,
    "+ .MuiDivider-root": {
      display: "none"
    }
  },
  ...n && {
    padding: ` ${t.spacing(1, 2, 0)} !important`,
    ".MuiDialog-paperFullScreen &": {
      padding: `${t.spacing(2, 2, 0)} !important`
    }
  },
  ...r && {
    paddingBottom: `${t.spacing(3)} !important`,
    ".MuiDialog-paperFullScreen &": {
      paddingBottom: `${t.spacing(3)} !important`
    }
  }
}));
function Zp({
  children: t,
  scrollableContent: o,
  hasFooterAlert: n,
  withGutter: r = !0,
  withBottomGutter: a = !0,
  onScroll: s,
  ...i
}, l) {
  const c = Bt(), [p, m] = Oe(null);
  ma(
    l,
    () => p,
    [p]
  );
  const f = nn(
    (g) => {
      const h = Math.abs(g.scrollHeight - g.clientHeight - g.scrollTop) < 1, D = g.scrollTop === 0, y = `1px solid ${c.palette.divider}`;
      g.style.borderTop = D ? "none" : y, g.style.borderBottom = h && !n ? "none" : y;
    },
    [c.palette.divider, n]
  ), d = nn(
    (g) => {
      f(g.target), s == null || s(g);
    },
    [f, s]
  );
  return ct(() => {
    p && f(p);
  }, [p, f]), ct(() => {
    if (!p || typeof ResizeObserver > "u") return;
    const g = new ResizeObserver(() => {
      f(p);
    });
    return g.observe(p), () => g.disconnect();
  }, [p, f]), /* @__PURE__ */ u(
    Qp,
    {
      ref: m,
      onScroll: d,
      scrollableContent: o,
      withGutter: r,
      withBottomGutter: a && r,
      ...i,
      children: t
    }
  );
}
const Xp = ze(Zp), bm = K(Xp, {
  shouldForwardProp: (t) => t !== "withAlert"
})(({ withAlert: t, theme: o }) => ({
  padding: `${o.spacing(0, 2)} !important`,
  ...t && {
    paddingBottom: `${o.spacing(3)} !important`
  }
})), Jp = K(jn)(({ theme: t }) => ({
  minHeight: "auto",
  padding: 0,
  backgroundColor: "transparent",
  "& .MuiTypography-root": {
    color: t.palette.text.secondary,
    a: {
      color: t.palette.primary.main
    }
  },
  "& .MuiAlertTitle-root": {
    color: t.palette.text.primary
  }
}));
function ra({
  children: t,
  severity: o = "neutral",
  ...n
}) {
  return /* @__PURE__ */ u(Jp, { severity: o, ...n, children: t });
}
const ef = K(fe, {
  shouldForwardProp: (t) => !["dark", "hasChildren"].includes(t)
})(({ dark: t, hasChildren: o, theme: n }) => ({
  flex: "0 0 auto",
  display: "block",
  minHeight: o ? n.spacing(8) : "auto",
  zIndex: 10,
  ...t && {
    backgroundColor: n.palette.common.black,
    color: n.palette.white[60],
    ".MuiAlert-root": {
      ".MuiTypography-root, .MuiAlert-message :not(.MuiAlertTitle-root)": {
        color: n.palette.white[60],
        a: {
          color: `${n.palette.secondary.main} !important`
        }
      },
      ".MuiAlert-icon": {
        color: n.palette.white[60]
      }
    }
  }
})), tf = K(fe)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& > div:empty": {
    padding: 0
  }
})), of = K(fe, {
  shouldForwardProp: (t) => t !== "hasAlert"
})(({ hasAlert: t, theme: o }) => ({
  display: "flex",
  alignItems: "center",
  gap: o.spacing(1),
  padding: o.spacing(2),
  paddingTop: t ? 0 : o.spacing(2)
})), aa = K(Ba, {
  shouldForwardProp: (t) => t !== "hasAlert"
})(({ hasAlert: t, theme: o }) => ({
  gap: o.spacing(1),
  padding: o.spacing(2),
  paddingTop: t ? 0 : o.spacing(2),
  margin: 0,
  ".MuiButton-root + .MuiButton-root": {
    marginLeft: 0
  }
})), nf = K(kt)(() => ({
  // To prevent double border in the top when content is scrollable
  marginTop: "-1px"
}));
function hm({
  children: t,
  secondaryActions: o,
  alertContent: n,
  alertProps: r,
  dark: a,
  topContent: s,
  ...i
}) {
  return /* @__PURE__ */ z(Ot, { children: [
    s,
    !!n && /* @__PURE__ */ u(nf, {}),
    /* @__PURE__ */ z(
      ef,
      {
        ...i,
        dark: a,
        "data-theme": a ? "dark" : "light",
        hasChildren: !!t,
        children: [
          !!n && /* @__PURE__ */ u(fe, { sx: { p: 2, pt: 1.5, pb: 1 }, children: /* @__PURE__ */ u(ra, { ...r, children: n }) }),
          /* @__PURE__ */ z(tf, { children: [
            /* @__PURE__ */ u(of, { hasAlert: !!n, children: o }),
            /* @__PURE__ */ u(aa, { hasAlert: !!n, children: t })
          ] })
        ]
      }
    )
  ] });
}
const rf = K(fe)(({ theme: t }) => ({
  position: "absolute",
  width: "100%",
  zIndex: 100,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  overflow: "hidden",
  display: "flex",
  boxSizing: "border-box",
  alignItems: "flex-end",
  background: t.palette.white[60]
})), af = K("div")(() => ({
  width: "100%"
})), sf = K(fe)(({ theme: t }) => ({
  width: "100%",
  padding: t.spacing(1.5, 2, 2),
  backgroundColor: t.palette.background.paper,
  borderTop: `1px solid ${t.palette.divider}`,
  ".MuiDialogActions-root": {
    padding: 0,
    marginTop: t.spacing(1)
  }
}));
function gm({
  children: t,
  onClickAway: o,
  actions: n,
  severity: r = "warning",
  opened: a,
  "data-testid": s,
  "aria-label": i,
  ...l
}) {
  const c = Do(null), p = Bt();
  return /* @__PURE__ */ u(
    rf,
    {
      ref: c,
      "data-testid": s,
      "aria-label": i,
      role: "presentation",
      children: /* @__PURE__ */ u(Ks, { onClickAway: () => {
        o && o();
      }, children: /* @__PURE__ */ u(
        En,
        {
          direction: "up",
          in: a,
          container: c.current,
          mountOnEnter: !0,
          unmountOnExit: !0,
          easing: p.transitions.easing.easeOut,
          timeout: 350,
          children: /* @__PURE__ */ u(af, { children: /* @__PURE__ */ z(sf, { children: [
            /* @__PURE__ */ u(ra, { severity: r, ...l, children: t }),
            /* @__PURE__ */ u(aa, { children: n })
          ] }) })
        }
      ) })
    }
  );
}
const lf = K(fe)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: t.spacing(8),
  marginBottom: t.spacing(2),
  "& > div": {
    flex: 1
  }
})), cf = K(fe)(({ theme: t }) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  "&:before, &:after": {
    content: '""',
    background: t.palette.divider,
    position: "absolute",
    top: t.spacing(1.25),
    height: t.spacing(0.25),
    width: `calc(50% - ${t.spacing(2.5)})`
  },
  "&:before": {
    left: 0
  },
  "&:after": {
    right: 0
  },
  "&:first-of-type:before": {
    content: "none"
  },
  "&:last-of-type:after": {
    content: "none"
  }
}));
function uf({
  theme: t,
  completed: o,
  current: n
}) {
  return o ? {
    background: t.palette.success.main,
    borderColor: t.palette.success.main,
    color: t.palette.common.white
  } : n ? {
    background: t.palette.text.primary,
    borderColor: t.palette.text.primary,
    color: t.palette.common.white
  } : {
    borderColor: t.palette.text.secondary,
    color: t.palette.text.secondary
  };
}
const df = K("span", {
  shouldForwardProp: (t) => t !== "completed" && t !== "current"
})(({ theme: t, completed: o, current: n }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: t.spacing(3),
  width: t.spacing(3),
  marginBottom: t.spacing(1),
  borderRadius: "50%",
  border: `${t.spacing(0.25)} solid currentColor`,
  ...t.typography.caption,
  ...uf({ theme: t, completed: o, current: n })
}));
function ym({
  currentStep: t,
  stepsLabels: o,
  ...n
}) {
  return /* @__PURE__ */ u(lf, { ...n, children: /* @__PURE__ */ u(fe, { sx: { display: "flex" }, children: o.map((r, a) => {
    const s = a + 1, i = s === t, l = s < t;
    return /* @__PURE__ */ z(
      cf,
      {
        "data-state": l ? "completed" : i ? "current" : "uncompleted",
        children: [
          /* @__PURE__ */ u(df, { completed: l, current: i, children: l ? /* @__PURE__ */ u(Xa, { fontSize: "small", "aria-label": "Completed step" }) : s }),
          /* @__PURE__ */ u(Re, { variant: "caption", component: "div", color: l ? "success.main" : i ? "textPrimary" : "textSecondary", children: r })
        ]
      },
      a
    );
  }) }) });
}
export {
  am as AccordionGroup,
  jn as Alert,
  lm as AppBar,
  om as Autocomplete,
  sm as Avatar,
  Gf as Button,
  nm as CreatableAutocomplete,
  Tn as DatePicker,
  cm as DateRangePicker,
  dm as DateTimePicker,
  fm as Dialog,
  aa as DialogActions,
  ra as DialogAlert,
  gm as DialogConfirmation,
  Xp as DialogContent,
  bm as DialogContentPadded,
  hm as DialogFooter,
  mm as DialogHeader,
  kn as DialogPaper,
  ym as DialogStepper,
  Qd as IconButton,
  Zo as LabelWithIndicator,
  Xf as Menu,
  Qr as MenuFilter,
  Gn as MenuItem,
  Jf as MenuList,
  rm as MultipleAutocomplete,
  em as MultipleSelectField,
  Qf as PasswordField,
  zd as SelectField,
  im as Snackbar,
  vm as TablePaginationActions,
  um as TimePicker,
  Zf as ToggleButtonGroup,
  pm as TooltipData,
  Re as Typography,
  tm as UploadField,
  cp as UploadFieldBase,
  Sn as dialogDimensionsBySize
};
